/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export enum BrowseEntitiesTagsOperator {
  and = "and",
  or = "or",
}


export type searchResults = {
  __typename: "searchResults",
  hits?:  Array<searchHitEntity | null > | null,
  suggest?: string | null,
  took?: number | null,
  total?: number | null,
};

export type searchHitEntity = {
  __typename: "searchHitEntity",
  _id?: string | null,
  _index?: string | null,
  _score?: number | null,
  _source?: SearchHitEntity_source | null,
};

export type SearchHitEntity_source = {
  __typename: "SearchHitEntity_source",
  createdAt?: string | null,
  description?: string | null,
  duration?: number | null,
  enforceEntitlementsAt?: number | null,
  entityType: EntityType,
  id: string,
  images?:  Array<EntityImage | null > | null,
  liveState?: EntityLiveState | null,
  order?: number | null,
  parentId?: string | null,
  publishAt?: string | null,
  redirectId?: string | null,
  requiredEntitlements?: Array< string | null > | null,
  rootEntityId?: string | null,
  startTime?: string | null,
  tags?: Array< string | null > | null,
  title: string,
  updatedAt?: string | null,
  validUntil?: string | null,
  visibility?: EntityVisibility | null,
};

export enum EntityType {
  CHALLENGE = "CHALLENGE",
  CHALLENGE_DAY = "CHALLENGE_DAY",
  CHALLENGE_TASK_ITEM = "CHALLENGE_TASK_ITEM",
  CHALLENGE_TASK_JOURNAL = "CHALLENGE_TASK_JOURNAL",
  CHALLENGE_TASK_SHARE = "CHALLENGE_TASK_SHARE",
  COURSE = "COURSE",
  COURSE_CHAPTER = "COURSE_CHAPTER",
  COURSE_LESSON = "COURSE_LESSON",
  DAILYFIRE = "DAILYFIRE",
  EVENT = "EVENT",
  FEATURED_VIDEO = "FEATURED_VIDEO",
  GROWTH_REC = "GROWTH_REC",
  REPLAY = "REPLAY",
}


export type EntityImage = {
  __typename: "EntityImage",
  height?: number | null,
  imageType: EntityImageType,
  url: string,
  width?: number | null,
};

export enum EntityImageType {
  BACKGROUND = "BACKGROUND",
  BANNER = "BANNER",
  ENDED_BANNER = "ENDED_BANNER",
  ICON = "ICON",
  LANDSCAPE = "LANDSCAPE",
  PORTRAIT = "PORTRAIT",
  REPLAY_BANNER = "REPLAY_BANNER",
  THUMBNAIL = "THUMBNAIL",
  TITLE = "TITLE",
}


export enum EntityLiveState {
  ENDED = "ENDED",
  LIVE = "LIVE",
  ON_DEMAND = "ON_DEMAND",
  REDIRECT = "REDIRECT",
  UPCOMING = "UPCOMING",
}


export enum EntityVisibility {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
  UNLISTED = "UNLISTED",
}


export type ActiveViewSession = {
  __typename: "ActiveViewSession",
  createdAt?: string | null,
  entityId: string,
  heartbeatCount: number,
  id: string,
  owner?: string | null,
  socialProof?: SocialProof | null,
  updatedAt?: string | null,
  userProfile?: UserProfile | null,
  userProfileId: string,
};

export type SocialProof = {
  __typename: "SocialProof",
  commentsCount?: number | null,
  createdAt: string,
  dashboardCardItem?: DashboardCardItem | null,
  dashboardCardItemId?: string | null,
  entity?: Entity | null,
  entityId?: string | null,
  entityLikes?: ModelEntityLikeConnection | null,
  joinCount?: number | null,
  likesCount?: number | null,
  parentId: string,
  parentType?: SocialProofParentType | null,
  rsvpCount?: number | null,
  rsvps?: ModelEventRsvpConnection | null,
  sharesCount?: number | null,
  updatedAt: string,
  version?: number | null,
  viewSessions?: ModelActiveViewSessionConnection | null,
  viewerCount?: number | null,
};

export type DashboardCardItem = {
  __typename: "DashboardCardItem",
  assessmentType?: DashboardCardItemAssessmentType | null,
  createdAt: string,
  customPrompt?: string | null,
  date: string,
  entityHasEntitlements?: boolean | null,
  entityId?: string | null,
  id: string,
  image?: CdnImage | null,
  nonEntitledEntityId?: string | null,
  order: number,
  parent?: DashboardCard | null,
  socialProof?: SocialProof | null,
  type?: DashboardCardItemType | null,
  updatedAt: string,
};

export enum DashboardCardItemAssessmentType {
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
}


export type CdnImage = {
  __typename: "CdnImage",
  cdnId?: string | null,
  height?: number | null,
  url?: string | null,
  width?: number | null,
};

export type DashboardCard = {
  __typename: "DashboardCard",
  children?: ModelDashboardCardItemConnection | null,
  createdAt: string,
  date: string,
  updatedAt: string,
};

export type ModelDashboardCardItemConnection = {
  __typename: "ModelDashboardCardItemConnection",
  items:  Array<DashboardCardItem | null >,
  nextToken?: string | null,
};

export enum DashboardCardItemType {
  CHECKLIST = "CHECKLIST",
  ENTITY = "ENTITY",
  JOURNAL = "JOURNAL",
  LIFESCORE = "LIFESCORE",
}


export type Entity = {
  __typename: "Entity",
  assets?: ModelAssetConnection | null,
  children?: EntityRelations | null,
  createdAt: string,
  description?: string | null,
  duration?: number | null,
  enforceEntitlementsAt?: number | null,
  entityType: EntityType,
  id: string,
  images?:  Array<EntityImage | null > | null,
  liveState?: EntityLiveState | null,
  notificationLogs?: ModelNotificationLogConnection | null,
  order?: number | null,
  parent?: EntityRelations | null,
  parentId?: string | null,
  publishAt?: string | null,
  redirectId?: string | null,
  requiredEntitlements?: Array< string | null > | null,
  rootEntityId?: string | null,
  shareContent?: EntityShareContent | null,
  socialProof?: SocialProof | null,
  startTime?: string | null,
  tags?: Array< string | null > | null,
  title: string,
  updatedAt: string,
  validUntil?: string | null,
  visibility: EntityVisibility,
};

export type ModelAssetConnection = {
  __typename: "ModelAssetConnection",
  items:  Array<Asset | null >,
  nextToken?: string | null,
};

export type Asset = {
  __typename: "Asset",
  assetType: AssetType,
  createdAt: string,
  description?: string | null,
  entity?: Entity | null,
  entityId?: string | null,
  id: string,
  locator: string,
  offering?: Offering | null,
  offeringId?: string | null,
  title?: string | null,
  updatedAt: string,
};

export enum AssetType {
  AUDIO_URL = "AUDIO_URL",
  IMAGE_URL = "IMAGE_URL",
  LIVE_ROOM_URL = "LIVE_ROOM_URL",
  PDF_URL = "PDF_URL",
  VIDEO_URL = "VIDEO_URL",
  VIMEO_ID = "VIMEO_ID",
  WISTIA_ID = "WISTIA_ID",
  YOUTUBE_ID = "YOUTUBE_ID",
}


export type Offering = {
  __typename: "Offering",
  createdAt: string,
  cta?: string | null,
  description?: string | null,
  heading?: string | null,
  id: string,
  image?: CdnImage | null,
  media?: Asset | null,
  offeringStackOfferings?: ModelOfferingStackConnection | null,
  offeringStackOrderBumps?: ModelOfferingStackConnection | null,
  offeringStackUpsellOfferings?: ModelOfferingStackUpsellConnection | null,
  overrides?: OfferingOverrides | null,
  productBundle?: ModelOfferingProductBundleConnection | null,
  products?: ModelOfferingProductConnection | null,
  readableTitle: string,
  redirectUrl?: string | null,
  shortDescription?: string | null,
  showGuarantee?: boolean | null,
  skipEmailCollectionStep?: boolean | null,
  step1Title?: string | null,
  step2Title?: string | null,
  type?: OfferingType | null,
  updatedAt: string,
};

export type ModelOfferingStackConnection = {
  __typename: "ModelOfferingStackConnection",
  items:  Array<OfferingStack | null >,
  nextToken?: string | null,
};

export type OfferingStack = {
  __typename: "OfferingStack",
  campaign?: ModelCampaignConnection | null,
  createdAt: string,
  id: string,
  offering?: Offering | null,
  offeringId: string,
  orderBump?: Offering | null,
  orderBumpId?: string | null,
  readableTitle: string,
  updatedAt: string,
  upsell?: OfferingStackUpsell | null,
};

export type ModelCampaignConnection = {
  __typename: "ModelCampaignConnection",
  items:  Array<Campaign | null >,
  nextToken?: string | null,
};

export type Campaign = {
  __typename: "Campaign",
  createdAt: string,
  id: string,
  isDefault?: boolean | null,
  offeringStack?: OfferingStack | null,
  offeringStackId?: string | null,
  readableTitle: string,
  updatedAt: string,
};

export type OfferingStackUpsell = {
  __typename: "OfferingStackUpsell",
  createdAt: string,
  id: string,
  offering?: Offering | null,
  offeringId: string,
  offeringStack?: OfferingStack | null,
  offeringStackId?: string | null,
  updatedAt: string,
  upsellNo?: OfferingStackUpsell | null,
  upsellNoId?: string | null,
  upsellNoParent?: OfferingStackUpsell | null,
  upsellYes?: OfferingStackUpsell | null,
  upsellYesId?: string | null,
  upsellYesParent?: OfferingStackUpsell | null,
};

export type ModelOfferingStackUpsellConnection = {
  __typename: "ModelOfferingStackUpsellConnection",
  items:  Array<OfferingStackUpsell | null >,
  nextToken?: string | null,
};

export type OfferingOverrides = {
  __typename: "OfferingOverrides",
  skipCreditCard?: boolean | null,
  trialDuration?: number | null,
  trialFrequency?: OfferingOverridesTrialFrequency | null,
};

export enum OfferingOverridesTrialFrequency {
  DAY = "DAY",
  MONTH = "MONTH",
  YEAR = "YEAR",
}


export type ModelOfferingProductBundleConnection = {
  __typename: "ModelOfferingProductBundleConnection",
  items:  Array<OfferingProductBundle | null >,
  nextToken?: string | null,
};

export type OfferingProductBundle = {
  __typename: "OfferingProductBundle",
  createdAt: string,
  id: string,
  offering?: Offering | null,
  offeringId: string,
  overrides?: OfferingOverrides | null,
  product?: Product | null,
  productId: string,
  readableTitle: string,
  updatedAt: string,
};

export type Product = {
  __typename: "Product",
  billingInterval?: ProductBillingInterval | null,
  businessUnit?: ProductBusinessUnit | null,
  createdAt: string,
  description?: string | null,
  entitlements?:  Array<EntitlementCustomType | null > | null,
  id: string,
  name: string,
  offerings?: ModelOfferingProductConnection | null,
  priceId?: string | null,
  productBundle?: ModelOfferingProductBundleConnection | null,
  productCategory?: string | null,
  productId: string,
  productNamespace: string,
  store?: ProductStore | null,
  subscriptionGroup?: ProductSubscriptionGroup | null,
  updatedAt: string,
  userSubscriptions?: ModelUserSubscriptionConnection | null,
  userTransactions?: ModelUserTransactionConnection | null,
};

export enum ProductBillingInterval {
  MONTH = "MONTH",
  ONE_TIME = "ONE_TIME",
  YEAR = "YEAR",
}


export enum ProductBusinessUnit {
  BODI = "BODI",
  GD = "GD",
}


export type EntitlementCustomType = {
  __typename: "EntitlementCustomType",
  identifier: string,
  revenueCatEntitlementId?: string | null,
};

export type ModelOfferingProductConnection = {
  __typename: "ModelOfferingProductConnection",
  items:  Array<OfferingProduct | null >,
  nextToken?: string | null,
};

export type OfferingProduct = {
  __typename: "OfferingProduct",
  createdAt: string,
  id: string,
  offering?: Offering | null,
  offeringId: string,
  product?: Product | null,
  productId: string,
  updatedAt: string,
};

export enum ProductStore {
  APP_STORE = "APP_STORE",
  BODI = "BODI",
  KAJABI = "KAJABI",
  PLAY_STORE = "PLAY_STORE",
  STRIPE_GROWTHDAY = "STRIPE_GROWTHDAY",
  STRIPE_GROWTHDAYINC = "STRIPE_GROWTHDAYINC",
  STRIPE_INFLUENCERPRO = "STRIPE_INFLUENCERPRO",
  STRIPE_INFLUENCERPROCIRCLE = "STRIPE_INFLUENCERPROCIRCLE",
}


export enum ProductSubscriptionGroup {
  MEMBERSHIP_PLANS = "MEMBERSHIP_PLANS",
  NONE = "NONE",
}


export type ModelUserSubscriptionConnection = {
  __typename: "ModelUserSubscriptionConnection",
  items:  Array<UserSubscription | null >,
  nextToken?: string | null,
};

export type UserSubscription = {
  __typename: "UserSubscription",
  createdAt: string,
  expirationDate?: string | null,
  id: string,
  owner?: string | null,
  product?: Product | null,
  productId: string,
  purchaseDate?: string | null,
  renewalDate?: string | null,
  status?: UserSubscriptionStatus | null,
  subscriptionId: string,
  updatedAt: string,
  userTransactions?: ModelUserTransactionConnection | null,
};

export enum UserSubscriptionStatus {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  CANCELLED_TRIAL = "CANCELLED_TRIAL",
  EXPIRED = "EXPIRED",
  EXPIRED_PROMOTIONAL = "EXPIRED_PROMOTIONAL",
  GRACE_PERIOD = "GRACE_PERIOD",
  GRACE_PERIOD_TRIAL = "GRACE_PERIOD_TRIAL",
  INTRO = "INTRO",
  PAUSED = "PAUSED",
  PROMOTIONAL = "PROMOTIONAL",
  TRIAL = "TRIAL",
}


export type ModelUserTransactionConnection = {
  __typename: "ModelUserTransactionConnection",
  items:  Array<UserTransaction | null >,
  nextToken?: string | null,
};

export type UserTransaction = {
  __typename: "UserTransaction",
  createdAt: string,
  currency?: string | null,
  id: string,
  owner?: string | null,
  price?: number | null,
  product?: Product | null,
  productId: string,
  store: string,
  transactionDate: string,
  type?: UserTransactionType | null,
  updatedAt: string,
  userSubscription?: UserSubscription | null,
  userSubscriptionId?: string | null,
};

export enum UserTransactionType {
  CANCELLATION = "CANCELLATION",
  INITIAL_PURCHASE = "INITIAL_PURCHASE",
  RENEWAL = "RENEWAL",
}


export enum OfferingType {
  CHALLENGE = "CHALLENGE",
  COURSE = "COURSE",
  DAILYFIRE = "DAILYFIRE",
  EVENT = "EVENT",
  FEATURED_VIDEO = "FEATURED_VIDEO",
  GIFT = "GIFT",
  TEAM = "TEAM",
}


export type EntityRelations = {
  __typename: "EntityRelations",
  childId: string,
  createdAt: string,
  entities?: ModelEntityConnection | null,
  entity?: Entity | null,
  id: string,
  updatedAt: string,
};

export type ModelEntityConnection = {
  __typename: "ModelEntityConnection",
  items:  Array<Entity | null >,
  nextToken?: string | null,
};

export type ModelNotificationLogConnection = {
  __typename: "ModelNotificationLogConnection",
  items:  Array<NotificationLog | null >,
  nextToken?: string | null,
};

export type NotificationLog = {
  __typename: "NotificationLog",
  challengeDayProgressId?: string | null,
  createdAt: string,
  entity?: Entity | null,
  entityId?: string | null,
  id: string,
  meetup?: Meetup | null,
  meetupSlugId?: string | null,
  name?: NotificationLogName | null,
  updatedAt: string,
};

export type Meetup = {
  __typename: "Meetup",
  agenda: string,
  author?: UserProfile | null,
  chatRoomId?: string | null,
  createdAt: string,
  duration: number,
  endTime: string,
  hostReferralId?: string | null,
  liveState: MeetupLiveState,
  notificationLogs?: ModelNotificationLogConnection | null,
  owner?: string | null,
  recurrenceId?: string | null,
  recurrenceRule?: string | null,
  roomUrl?: string | null,
  rsvpCount?: number | null,
  rsvps?: ModelEventRsvpConnection | null,
  slugId: string,
  startTime: string,
  thumbnail?: MeetupThumbnail | null,
  title: string,
  updatedAt: string,
  version?: number | null,
  visibility: EntityVisibility,
};

export type UserProfile = {
  __typename: "UserProfile",
  activeViewSessions?: ModelActiveViewSessionConnection | null,
  attributes?: UserAttributes | null,
  badges?: UserProfileBadges | null,
  bio?: string | null,
  certificates?: ModelCourseCertificateConnection | null,
  commentLikes?: ModelCommentLikeConnection | null,
  comments?: ModelCommentConnection | null,
  cover?: CdnImage | null,
  createdAt?: string | null,
  displayName?: string | null,
  entityLikes?: ModelEntityLikeConnection | null,
  experimentMetadata?: UserProfileExperimentMetadata | null,
  leaderboards?: ModelLeaderboardConnection | null,
  meetups?: ModelMeetupConnection | null,
  messages?: ModelMessageConnection | null,
  notifications?: ModelAppNotificationConnection | null,
  owner: string,
  profileImage?: CdnImage | null,
  publicProfileId: string,
  rsvps?: ModelEventRsvpConnection | null,
  socialMediaLinks?: SocialMediaLinks | null,
  totalCoinsCount?: number | null,
  updatedAt: string,
};

export type ModelActiveViewSessionConnection = {
  __typename: "ModelActiveViewSessionConnection",
  items:  Array<ActiveViewSession | null >,
  nextToken?: string | null,
};

export type UserAttributes = {
  __typename: "UserAttributes",
  intents?: Array< string | null > | null,
  surveyCustCategory?: UserAttributesSurveyCustCategory | null,
  surveyInterests?: Array< string | null > | null,
};

export enum UserAttributesSurveyCustCategory {
  EMPLOYEE = "EMPLOYEE",
  ENTREPRENEUR = "ENTREPRENEUR",
  EXECUTIVE = "EXECUTIVE",
  OTHER = "OTHER",
  STUDENT = "STUDENT",
}


export type UserProfileBadges = {
  __typename: "UserProfileBadges",
  chpc?: boolean | null,
  growthday?: boolean | null,
  ultra?: boolean | null,
};

export type ModelCourseCertificateConnection = {
  __typename: "ModelCourseCertificateConnection",
  items:  Array<CourseCertificate | null >,
  nextToken?: string | null,
};

export type CourseCertificate = {
  __typename: "CourseCertificate",
  createdAt?: string | null,
  entityId: string,
  image: CdnImage,
  owner: string,
  updatedAt: string,
  userProfile?: UserProfile | null,
  userProfileId: string,
};

export type ModelCommentLikeConnection = {
  __typename: "ModelCommentLikeConnection",
  items:  Array<CommentLike | null >,
  nextToken?: string | null,
};

export type CommentLike = {
  __typename: "CommentLike",
  comment?: Comment | null,
  commentId: string,
  createdAt: string,
  id: string,
  owner?: string | null,
  threadId: string,
  updatedAt: string,
  userProfile?: UserProfile | null,
  userProfileId: string,
};

export type Comment = {
  __typename: "Comment",
  author?: UserProfile | null,
  commentsCount?: number | null,
  content: string,
  createdAt?: string | null,
  id: string,
  images?:  Array<CdnImage | null > | null,
  isEdited?: boolean | null,
  likes?: ModelCommentLikeConnection | null,
  likesCount?: number | null,
  owner?: string | null,
  parent?: Comment | null,
  parentId: string,
  parentType?: CommentParentType | null,
  pinnedState?: CommentPinnedState | null,
  replies?: ModelCommentConnection | null,
  threadId: string,
  type?: CommentType | null,
  updatedAt: string,
  version?: number | null,
  visibility: CommentVisibility,
};

export enum CommentParentType {
  CHECKLIST = "CHECKLIST",
  COMMENT = "COMMENT",
  COMMUNITY_CHAT = "COMMUNITY_CHAT",
  DASHBOARD_CARD = "DASHBOARD_CARD",
  ENTITY = "ENTITY",
  JOURNAL = "JOURNAL",
}


export enum CommentPinnedState {
  PINNED = "PINNED",
  UNPINNED = "UNPINNED",
}


export type ModelCommentConnection = {
  __typename: "ModelCommentConnection",
  items:  Array<Comment | null >,
  nextToken?: string | null,
};

export enum CommentType {
  COMMENT = "COMMENT",
  REPLY = "REPLY",
}


export enum CommentVisibility {
  HIDDEN = "HIDDEN",
  VISIBLE = "VISIBLE",
}


export type ModelEntityLikeConnection = {
  __typename: "ModelEntityLikeConnection",
  items:  Array<EntityLike | null >,
  nextToken?: string | null,
};

export type EntityLike = {
  __typename: "EntityLike",
  createdAt: string,
  entityId: string,
  id: string,
  owner?: string | null,
  socialProof?: SocialProof | null,
  updatedAt: string,
  userProfile?: UserProfile | null,
  userProfileId: string,
};

export type UserProfileExperimentMetadata = {
  __typename: "UserProfileExperimentMetadata",
  mozartUser?: boolean | null,
};

export type ModelLeaderboardConnection = {
  __typename: "ModelLeaderboardConnection",
  items:  Array<Leaderboard | null >,
  nextToken?: string | null,
};

export type Leaderboard = {
  __typename: "Leaderboard",
  createdAt: string,
  dashboardStreaks?: ModelLeaderboardDashboardStreakConnection | null,
  highestStreakCount: number,
  highestStreakCountAndTotalCoinsCount: string,
  month: string,
  owner: string,
  profile?: UserProfile | null,
  ranking?: number | null,
  totalCoinsCount: number,
  totalLeadsCount?: number | null,
  totalReferralsCount: number,
  totalReferralsCountAndTotalLeadsCount?: string | null,
  totalStreaksCount: number,
  updatedAt: string,
  userProfileId: string,
};

export type ModelLeaderboardDashboardStreakConnection = {
  __typename: "ModelLeaderboardDashboardStreakConnection",
  items:  Array<LeaderboardDashboardStreak | null >,
  nextToken?: string | null,
};

export type LeaderboardDashboardStreak = {
  __typename: "LeaderboardDashboardStreak",
  createdAt: string,
  dashboardStreak?: DashboardStreak | null,
  dashboardStreakId: string,
  id: string,
  leaderboard?: Leaderboard | null,
  month: string,
  owner: string,
  updatedAt: string,
};

export type DashboardStreak = {
  __typename: "DashboardStreak",
  count: number,
  createdAt: string,
  id: string,
  lastActiveDate: string,
  leaderboards?: ModelLeaderboardDashboardStreakConnection | null,
  owner: string,
  startDate: string,
  updatedAt: string,
};

export type ModelMeetupConnection = {
  __typename: "ModelMeetupConnection",
  items:  Array<Meetup | null >,
  nextToken?: string | null,
};

export type ModelMessageConnection = {
  __typename: "ModelMessageConnection",
  items:  Array<Message | null >,
  nextToken?: string | null,
};

export type Message = {
  __typename: "Message",
  author?: UserProfile | null,
  content: string,
  createdAt?: string | null,
  id: string,
  isEdited?: boolean | null,
  mediaPosition: number,
  metadata?: string | null,
  owner?: string | null,
  pinnedState?: MessagePinnedState | null,
  room?: ChatRoom | null,
  roomId: string,
  type: MessageType,
  updatedAt: string,
};

export enum MessagePinnedState {
  PINNED = "PINNED",
  UNPINNED = "UNPINNED",
}


export type ChatRoom = {
  __typename: "ChatRoom",
  bannedUsers?: Array< string | null > | null,
  createdAt?: string | null,
  entityId: string,
  id: string,
  messages?: ModelMessageConnection | null,
  moderators?: Array< string | null > | null,
  updatedAt: string,
};

export enum MessageType {
  REACTION = "REACTION",
  SYSTEM = "SYSTEM",
  TEXT = "TEXT",
}


export type ModelAppNotificationConnection = {
  __typename: "ModelAppNotificationConnection",
  items:  Array<AppNotification | null >,
  nextToken?: string | null,
};

export type AppNotification = {
  __typename: "AppNotification",
  author?: UserProfile | null,
  authorId?: string | null,
  content?: string | null,
  createdAt?: string | null,
  deeplink?: string | null,
  id: string,
  image?: CdnImage | null,
  notificationType: AppNotificationType,
  owner: string,
  sourceId: string,
  sourceType?: AppNotificationSourceType | null,
  status: AppNotificationStatus,
  title: string,
  updatedAt?: string | null,
};

export enum AppNotificationType {
  COMMENT_LIKE = "COMMENT_LIKE",
  COMMENT_REPLY = "COMMENT_REPLY",
  REMINDER = "REMINDER",
}


export enum AppNotificationSourceType {
  CHALLENGE = "CHALLENGE",
  COMMENT = "COMMENT",
  MEETUP = "MEETUP",
}


export enum AppNotificationStatus {
  READ = "READ",
  UNREAD = "UNREAD",
}


export type ModelEventRsvpConnection = {
  __typename: "ModelEventRsvpConnection",
  items:  Array<EventRsvp | null >,
  nextToken?: string | null,
};

export type EventRsvp = {
  __typename: "EventRsvp",
  createdAt?: string | null,
  eventStartTime: string,
  meetup?: Meetup | null,
  meetupId?: string | null,
  owner: string,
  parentId: string,
  parentType?: EventRsvpParentType | null,
  socialProof?: SocialProof | null,
  socialProofId?: string | null,
  updatedAt: string,
  userProfile?: UserProfile | null,
  userProfileId: string,
};

export enum EventRsvpParentType {
  EVENT = "EVENT",
  MEETUP = "MEETUP",
}


export type SocialMediaLinks = {
  __typename: "SocialMediaLinks",
  facebook?: string | null,
  instagram?: string | null,
  linkedin?: string | null,
  website?: string | null,
  x?: string | null,
};

export enum MeetupLiveState {
  CANCELED = "CANCELED",
  ENDED = "ENDED",
  LIVE = "LIVE",
  UPCOMING = "UPCOMING",
}


export type MeetupThumbnail = {
  __typename: "MeetupThumbnail",
  height?: number | null,
  url: string,
  width?: number | null,
};

export enum NotificationLogName {
  CHALLENGE_REMINDER = "CHALLENGE_REMINDER",
  EVENT_15_MIN_REMINDER = "EVENT_15_MIN_REMINDER",
  EVENT_1_HOUR_REMINDER = "EVENT_1_HOUR_REMINDER",
  MEETUP_15_MIN_REMINDER = "MEETUP_15_MIN_REMINDER",
  MEETUP_1_HOUR_REMINDER = "MEETUP_1_HOUR_REMINDER",
}


export type EntityShareContent = {
  __typename: "EntityShareContent",
  description?: string | null,
  images?:  Array<EntityImage | null > | null,
  title?: string | null,
};

export enum SocialProofParentType {
  DASHBOARD_CARD = "DASHBOARD_CARD",
  ENTITY = "ENTITY",
}


export type Bookmark = {
  __typename: "Bookmark",
  createdAt?: string | null,
  entityType?: string | null,
  owner: string,
  parentId: string,
  parentType: string,
  updatedAt: string,
};

export type ChallengeProgress = {
  __typename: "ChallengeProgress",
  children?:  Array<ChallengeDayProgress | null > | null,
  coinsEarned?: number | null,
  completeTime?: string | null,
  createdAt: string,
  endTime: string,
  entityId: string,
  id: string,
  owner?: string | null,
  startTime: string,
  type?: string | null,
  updatedAt: string,
};

export type ChallengeDayProgress = {
  __typename: "ChallengeDayProgress",
  children?:  Array<ChallengeTaskProgress | null > | null,
  coinsEarned?: number | null,
  completeTime?: string | null,
  entityId: string,
  id: string,
  startTime: string,
};

export type ChallengeTaskProgress = {
  __typename: "ChallengeTaskProgress",
  completeTime?: string | null,
  entityId: string,
  id: string,
};

export type Checklist = {
  __typename: "Checklist",
  completed?: boolean | null,
  createdAt: string,
  date: string,
  items?:  Array<ItemCompletion | null > | null,
  owner: string,
  started?: boolean | null,
  updatedAt: string,
};

export type ItemCompletion = {
  __typename: "ItemCompletion",
  completed?: boolean | null,
  deleted?: boolean | null,
  itemId?: string | null,
  order?: number | null,
};

export type ChecklistItem = {
  __typename: "ChecklistItem",
  createdAt: string,
  date: string,
  endDate?: string | null,
  frequency: ItemFrequency,
  id: string,
  order?: number | null,
  owner: string,
  title: string,
  updatedAt: string,
  weekday: DayOfWeek,
};

export enum ItemFrequency {
  DAILY = "DAILY",
  NONE = "NONE",
  WEEKLY = "WEEKLY",
}


export enum DayOfWeek {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  NONE = "NONE",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}


export enum GetCommunityFeedFeedType {
  FYP = "FYP",
  LATEST = "LATEST",
}


export type CommunityFeedResponse = {
  __typename: "CommunityFeedResponse",
  interactionId?: string | null,
  items?:  Array<CommunityItem | null > | null,
  nextToken?: string | null,
};

export type CommunityItem = {
  __typename: "CommunityItem",
  authorId?: string | null,
  commentId: string,
  commentsCount?: number | null,
  content?: string | null,
  createdAt?: string | null,
  dashboardCardInfo?: CommunityItemDashboardCardInfo | null,
  displayName?: string | null,
  entityInfo?: CommunityItemEntityInfo | null,
  images?:  Array<CdnImage | null > | null,
  isEdited?: boolean | null,
  likesCount?: number | null,
  parentId?: string | null,
  parentType?: CommunityItemParentType | null,
  pinnedState?: CommunityItemPinnedState | null,
  profileImage?: CdnImage | null,
};

export type CommunityItemDashboardCardInfo = {
  __typename: "CommunityItemDashboardCardInfo",
  assessmentType?: CommunityItemDashboardCardInfoAssessmentType | null,
  customPrompt?: string | null,
  date?: string | null,
  image?: CdnImage | null,
  type?: CommunityItemDashboardCardInfoType | null,
};

export enum CommunityItemDashboardCardInfoAssessmentType {
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
}


export enum CommunityItemDashboardCardInfoType {
  CHECKLIST = "CHECKLIST",
  ENTITY = "ENTITY",
  JOURNAL = "JOURNAL",
  LIFESCORE = "LIFESCORE",
}


export type CommunityItemEntityInfo = {
  __typename: "CommunityItemEntityInfo",
  description?: string | null,
  duration?: number | null,
  entityId?: string | null,
  entityType?: string | null,
  images?:  Array<EntityImage | null > | null,
  liveState?: EntityLiveState | null,
  rootEntityId?: string | null,
  startTime?: string | null,
  title?: string | null,
};

export enum CommunityItemParentType {
  CHECKLIST = "CHECKLIST",
  COMMENT = "COMMENT",
  COMMUNITY_CHAT = "COMMUNITY_CHAT",
  DASHBOARD_CARD = "DASHBOARD_CARD",
  ENTITY = "ENTITY",
  JOURNAL = "JOURNAL",
}


export enum CommunityItemPinnedState {
  PINNED = "PINNED",
  UNPINNED = "UNPINNED",
}


export type DailyLifescore = {
  __typename: "DailyLifescore",
  averageScorePercentage: number,
  clarityScore: number,
  courageScore: number,
  createdAt?: string | null,
  energyScore: number,
  id: string,
  influenceScore: number,
  moodScore: number,
  movementScore: number,
  necessityScore: number,
  nutritionScore: number,
  owner?: string | null,
  parentId?: string | null,
  productivityScore: number,
  sleepScore: number,
  updatedAt: string,
};

export type DashboardProgress = {
  __typename: "DashboardProgress",
  children?:  Array<DashboardProgressItem > | null,
  completeTime?: string | null,
  createdAt: string,
  date: string,
  owner: string,
  updatedAt: string,
};

export type DashboardProgressItem = {
  __typename: "DashboardProgressItem",
  completeTime?: string | null,
  parentId: string,
  upsellRejected?: boolean | null,
};

export type GetDelphiJWTReturnType = {
  __typename: "GetDelphiJWTReturnType",
  token?: string | null,
};

export type RevenueCatEntitlementResponse = {
  __typename: "RevenueCatEntitlementResponse",
  requestDate: string,
  subscriber: RevenueCatSubscriber,
};

export type RevenueCatSubscriber = {
  __typename: "RevenueCatSubscriber",
  entitlements?: string | null,
  firstSeen?: string | null,
  managementUrl?: string | null,
  nonSubscriptions?: string | null,
  originalAppUserId?: string | null,
  originalApplicationVersion?: string | null,
  originalPurchaseDate?: string | null,
  otherPurchases?: string | null,
  subscriptions?: string | null,
};

export type GiftRecipient = {
  __typename: "GiftRecipient",
  buyerId: string,
  createdAt?: string | null,
  email?: string | null,
  firstName?: string | null,
  id: string,
  lastName?: string | null,
  owner: string,
  stripePriceId?: string | null,
  subscriptionId?: string | null,
  updatedAt: string,
};

export type GrowthCoinStats = {
  __typename: "GrowthCoinStats",
  createdAt: string,
  currentMonth: string,
  monthCoins: number,
  owner: string,
  source: string,
  sourceEvent: string,
  totalCoins: number,
  updatedAt: string,
  version?: number | null,
};

export type GrowthCoinTransaction = {
  __typename: "GrowthCoinTransaction",
  coinsAdded: number,
  createdAt?: string | null,
  endBalance: number,
  id: string,
  owner?: string | null,
  source: GrowthCoinTransactionSource,
  sourceEvent: GrowthCoinTransactionSourceEvent,
  startBalance: number,
  updatedAt: string,
};

export enum GrowthCoinTransactionSource {
  CHALLENGE = "CHALLENGE",
  COURSE = "COURSE",
  CUSTOM = "CUSTOM",
  DASHBOARD = "DASHBOARD",
  FEEDBACK = "FEEDBACK",
  JOURNAL = "JOURNAL",
  LEGACY_PROFILE = "LEGACY_PROFILE",
  LIFESCORE = "LIFESCORE",
  LIVE_EVENT = "LIVE_EVENT",
  MEETUP = "MEETUP",
  REFERRAL = "REFERRAL",
}


export enum GrowthCoinTransactionSourceEvent {
  CHALLENGE_COMPLETED = "CHALLENGE_COMPLETED",
  CHALLENGE_TASK_COMPLETED = "CHALLENGE_TASK_COMPLETED",
  COURSE_VIDEO_LESSON_COMPLETED = "COURSE_VIDEO_LESSON_COMPLETED",
  CUSTOM = "CUSTOM",
  DAILY_LIFESCORE_ASSESSMENT_COMPLETED = "DAILY_LIFESCORE_ASSESSMENT_COMPLETED",
  FEEDBACK_REPORTED = "FEEDBACK_REPORTED",
  GROWTH_LOOP_COMPLETED = "GROWTH_LOOP_COMPLETED",
  ISSUE_REPORTED = "ISSUE_REPORTED",
  JOURNAL_CREATED = "JOURNAL_CREATED",
  LEGACY_CHALLENGE_ALL_TASKS_COMPLETED_ON_TIME = "LEGACY_CHALLENGE_ALL_TASKS_COMPLETED_ON_TIME",
  LEGACY_CHALLENGE_REGISTERED = "LEGACY_CHALLENGE_REGISTERED",
  LEGACY_DAILY_HABIT_DELETED = "LEGACY_DAILY_HABIT_DELETED",
  LEGACY_DAILY_JOURNAL_DELETED = "LEGACY_DAILY_JOURNAL_DELETED",
  LEGACY_LIVE_EVENT_FIRST_COMPLETED = "LEGACY_LIVE_EVENT_FIRST_COMPLETED",
  LEGACY_MONTHLY_LIFE_ASSESSMENT_DELETED = "LEGACY_MONTHLY_LIFE_ASSESSMENT_DELETED",
  LEGACY_TEAM_ASSESSMENT_CREATED = "LEGACY_TEAM_ASSESSMENT_CREATED",
  LEGACY_USER_PROFILE_COMPLETION = "LEGACY_USER_PROFILE_COMPLETION",
  LEGACY_WEEKLY_ASSESSMENT_CREATED = "LEGACY_WEEKLY_ASSESSMENT_CREATED",
  LEGACY_WEEKLY_ASSESSMENT_DELETED = "LEGACY_WEEKLY_ASSESSMENT_DELETED",
  LIFESCORE_ACHIEVEMENT = "LIFESCORE_ACHIEVEMENT",
  LIVE_EVENT_COMPLETED = "LIVE_EVENT_COMPLETED",
  MEETUP_ATTENDED = "MEETUP_ATTENDED",
  MEETUP_HOSTED = "MEETUP_HOSTED",
  REFERRAL_SIGNUP = "REFERRAL_SIGNUP",
  WHOLE_LIFE_FIRST_LIFESCORE_ASSESSMENT_COMPLETED = "WHOLE_LIFE_FIRST_LIFESCORE_ASSESSMENT_COMPLETED",
  WHOLE_LIFE_LIFESCORE_ASSESSMENT_COMPLETED = "WHOLE_LIFE_LIFESCORE_ASSESSMENT_COMPLETED",
}


export type Journal = {
  __typename: "Journal",
  createdAt: string,
  customPrompts?: Array< string | null > | null,
  datetime: string,
  id: string,
  images?:  Array<JournalImage | null > | null,
  journalType: JournalType,
  owner?: string | null,
  parentId?: string | null,
  responses?: Array< string | null > | null,
  updatedAt: string,
};

export type JournalImage = {
  __typename: "JournalImage",
  height?: number | null,
  s3Key: string,
  width?: number | null,
};

export enum JournalType {
  CUSTOM = "CUSTOM",
  EVENING_REVIEW = "EVENING_REVIEW",
  GROWTH_PROMPT = "GROWTH_PROMPT",
  MONTHLY_REVIEW = "MONTHLY_REVIEW",
  MORNING_MINDSET = "MORNING_MINDSET",
  WEEKLY_REVIEW = "WEEKLY_REVIEW",
}


export type ReferralStats = {
  __typename: "ReferralStats",
  activeCustomersCount: number,
  cancellationsCount: number,
  clicksCount: number,
  customersCount: number,
  earnings: number,
  leadsCount: number,
  paidEarnings: number,
  refundsCount: number,
};

export type MonthlyLifescore = {
  __typename: "MonthlyLifescore",
  averageScorePercentage: number,
  createdAt?: string | null,
  experienceScore: number,
  familyScore: number,
  financeScore: number,
  friendScore: number,
  healthScore: number,
  id: string,
  learningScore: number,
  mentalAndEmotionalScore: number,
  missionScore: number,
  owner?: string | null,
  parentId?: string | null,
  partnerAndLoveScore: number,
  spiritScore: number,
  updatedAt: string,
};

export type Note = {
  __typename: "Note",
  content: string,
  createdAt?: string | null,
  entityId: string,
  entityType?: EntityType | null,
  noteItems?: ModelNoteItemConnection | null,
  owner: string,
  parentId: string,
  parentType?: NoteParentType | null,
  pinnedState?: NotePinnedState | null,
  updatedAt: string,
};

export type ModelNoteItemConnection = {
  __typename: "ModelNoteItemConnection",
  items:  Array<NoteItem | null >,
  nextToken?: string | null,
};

export type NoteItem = {
  __typename: "NoteItem",
  content: string,
  createdAt: string,
  entityId: string,
  entityType?: EntityType | null,
  id: string,
  note?: Note | null,
  noteOwner: string,
  owner?: string | null,
  parentId: string,
  parentType?: NoteItemParentType | null,
  timestamp: number,
  updatedAt: string,
};

export enum NoteItemParentType {
  CHALLENGE_PROGRESS = "CHALLENGE_PROGRESS",
  ENTITY = "ENTITY",
  MEETUP = "MEETUP",
}


export enum NoteParentType {
  CHALLENGE_PROGRESS = "CHALLENGE_PROGRESS",
  ENTITY = "ENTITY",
  MEETUP = "MEETUP",
}


export enum NotePinnedState {
  PINNED = "PINNED",
  UNPINNED = "UNPINNED",
}


export type PaymentMethod = {
  __typename: "PaymentMethod",
  address?: Address | null,
  brand: string,
  expMonth: number,
  expYear: number,
  id: string,
  last4: string,
  name?: string | null,
};

export type Address = {
  __typename: "Address",
  city?: string | null,
  country?: string | null,
  line1?: string | null,
  line2?: string | null,
  state?: string | null,
  zip?: string | null,
};

export type PlaybackMedia = {
  __typename: "PlaybackMedia",
  poster?: string | null,
  src: string,
  thumbPreview?: ThumbPreview | null,
  tracks?:  Array<Track | null > | null,
};

export type ThumbPreview = {
  __typename: "ThumbPreview",
  duration: number,
  frameCount: number,
  frameHeight: number,
  frameWidth: number,
  height: number,
  url: string,
  width: number,
};

export type Track = {
  __typename: "Track",
  content?: string | null,
  isDefault?: boolean | null,
  kind?: string | null,
  label: string,
  lang: string,
  src?: string | null,
  trackType?: string | null,
};

export type RecentlyPlayed = {
  __typename: "RecentlyPlayed",
  children?:  Array<RecentlyPlayedChild | null > | null,
  completeTime?: string | null,
  createdAt: string,
  entityId: string,
  entityType: EntityType,
  id: string,
  images?:  Array<EntityImage | null > | null,
  lastPlayedAt: string,
  owner?: string | null,
  playbackPercentage: number,
  updatedAt: string,
};

export type RecentlyPlayedChild = {
  __typename: "RecentlyPlayedChild",
  completeTime?: string | null,
  entityId?: string | null,
  lastPlayedAt: string,
  playbackPercentage: number,
};

export enum GetRecommendationsRecommenderType {
  BECAUSE_YOU_WATCHED_X = "BECAUSE_YOU_WATCHED_X",
  MORE_LIKE_X = "MORE_LIKE_X",
  MOST_POPULAR = "MOST_POPULAR",
  TOP_PICKS = "TOP_PICKS",
  TRENDING_NOW = "TRENDING_NOW",
}


export type RecommendedResult = {
  __typename: "RecommendedResult",
  items?:  Array<RecommendedItem | null > | null,
  recommendationId?: string | null,
};

export type RecommendedItem = {
  __typename: "RecommendedItem",
  createdAt?: string | null,
  description?: string | null,
  duration?: number | null,
  enforceEntitlementsAt?: number | null,
  entityType: EntityType,
  id: string,
  images?:  Array<EntityImage | null > | null,
  liveState?: EntityLiveState | null,
  order?: number | null,
  parentId?: string | null,
  publishAt?: string | null,
  recommendationId?: string | null,
  redirectId?: string | null,
  requiredEntitlements?: Array< string | null > | null,
  rootEntityId?: string | null,
  startTime?: string | null,
  tags?: Array< string | null > | null,
  title: string,
  updatedAt?: string | null,
  validUntil?: string | null,
  visibility?: EntityVisibility | null,
};

export type ReferralEarningsSummary = {
  __typename: "ReferralEarningsSummary",
  currentMonthEarnings: number,
  nextPayDay: string,
  totalCustomerCount: number,
  totalEarningsPaid: number,
  totalLeadsCount: number,
  totalVisitorCount: number,
  transactions:  Array<ReferralTransactionDetail >,
};

export type ReferralTransactionDetail = {
  __typename: "ReferralTransactionDetail",
  customerCount: number,
  earnings: number,
  leadsCount: number,
  transactionMonth: string,
  visitorCount: number,
};

export type ReferralProfile = {
  __typename: "ReferralProfile",
  activeCustomersCount: number,
  cancellationsCount: number,
  clicksCount: number,
  customersCount: number,
  earnings: number,
  leadsCount: number,
  nextPayDay: string,
  paidEarnings: number,
  paypalEmail?: string | null,
  referralCode: string,
  refundsCount: number,
  remainingBalance: number,
};

export type StripeSubscription = {
  __typename: "StripeSubscription",
  canceledAt?: string | null,
  createdAt?: string | null,
  endedAt?: string | null,
  id: string,
  item: StripePurchaseLineItem,
  periodEnd?: string | null,
  periodStart?: string | null,
  product: ProductCustomType,
  scheduleId?: string | null,
  startDate?: string | null,
  status?: StripeSubscriptionStatus | null,
  trialEnd?: string | null,
  trialStart?: string | null,
  type?: StripeSubscriptionType | null,
};

export type StripePurchaseLineItem = {
  __typename: "StripePurchaseLineItem",
  amount: number,
  currency: string,
  id: string,
  interval?: StripePurchaseLineItemInterval | null,
  name: string,
  priceId: string,
  quantity: number,
};

export enum StripePurchaseLineItemInterval {
  day = "day",
  month = "month",
  one_time = "one_time",
  week = "week",
  year = "year",
}


export type ProductCustomType = {
  __typename: "ProductCustomType",
  billingInterval?: ProductCustomTypeBillingInterval | null,
  businessUnit?: ProductCustomTypeBusinessUnit | null,
  description?: string | null,
  entitlements?:  Array<EntitlementCustomType | null > | null,
  name: string,
  priceId?: string | null,
  productCategory?: string | null,
  productId: string,
  productNamespace: string,
  store?: ProductCustomTypeStore | null,
  subscriptionGroup?: ProductCustomTypeSubscriptionGroup | null,
};

export enum ProductCustomTypeBillingInterval {
  MONTH = "MONTH",
  ONE_TIME = "ONE_TIME",
  YEAR = "YEAR",
}


export enum ProductCustomTypeBusinessUnit {
  BODI = "BODI",
  GD = "GD",
}


export enum ProductCustomTypeStore {
  APP_STORE = "APP_STORE",
  BODI = "BODI",
  KAJABI = "KAJABI",
  PLAY_STORE = "PLAY_STORE",
  STRIPE_GROWTHDAY = "STRIPE_GROWTHDAY",
  STRIPE_GROWTHDAYINC = "STRIPE_GROWTHDAYINC",
  STRIPE_INFLUENCERPRO = "STRIPE_INFLUENCERPRO",
  STRIPE_INFLUENCERPROCIRCLE = "STRIPE_INFLUENCERPROCIRCLE",
}


export enum ProductCustomTypeSubscriptionGroup {
  MEMBERSHIP_PLANS = "MEMBERSHIP_PLANS",
  NONE = "NONE",
}


export enum StripeSubscriptionStatus {
  active = "active",
  canceled = "canceled",
  incomplete = "incomplete",
  incomplete_expired = "incomplete_expired",
  past_due = "past_due",
  paused = "paused",
  trialing = "trialing",
  unpaid = "unpaid",
}


export enum StripeSubscriptionType {
  GIFT_SUBSCRIPTION = "GIFT_SUBSCRIPTION",
  MEMBERSHIP = "MEMBERSHIP",
  NONE = "NONE",
  TEAMS = "TEAMS",
}


export type StripePrice = {
  __typename: "StripePrice",
  amount: number,
  currency: string,
  id: string,
  interval?: StripePriceInterval | null,
  name: string,
  productId: string,
};

export enum StripePriceInterval {
  day = "day",
  month = "month",
  one_time = "one_time",
  week = "week",
  year = "year",
}


export type StripeSubscriptionSchedule = {
  __typename: "StripeSubscriptionSchedule",
  canceledAt?: string | null,
  createdAt?: string | null,
  id: string,
  item: StripePurchaseLineItem,
  periodEnd?: string | null,
  periodStart?: string | null,
  product: ProductCustomType,
  releasedAt?: string | null,
  status?: StripeSubscriptionScheduleStatus | null,
};

export enum StripeSubscriptionScheduleStatus {
  active = "active",
  canceled = "canceled",
  completed = "completed",
  not_started = "not_started",
  released = "released",
}


export type StripeSubscriptionProratedAmount = {
  __typename: "StripeSubscriptionProratedAmount",
  currency?: string | null,
  subTotalInCents?: number | null,
  taxInCents?: number | null,
  totalInCents?: number | null,
};

export type StripeTransactionsResponse = {
  __typename: "StripeTransactionsResponse",
  items:  Array<StripeTransaction | null >,
  nextToken?: string | null,
};

export type StripeTransaction = {
  __typename: "StripeTransaction",
  amount: number,
  currency: string,
  date: string,
  description: string,
  id: string,
  invoicePdfUrl?: string | null,
  lineItems:  Array<StripeTransactionLineItem | null >,
  status?: StripeTransactionStatus | null,
  tax: number,
};

export type StripeTransactionLineItem = {
  __typename: "StripeTransactionLineItem",
  amount: number,
  description: string,
  periodEnd?: string | null,
  periodStart?: string | null,
  priceId?: string | null,
  quantity: number,
  tax: number,
  title: string,
};

export enum StripeTransactionStatus {
  TxDraft = "TxDraft",
  TxOpen = "TxOpen",
  TxPaid = "TxPaid",
  TxUncollectible = "TxUncollectible",
  TxVoid = "TxVoid",
}


export type Team = {
  __typename: "Team",
  createdAt: string,
  id: string,
  invitationState?: TeamInvitationState | null,
  members?: ModelTeamMemberConnection | null,
  owner: string,
  stripePriceId?: string | null,
  stripeProductId?: string | null,
  subscriptionId?: string | null,
  subscriptionItemId?: string | null,
  subscriptionState?: TeamSubscriptionState | null,
  totalSeats?: number | null,
  updatedAt: string,
  usedSeats?: number | null,
  version?: number | null,
};

export enum TeamInvitationState {
  PENDING = "PENDING",
  PROCESSED = "PROCESSED",
}


export type ModelTeamMemberConnection = {
  __typename: "ModelTeamMemberConnection",
  items:  Array<TeamMember | null >,
  nextToken?: string | null,
};

export type TeamMember = {
  __typename: "TeamMember",
  createdAt: string,
  email?: string | null,
  firstName?: string | null,
  id: string,
  lastName?: string | null,
  owner: string,
  subscriptionState?: TeamSubscriptionState | null,
  team?: Team | null,
  teamId: string,
  updatedAt: string,
};

export enum TeamSubscriptionState {
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED",
  INACTIVE = "INACTIVE",
}


export type UserExternalIdentifier = {
  __typename: "UserExternalIdentifier",
  createdAt: string,
  externalIdentifier: string,
  owner: string,
  type?: UserExternalIdentifierType | null,
  updatedAt: string,
};

export enum UserExternalIdentifierType {
  EMAIL = "EMAIL",
  FIRST_PROMOTER = "FIRST_PROMOTER",
  KAJABI = "KAJABI",
  STRIPE_GROWTHDAY = "STRIPE_GROWTHDAY",
  STRIPE_GROWTHDAYINC = "STRIPE_GROWTHDAYINC",
  UUID = "UUID",
}


export type UserTour = {
  __typename: "UserTour",
  completed?: boolean | null,
  completedAt?: string | null,
  createdAt: string,
  id: string,
  owner: string,
  type: UserTourType,
  updatedAt: string,
};

export enum UserTourType {
  ONBOARDING = "ONBOARDING",
}


export type WatchNextResult = {
  __typename: "WatchNextResult",
  items?:  Array<WatchNextItem | null > | null,
};

export type WatchNextItem = {
  __typename: "WatchNextItem",
  description?: string | null,
  id: string,
  images?:  Array<EntityImage | null > | null,
  link: string,
  order?: number | null,
  recommendationId?: string | null,
  source: string,
  tags?: Array< string | null > | null,
  title: string,
};

export type ModelActiveViewSessionFilterInput = {
  and?: Array< ModelActiveViewSessionFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  heartbeatCount?: ModelIntInput | null,
  id?: ModelIDInput | null,
  not?: ModelActiveViewSessionFilterInput | null,
  or?: Array< ModelActiveViewSessionFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userProfileId?: ModelIDInput | null,
};

export type ModelStringInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  _null = "_null",
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
}


export type ModelSizeInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelIDInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: ModelSizeInput | null,
};

export type ModelIntInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelStringKeyConditionInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
};

export type ModelAppNotificationFilterInput = {
  and?: Array< ModelAppNotificationFilterInput | null > | null,
  authorId?: ModelStringInput | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  deeplink?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelAppNotificationFilterInput | null,
  notificationType?: ModelAppNotificationTypeInput | null,
  or?: Array< ModelAppNotificationFilterInput | null > | null,
  owner?: ModelStringInput | null,
  sourceId?: ModelIDInput | null,
  sourceType?: ModelAppNotificationSourceTypeInput | null,
  status?: ModelAppNotificationStatusInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelAppNotificationTypeInput = {
  eq?: AppNotificationType | null,
  ne?: AppNotificationType | null,
};

export type ModelAppNotificationSourceTypeInput = {
  eq?: AppNotificationSourceType | null,
  ne?: AppNotificationSourceType | null,
};

export type ModelAppNotificationStatusInput = {
  eq?: AppNotificationStatus | null,
  ne?: AppNotificationStatus | null,
};

export type ModelAppNotificationAppNotificationsByOwnerAndStatusAndCreatedAtCompositeKeyConditionInput = {
  beginsWith?: ModelAppNotificationAppNotificationsByOwnerAndStatusAndCreatedAtCompositeKeyInput | null,
  between?: Array< ModelAppNotificationAppNotificationsByOwnerAndStatusAndCreatedAtCompositeKeyInput | null > | null,
  eq?: ModelAppNotificationAppNotificationsByOwnerAndStatusAndCreatedAtCompositeKeyInput | null,
  ge?: ModelAppNotificationAppNotificationsByOwnerAndStatusAndCreatedAtCompositeKeyInput | null,
  gt?: ModelAppNotificationAppNotificationsByOwnerAndStatusAndCreatedAtCompositeKeyInput | null,
  le?: ModelAppNotificationAppNotificationsByOwnerAndStatusAndCreatedAtCompositeKeyInput | null,
  lt?: ModelAppNotificationAppNotificationsByOwnerAndStatusAndCreatedAtCompositeKeyInput | null,
};

export type ModelAppNotificationAppNotificationsByOwnerAndStatusAndCreatedAtCompositeKeyInput = {
  createdAt?: string | null,
  status?: AppNotificationStatus | null,
};

export type ModelAssetFilterInput = {
  and?: Array< ModelAssetFilterInput | null > | null,
  assetType?: ModelAssetTypeInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  locator?: ModelStringInput | null,
  not?: ModelAssetFilterInput | null,
  offeringId?: ModelIDInput | null,
  or?: Array< ModelAssetFilterInput | null > | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelAssetTypeInput = {
  eq?: AssetType | null,
  ne?: AssetType | null,
};

export type ModelBookmarkFilterInput = {
  and?: Array< ModelBookmarkFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelBookmarkFilterInput | null,
  or?: Array< ModelBookmarkFilterInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelStringInput | null,
  parentType?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBookmarkConnection = {
  __typename: "ModelBookmarkConnection",
  items:  Array<Bookmark | null >,
  nextToken?: string | null,
};

export type ModelBookmarkBookmarksByOwnerAndParentTypeAndCreatedAtCompositeKeyConditionInput = {
  beginsWith?: ModelBookmarkBookmarksByOwnerAndParentTypeAndCreatedAtCompositeKeyInput | null,
  between?: Array< ModelBookmarkBookmarksByOwnerAndParentTypeAndCreatedAtCompositeKeyInput | null > | null,
  eq?: ModelBookmarkBookmarksByOwnerAndParentTypeAndCreatedAtCompositeKeyInput | null,
  ge?: ModelBookmarkBookmarksByOwnerAndParentTypeAndCreatedAtCompositeKeyInput | null,
  gt?: ModelBookmarkBookmarksByOwnerAndParentTypeAndCreatedAtCompositeKeyInput | null,
  le?: ModelBookmarkBookmarksByOwnerAndParentTypeAndCreatedAtCompositeKeyInput | null,
  lt?: ModelBookmarkBookmarksByOwnerAndParentTypeAndCreatedAtCompositeKeyInput | null,
};

export type ModelBookmarkBookmarksByOwnerAndParentTypeAndCreatedAtCompositeKeyInput = {
  createdAt?: string | null,
  parentType?: string | null,
};

export type ModelBookmarkBookmarksByOwnerAndParentTypeAndEntityTypeAndCreatedAtCompositeKeyConditionInput = {
  beginsWith?: ModelBookmarkBookmarksByOwnerAndParentTypeAndEntityTypeAndCreatedAtCompositeKeyInput | null,
  between?: Array< ModelBookmarkBookmarksByOwnerAndParentTypeAndEntityTypeAndCreatedAtCompositeKeyInput | null > | null,
  eq?: ModelBookmarkBookmarksByOwnerAndParentTypeAndEntityTypeAndCreatedAtCompositeKeyInput | null,
  ge?: ModelBookmarkBookmarksByOwnerAndParentTypeAndEntityTypeAndCreatedAtCompositeKeyInput | null,
  gt?: ModelBookmarkBookmarksByOwnerAndParentTypeAndEntityTypeAndCreatedAtCompositeKeyInput | null,
  le?: ModelBookmarkBookmarksByOwnerAndParentTypeAndEntityTypeAndCreatedAtCompositeKeyInput | null,
  lt?: ModelBookmarkBookmarksByOwnerAndParentTypeAndEntityTypeAndCreatedAtCompositeKeyInput | null,
};

export type ModelBookmarkBookmarksByOwnerAndParentTypeAndEntityTypeAndCreatedAtCompositeKeyInput = {
  createdAt?: string | null,
  entityType?: string | null,
  parentType?: string | null,
};

export type ModelBookmarkPrimaryCompositeKeyConditionInput = {
  beginsWith?: ModelBookmarkPrimaryCompositeKeyInput | null,
  between?: Array< ModelBookmarkPrimaryCompositeKeyInput | null > | null,
  eq?: ModelBookmarkPrimaryCompositeKeyInput | null,
  ge?: ModelBookmarkPrimaryCompositeKeyInput | null,
  gt?: ModelBookmarkPrimaryCompositeKeyInput | null,
  le?: ModelBookmarkPrimaryCompositeKeyInput | null,
  lt?: ModelBookmarkPrimaryCompositeKeyInput | null,
};

export type ModelBookmarkPrimaryCompositeKeyInput = {
  parentId?: string | null,
  parentType?: string | null,
};

export type BookmarkWithParentResults = {
  __typename: "BookmarkWithParentResults",
  data:  Array<BookmarkWithParent >,
  nextToken?: string | null,
};

export type BookmarkWithParent = {
  __typename: "BookmarkWithParent",
  createdAt?: string | null,
  entity?: SearchHitEntity_source | null,
  entityType?: string | null,
  journal?: CustomJournalSource | null,
  owner: string,
  parentId: string,
  parentType: string,
};

export type CustomJournalSource = {
  __typename: "CustomJournalSource",
  customPrompts?: Array< string | null > | null,
  datetime: string,
  id: string,
  images?:  Array<JournalImage | null > | null,
  journalType: JournalType,
  owner: string,
  parentId?: string | null,
  responses?: Array< string | null > | null,
};

export type ModelCampaignFilterInput = {
  and?: Array< ModelCampaignFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  isDefault?: ModelBooleanInput | null,
  not?: ModelCampaignFilterInput | null,
  offeringStackId?: ModelIDInput | null,
  or?: Array< ModelCampaignFilterInput | null > | null,
  readableTitle?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBooleanInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  eq?: boolean | null,
  ne?: boolean | null,
};

export type ModelChallengeProgressFilterInput = {
  and?: Array< ModelChallengeProgressFilterInput | null > | null,
  coinsEarned?: ModelIntInput | null,
  completeTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  not?: ModelChallengeProgressFilterInput | null,
  or?: Array< ModelChallengeProgressFilterInput | null > | null,
  owner?: ModelStringInput | null,
  startTime?: ModelStringInput | null,
  type?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelChallengeProgressConnection = {
  __typename: "ModelChallengeProgressConnection",
  items:  Array<ChallengeProgress | null >,
  nextToken?: string | null,
};

export type ModelChatRoomFilterInput = {
  and?: Array< ModelChatRoomFilterInput | null > | null,
  bannedUsers?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  moderators?: ModelIDInput | null,
  not?: ModelChatRoomFilterInput | null,
  or?: Array< ModelChatRoomFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelChatRoomConnection = {
  __typename: "ModelChatRoomConnection",
  items:  Array<ChatRoom | null >,
  nextToken?: string | null,
};

export type ModelChecklistItemFilterInput = {
  and?: Array< ModelChecklistItemFilterInput | null > | null,
  date?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  frequency?: ModelItemFrequencyInput | null,
  not?: ModelChecklistItemFilterInput | null,
  or?: Array< ModelChecklistItemFilterInput | null > | null,
  order?: ModelIntInput | null,
  owner?: ModelStringInput | null,
  title?: ModelStringInput | null,
  weekday?: ModelDayOfWeekInput | null,
};

export type ModelItemFrequencyInput = {
  eq?: ItemFrequency | null,
  ne?: ItemFrequency | null,
};

export type ModelDayOfWeekInput = {
  eq?: DayOfWeek | null,
  ne?: DayOfWeek | null,
};

export type ModelChecklistItemConnection = {
  __typename: "ModelChecklistItemConnection",
  items:  Array<ChecklistItem | null >,
  nextToken?: string | null,
};

export type ModelChecklistItemChecklistItemsByOwnerAndFrequencyAndWeekdayCompositeKeyConditionInput = {
  beginsWith?: ModelChecklistItemChecklistItemsByOwnerAndFrequencyAndWeekdayCompositeKeyInput | null,
  between?: Array< ModelChecklistItemChecklistItemsByOwnerAndFrequencyAndWeekdayCompositeKeyInput | null > | null,
  eq?: ModelChecklistItemChecklistItemsByOwnerAndFrequencyAndWeekdayCompositeKeyInput | null,
  ge?: ModelChecklistItemChecklistItemsByOwnerAndFrequencyAndWeekdayCompositeKeyInput | null,
  gt?: ModelChecklistItemChecklistItemsByOwnerAndFrequencyAndWeekdayCompositeKeyInput | null,
  le?: ModelChecklistItemChecklistItemsByOwnerAndFrequencyAndWeekdayCompositeKeyInput | null,
  lt?: ModelChecklistItemChecklistItemsByOwnerAndFrequencyAndWeekdayCompositeKeyInput | null,
};

export type ModelChecklistItemChecklistItemsByOwnerAndFrequencyAndWeekdayCompositeKeyInput = {
  frequency?: ItemFrequency | null,
  weekday?: DayOfWeek | null,
};

export type ModelCommentFilterInput = {
  and?: Array< ModelCommentFilterInput | null > | null,
  commentsCount?: ModelIntInput | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  isEdited?: ModelBooleanInput | null,
  likesCount?: ModelIntInput | null,
  not?: ModelCommentFilterInput | null,
  or?: Array< ModelCommentFilterInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  parentType?: ModelCommentParentTypeInput | null,
  pinnedState?: ModelCommentPinnedStateInput | null,
  threadId?: ModelStringInput | null,
  type?: ModelCommentTypeInput | null,
  updatedAt?: ModelStringInput | null,
  version?: ModelIntInput | null,
  visibility?: ModelCommentVisibilityInput | null,
};

export type ModelCommentParentTypeInput = {
  eq?: CommentParentType | null,
  ne?: CommentParentType | null,
};

export type ModelCommentPinnedStateInput = {
  eq?: CommentPinnedState | null,
  ne?: CommentPinnedState | null,
};

export type ModelCommentTypeInput = {
  eq?: CommentType | null,
  ne?: CommentType | null,
};

export type ModelCommentVisibilityInput = {
  eq?: CommentVisibility | null,
  ne?: CommentVisibility | null,
};

export type ModelCommentCommentsByThreadIdAndParentIdAndCreatedAtCompositeKeyConditionInput = {
  beginsWith?: ModelCommentCommentsByThreadIdAndParentIdAndCreatedAtCompositeKeyInput | null,
  between?: Array< ModelCommentCommentsByThreadIdAndParentIdAndCreatedAtCompositeKeyInput | null > | null,
  eq?: ModelCommentCommentsByThreadIdAndParentIdAndCreatedAtCompositeKeyInput | null,
  ge?: ModelCommentCommentsByThreadIdAndParentIdAndCreatedAtCompositeKeyInput | null,
  gt?: ModelCommentCommentsByThreadIdAndParentIdAndCreatedAtCompositeKeyInput | null,
  le?: ModelCommentCommentsByThreadIdAndParentIdAndCreatedAtCompositeKeyInput | null,
  lt?: ModelCommentCommentsByThreadIdAndParentIdAndCreatedAtCompositeKeyInput | null,
};

export type ModelCommentCommentsByThreadIdAndParentIdAndCreatedAtCompositeKeyInput = {
  createdAt?: string | null,
  parentId?: string | null,
};

export type ModelCommentCommentsByThreadIdAndPinnedStateAndCreatedAtCompositeKeyConditionInput = {
  beginsWith?: ModelCommentCommentsByThreadIdAndPinnedStateAndCreatedAtCompositeKeyInput | null,
  between?: Array< ModelCommentCommentsByThreadIdAndPinnedStateAndCreatedAtCompositeKeyInput | null > | null,
  eq?: ModelCommentCommentsByThreadIdAndPinnedStateAndCreatedAtCompositeKeyInput | null,
  ge?: ModelCommentCommentsByThreadIdAndPinnedStateAndCreatedAtCompositeKeyInput | null,
  gt?: ModelCommentCommentsByThreadIdAndPinnedStateAndCreatedAtCompositeKeyInput | null,
  le?: ModelCommentCommentsByThreadIdAndPinnedStateAndCreatedAtCompositeKeyInput | null,
  lt?: ModelCommentCommentsByThreadIdAndPinnedStateAndCreatedAtCompositeKeyInput | null,
};

export type ModelCommentCommentsByThreadIdAndPinnedStateAndCreatedAtCompositeKeyInput = {
  createdAt?: string | null,
  pinnedState?: CommentPinnedState | null,
};

export type ModelCommentLikeFilterInput = {
  and?: Array< ModelCommentLikeFilterInput | null > | null,
  commentId?: ModelIDInput | null,
  not?: ModelCommentLikeFilterInput | null,
  or?: Array< ModelCommentLikeFilterInput | null > | null,
  owner?: ModelStringInput | null,
  threadId?: ModelStringInput | null,
  userProfileId?: ModelIDInput | null,
};

export type ModelIDKeyConditionInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
};

export type ModelCourseCertificateFilterInput = {
  and?: Array< ModelCourseCertificateFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelCourseCertificateFilterInput | null,
  or?: Array< ModelCourseCertificateFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userProfileId?: ModelIDInput | null,
};

export type ModelDailyLifescoreFilterInput = {
  and?: Array< ModelDailyLifescoreFilterInput | null > | null,
  averageScorePercentage?: ModelIntInput | null,
  clarityScore?: ModelIntInput | null,
  courageScore?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  energyScore?: ModelIntInput | null,
  influenceScore?: ModelIntInput | null,
  moodScore?: ModelIntInput | null,
  movementScore?: ModelIntInput | null,
  necessityScore?: ModelIntInput | null,
  not?: ModelDailyLifescoreFilterInput | null,
  nutritionScore?: ModelIntInput | null,
  or?: Array< ModelDailyLifescoreFilterInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelStringInput | null,
  productivityScore?: ModelIntInput | null,
  sleepScore?: ModelIntInput | null,
};

export type ModelDailyLifescoreConnection = {
  __typename: "ModelDailyLifescoreConnection",
  items:  Array<DailyLifescore | null >,
  nextToken?: string | null,
};

export type ModelDashboardCardItemFilterInput = {
  and?: Array< ModelDashboardCardItemFilterInput | null > | null,
  assessmentType?: ModelDashboardCardItemAssessmentTypeInput | null,
  createdAt?: ModelStringInput | null,
  customPrompt?: ModelStringInput | null,
  date?: ModelStringInput | null,
  entityHasEntitlements?: ModelBooleanInput | null,
  entityId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  nonEntitledEntityId?: ModelIDInput | null,
  not?: ModelDashboardCardItemFilterInput | null,
  or?: Array< ModelDashboardCardItemFilterInput | null > | null,
  order?: ModelIntInput | null,
  type?: ModelDashboardCardItemTypeInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelDashboardCardItemAssessmentTypeInput = {
  eq?: DashboardCardItemAssessmentType | null,
  ne?: DashboardCardItemAssessmentType | null,
};

export type ModelDashboardCardItemTypeInput = {
  eq?: DashboardCardItemType | null,
  ne?: DashboardCardItemType | null,
};

export type ModelDashboardCardFilterInput = {
  and?: Array< ModelDashboardCardFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  date?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelDashboardCardFilterInput | null,
  or?: Array< ModelDashboardCardFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelDashboardCardConnection = {
  __typename: "ModelDashboardCardConnection",
  items:  Array<DashboardCard | null >,
  nextToken?: string | null,
};

export type ModelDashboardStreakFilterInput = {
  and?: Array< ModelDashboardStreakFilterInput | null > | null,
  count?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  lastActiveDate?: ModelStringInput | null,
  not?: ModelDashboardStreakFilterInput | null,
  or?: Array< ModelDashboardStreakFilterInput | null > | null,
  owner?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelDashboardStreakConnection = {
  __typename: "ModelDashboardStreakConnection",
  items:  Array<DashboardStreak | null >,
  nextToken?: string | null,
};

export type ModelEntityFilterInput = {
  and?: Array< ModelEntityFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  duration?: ModelFloatInput | null,
  enforceEntitlementsAt?: ModelIntInput | null,
  entityType?: ModelEntityTypeInput | null,
  id?: ModelIDInput | null,
  liveState?: ModelEntityLiveStateInput | null,
  not?: ModelEntityFilterInput | null,
  or?: Array< ModelEntityFilterInput | null > | null,
  order?: ModelIntInput | null,
  parentId?: ModelIDInput | null,
  publishAt?: ModelStringInput | null,
  redirectId?: ModelIDInput | null,
  requiredEntitlements?: ModelStringInput | null,
  rootEntityId?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  validUntil?: ModelStringInput | null,
  visibility?: ModelEntityVisibilityInput | null,
};

export type ModelFloatInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelEntityTypeInput = {
  eq?: EntityType | null,
  ne?: EntityType | null,
};

export type ModelEntityLiveStateInput = {
  eq?: EntityLiveState | null,
  ne?: EntityLiveState | null,
};

export type ModelEntityVisibilityInput = {
  eq?: EntityVisibility | null,
  ne?: EntityVisibility | null,
};

export type ModelEntityLikeFilterInput = {
  and?: Array< ModelEntityLikeFilterInput | null > | null,
  entityId?: ModelIDInput | null,
  not?: ModelEntityLikeFilterInput | null,
  or?: Array< ModelEntityLikeFilterInput | null > | null,
  owner?: ModelStringInput | null,
  userProfileId?: ModelIDInput | null,
};

export type ModelEntityRelationsFilterInput = {
  and?: Array< ModelEntityRelationsFilterInput | null > | null,
  childId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelEntityRelationsFilterInput | null,
  or?: Array< ModelEntityRelationsFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelEntityRelationsConnection = {
  __typename: "ModelEntityRelationsConnection",
  items:  Array<EntityRelations | null >,
  nextToken?: string | null,
};

export type ModelEventRsvpFilterInput = {
  and?: Array< ModelEventRsvpFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  eventStartTime?: ModelStringInput | null,
  meetupId?: ModelIDInput | null,
  not?: ModelEventRsvpFilterInput | null,
  or?: Array< ModelEventRsvpFilterInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  parentType?: ModelEventRsvpParentTypeInput | null,
  socialProofId?: ModelIDInput | null,
  userProfileId?: ModelIDInput | null,
};

export type ModelEventRsvpParentTypeInput = {
  eq?: EventRsvpParentType | null,
  ne?: EventRsvpParentType | null,
};

export type ModelEventRsvpEventRsvpsByOwnerAndParentTypeAndEventStartTimeAndCreatedAtCompositeKeyConditionInput = {
  beginsWith?: ModelEventRsvpEventRsvpsByOwnerAndParentTypeAndEventStartTimeAndCreatedAtCompositeKeyInput | null,
  between?: Array< ModelEventRsvpEventRsvpsByOwnerAndParentTypeAndEventStartTimeAndCreatedAtCompositeKeyInput | null > | null,
  eq?: ModelEventRsvpEventRsvpsByOwnerAndParentTypeAndEventStartTimeAndCreatedAtCompositeKeyInput | null,
  ge?: ModelEventRsvpEventRsvpsByOwnerAndParentTypeAndEventStartTimeAndCreatedAtCompositeKeyInput | null,
  gt?: ModelEventRsvpEventRsvpsByOwnerAndParentTypeAndEventStartTimeAndCreatedAtCompositeKeyInput | null,
  le?: ModelEventRsvpEventRsvpsByOwnerAndParentTypeAndEventStartTimeAndCreatedAtCompositeKeyInput | null,
  lt?: ModelEventRsvpEventRsvpsByOwnerAndParentTypeAndEventStartTimeAndCreatedAtCompositeKeyInput | null,
};

export type ModelEventRsvpEventRsvpsByOwnerAndParentTypeAndEventStartTimeAndCreatedAtCompositeKeyInput = {
  createdAt?: string | null,
  eventStartTime?: string | null,
  parentType?: EventRsvpParentType | null,
};

export type ModelGiftRecipientFilterInput = {
  and?: Array< ModelGiftRecipientFilterInput | null > | null,
  buyerId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  not?: ModelGiftRecipientFilterInput | null,
  or?: Array< ModelGiftRecipientFilterInput | null > | null,
  owner?: ModelStringInput | null,
  stripePriceId?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
};

export type ModelGiftRecipientConnection = {
  __typename: "ModelGiftRecipientConnection",
  items:  Array<GiftRecipient | null >,
  nextToken?: string | null,
};

export type ModelGrowthCoinStatsFilterInput = {
  and?: Array< ModelGrowthCoinStatsFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  currentMonth?: ModelStringInput | null,
  id?: ModelIDInput | null,
  monthCoins?: ModelIntInput | null,
  not?: ModelGrowthCoinStatsFilterInput | null,
  or?: Array< ModelGrowthCoinStatsFilterInput | null > | null,
  owner?: ModelStringInput | null,
  source?: ModelStringInput | null,
  sourceEvent?: ModelStringInput | null,
  totalCoins?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  version?: ModelIntInput | null,
};

export type ModelGrowthCoinStatsPrimaryCompositeKeyConditionInput = {
  beginsWith?: ModelGrowthCoinStatsPrimaryCompositeKeyInput | null,
  between?: Array< ModelGrowthCoinStatsPrimaryCompositeKeyInput | null > | null,
  eq?: ModelGrowthCoinStatsPrimaryCompositeKeyInput | null,
  ge?: ModelGrowthCoinStatsPrimaryCompositeKeyInput | null,
  gt?: ModelGrowthCoinStatsPrimaryCompositeKeyInput | null,
  le?: ModelGrowthCoinStatsPrimaryCompositeKeyInput | null,
  lt?: ModelGrowthCoinStatsPrimaryCompositeKeyInput | null,
};

export type ModelGrowthCoinStatsPrimaryCompositeKeyInput = {
  source?: string | null,
  sourceEvent?: string | null,
};

export type ModelGrowthCoinStatsConnection = {
  __typename: "ModelGrowthCoinStatsConnection",
  items:  Array<GrowthCoinStats | null >,
  nextToken?: string | null,
};

export type ModelGrowthCoinStatsGrowthCoinStatsByOwnerAndSourceAndSourceEventCompositeKeyConditionInput = {
  beginsWith?: ModelGrowthCoinStatsGrowthCoinStatsByOwnerAndSourceAndSourceEventCompositeKeyInput | null,
  between?: Array< ModelGrowthCoinStatsGrowthCoinStatsByOwnerAndSourceAndSourceEventCompositeKeyInput | null > | null,
  eq?: ModelGrowthCoinStatsGrowthCoinStatsByOwnerAndSourceAndSourceEventCompositeKeyInput | null,
  ge?: ModelGrowthCoinStatsGrowthCoinStatsByOwnerAndSourceAndSourceEventCompositeKeyInput | null,
  gt?: ModelGrowthCoinStatsGrowthCoinStatsByOwnerAndSourceAndSourceEventCompositeKeyInput | null,
  le?: ModelGrowthCoinStatsGrowthCoinStatsByOwnerAndSourceAndSourceEventCompositeKeyInput | null,
  lt?: ModelGrowthCoinStatsGrowthCoinStatsByOwnerAndSourceAndSourceEventCompositeKeyInput | null,
};

export type ModelGrowthCoinStatsGrowthCoinStatsByOwnerAndSourceAndSourceEventCompositeKeyInput = {
  source?: string | null,
  sourceEvent?: string | null,
};

export type ModelGrowthCoinTransactionFilterInput = {
  and?: Array< ModelGrowthCoinTransactionFilterInput | null > | null,
  coinsAdded?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  endBalance?: ModelIntInput | null,
  id?: ModelIDInput | null,
  not?: ModelGrowthCoinTransactionFilterInput | null,
  or?: Array< ModelGrowthCoinTransactionFilterInput | null > | null,
  owner?: ModelStringInput | null,
  source?: ModelGrowthCoinTransactionSourceInput | null,
  sourceEvent?: ModelGrowthCoinTransactionSourceEventInput | null,
  startBalance?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelGrowthCoinTransactionSourceInput = {
  eq?: GrowthCoinTransactionSource | null,
  ne?: GrowthCoinTransactionSource | null,
};

export type ModelGrowthCoinTransactionSourceEventInput = {
  eq?: GrowthCoinTransactionSourceEvent | null,
  ne?: GrowthCoinTransactionSourceEvent | null,
};

export type ModelGrowthCoinTransactionConnection = {
  __typename: "ModelGrowthCoinTransactionConnection",
  items:  Array<GrowthCoinTransaction | null >,
  nextToken?: string | null,
};

export type ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceAndCreatedAtCompositeKeyConditionInput = {
  beginsWith?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceAndCreatedAtCompositeKeyInput | null,
  between?: Array< ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceAndCreatedAtCompositeKeyInput | null > | null,
  eq?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceAndCreatedAtCompositeKeyInput | null,
  ge?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceAndCreatedAtCompositeKeyInput | null,
  gt?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceAndCreatedAtCompositeKeyInput | null,
  le?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceAndCreatedAtCompositeKeyInput | null,
  lt?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceAndCreatedAtCompositeKeyInput | null,
};

export type ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceAndCreatedAtCompositeKeyInput = {
  createdAt?: string | null,
  source?: GrowthCoinTransactionSource | null,
};

export type ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceEventAndCreatedAtCompositeKeyConditionInput = {
  beginsWith?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceEventAndCreatedAtCompositeKeyInput | null,
  between?: Array< ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceEventAndCreatedAtCompositeKeyInput | null > | null,
  eq?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceEventAndCreatedAtCompositeKeyInput | null,
  ge?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceEventAndCreatedAtCompositeKeyInput | null,
  gt?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceEventAndCreatedAtCompositeKeyInput | null,
  le?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceEventAndCreatedAtCompositeKeyInput | null,
  lt?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceEventAndCreatedAtCompositeKeyInput | null,
};

export type ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceEventAndCreatedAtCompositeKeyInput = {
  createdAt?: string | null,
  sourceEvent?: GrowthCoinTransactionSourceEvent | null,
};

export type ModelJournalFilterInput = {
  and?: Array< ModelJournalFilterInput | null > | null,
  customPrompts?: ModelStringInput | null,
  datetime?: ModelStringInput | null,
  journalType?: ModelJournalTypeInput | null,
  not?: ModelJournalFilterInput | null,
  or?: Array< ModelJournalFilterInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelStringInput | null,
  responses?: ModelStringInput | null,
};

export type ModelJournalTypeInput = {
  eq?: JournalType | null,
  ne?: JournalType | null,
};

export type ModelJournalConnection = {
  __typename: "ModelJournalConnection",
  items:  Array<Journal | null >,
  nextToken?: string | null,
};

export type ModelLeaderboardFilterInput = {
  and?: Array< ModelLeaderboardFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  highestStreakCount?: ModelIntInput | null,
  highestStreakCountAndTotalCoinsCount?: ModelStringInput | null,
  id?: ModelIDInput | null,
  month?: ModelStringInput | null,
  not?: ModelLeaderboardFilterInput | null,
  or?: Array< ModelLeaderboardFilterInput | null > | null,
  owner?: ModelStringInput | null,
  ranking?: ModelIntInput | null,
  totalCoinsCount?: ModelIntInput | null,
  totalLeadsCount?: ModelIntInput | null,
  totalReferralsCount?: ModelIntInput | null,
  totalReferralsCountAndTotalLeadsCount?: ModelStringInput | null,
  totalStreaksCount?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userProfileId?: ModelIDInput | null,
};

export type ModelIntKeyConditionInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
};

export type ModelLeaderboardDashboardStreakFilterInput = {
  and?: Array< ModelLeaderboardDashboardStreakFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  dashboardStreakId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  month?: ModelStringInput | null,
  not?: ModelLeaderboardDashboardStreakFilterInput | null,
  or?: Array< ModelLeaderboardDashboardStreakFilterInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelMeetupFilterInput = {
  agenda?: ModelStringInput | null,
  and?: Array< ModelMeetupFilterInput | null > | null,
  chatRoomId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  duration?: ModelFloatInput | null,
  endTime?: ModelStringInput | null,
  hostReferralId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  liveState?: ModelMeetupLiveStateInput | null,
  not?: ModelMeetupFilterInput | null,
  or?: Array< ModelMeetupFilterInput | null > | null,
  owner?: ModelStringInput | null,
  recurrenceId?: ModelStringInput | null,
  recurrenceRule?: ModelStringInput | null,
  roomUrl?: ModelStringInput | null,
  rsvpCount?: ModelIntInput | null,
  slugId?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  version?: ModelIntInput | null,
  visibility?: ModelEntityVisibilityInput | null,
};

export type ModelMeetupLiveStateInput = {
  eq?: MeetupLiveState | null,
  ne?: MeetupLiveState | null,
};

export type ModelMessageFilterInput = {
  and?: Array< ModelMessageFilterInput | null > | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  isEdited?: ModelBooleanInput | null,
  mediaPosition?: ModelIntInput | null,
  metadata?: ModelStringInput | null,
  not?: ModelMessageFilterInput | null,
  or?: Array< ModelMessageFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pinnedState?: ModelMessagePinnedStateInput | null,
  roomId?: ModelIDInput | null,
  type?: ModelMessageTypeInput | null,
};

export type ModelMessagePinnedStateInput = {
  eq?: MessagePinnedState | null,
  ne?: MessagePinnedState | null,
};

export type ModelMessageTypeInput = {
  eq?: MessageType | null,
  ne?: MessageType | null,
};

export type ModelMonthlyLifescoreFilterInput = {
  and?: Array< ModelMonthlyLifescoreFilterInput | null > | null,
  averageScorePercentage?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  experienceScore?: ModelIntInput | null,
  familyScore?: ModelIntInput | null,
  financeScore?: ModelIntInput | null,
  friendScore?: ModelIntInput | null,
  healthScore?: ModelIntInput | null,
  learningScore?: ModelIntInput | null,
  mentalAndEmotionalScore?: ModelIntInput | null,
  missionScore?: ModelIntInput | null,
  not?: ModelMonthlyLifescoreFilterInput | null,
  or?: Array< ModelMonthlyLifescoreFilterInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelStringInput | null,
  partnerAndLoveScore?: ModelIntInput | null,
  spiritScore?: ModelIntInput | null,
};

export type ModelMonthlyLifescoreConnection = {
  __typename: "ModelMonthlyLifescoreConnection",
  items:  Array<MonthlyLifescore | null >,
  nextToken?: string | null,
};

export type ModelNoteFilterInput = {
  and?: Array< ModelNoteFilterInput | null > | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelStringInput | null,
  entityType?: ModelEntityTypeInput | null,
  not?: ModelNoteFilterInput | null,
  or?: Array< ModelNoteFilterInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  parentType?: ModelNoteParentTypeInput | null,
  pinnedState?: ModelNotePinnedStateInput | null,
};

export type ModelNoteParentTypeInput = {
  eq?: NoteParentType | null,
  ne?: NoteParentType | null,
};

export type ModelNotePinnedStateInput = {
  eq?: NotePinnedState | null,
  ne?: NotePinnedState | null,
};

export type ModelNoteConnection = {
  __typename: "ModelNoteConnection",
  items:  Array<Note | null >,
  nextToken?: string | null,
};

export type ModelNotificationLogFilterInput = {
  and?: Array< ModelNotificationLogFilterInput | null > | null,
  challengeDayProgressId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  meetupSlugId?: ModelIDInput | null,
  name?: ModelNotificationLogNameInput | null,
  not?: ModelNotificationLogFilterInput | null,
  or?: Array< ModelNotificationLogFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelNotificationLogNameInput = {
  eq?: NotificationLogName | null,
  ne?: NotificationLogName | null,
};

export type ModelOfferingFilterInput = {
  and?: Array< ModelOfferingFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  cta?: ModelStringInput | null,
  description?: ModelStringInput | null,
  heading?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelOfferingFilterInput | null,
  or?: Array< ModelOfferingFilterInput | null > | null,
  readableTitle?: ModelStringInput | null,
  redirectUrl?: ModelStringInput | null,
  shortDescription?: ModelStringInput | null,
  showGuarantee?: ModelBooleanInput | null,
  skipEmailCollectionStep?: ModelBooleanInput | null,
  step1Title?: ModelStringInput | null,
  step2Title?: ModelStringInput | null,
  type?: ModelOfferingTypeInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelOfferingTypeInput = {
  eq?: OfferingType | null,
  ne?: OfferingType | null,
};

export type ModelOfferingConnection = {
  __typename: "ModelOfferingConnection",
  items:  Array<Offering | null >,
  nextToken?: string | null,
};

export type ModelOfferingProductBundleFilterInput = {
  and?: Array< ModelOfferingProductBundleFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelOfferingProductBundleFilterInput | null,
  offeringId?: ModelIDInput | null,
  or?: Array< ModelOfferingProductBundleFilterInput | null > | null,
  productId?: ModelIDInput | null,
  readableTitle?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelOfferingProductFilterInput = {
  and?: Array< ModelOfferingProductFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelOfferingProductFilterInput | null,
  offeringId?: ModelIDInput | null,
  or?: Array< ModelOfferingProductFilterInput | null > | null,
  productId?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelOfferingStackUpsellFilterInput = {
  and?: Array< ModelOfferingStackUpsellFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelOfferingStackUpsellFilterInput | null,
  offeringId?: ModelIDInput | null,
  offeringStackId?: ModelIDInput | null,
  or?: Array< ModelOfferingStackUpsellFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
  upsellNoId?: ModelIDInput | null,
  upsellYesId?: ModelIDInput | null,
};

export type ModelOfferingStackFilterInput = {
  and?: Array< ModelOfferingStackFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelOfferingStackFilterInput | null,
  offeringId?: ModelIDInput | null,
  or?: Array< ModelOfferingStackFilterInput | null > | null,
  orderBumpId?: ModelIDInput | null,
  readableTitle?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelProductFilterInput = {
  and?: Array< ModelProductFilterInput | null > | null,
  billingInterval?: ModelProductBillingIntervalInput | null,
  businessUnit?: ModelProductBusinessUnitInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelProductFilterInput | null,
  or?: Array< ModelProductFilterInput | null > | null,
  priceId?: ModelStringInput | null,
  productCategory?: ModelStringInput | null,
  productId?: ModelStringInput | null,
  productNamespace?: ModelStringInput | null,
  store?: ModelProductStoreInput | null,
  subscriptionGroup?: ModelProductSubscriptionGroupInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelProductBillingIntervalInput = {
  eq?: ProductBillingInterval | null,
  ne?: ProductBillingInterval | null,
};

export type ModelProductBusinessUnitInput = {
  eq?: ProductBusinessUnit | null,
  ne?: ProductBusinessUnit | null,
};

export type ModelProductStoreInput = {
  eq?: ProductStore | null,
  ne?: ProductStore | null,
};

export type ModelProductSubscriptionGroupInput = {
  eq?: ProductSubscriptionGroup | null,
  ne?: ProductSubscriptionGroup | null,
};

export type ModelProductProductsByProductIdAndStoreAndPriceIdCompositeKeyConditionInput = {
  beginsWith?: ModelProductProductsByProductIdAndStoreAndPriceIdCompositeKeyInput | null,
  between?: Array< ModelProductProductsByProductIdAndStoreAndPriceIdCompositeKeyInput | null > | null,
  eq?: ModelProductProductsByProductIdAndStoreAndPriceIdCompositeKeyInput | null,
  ge?: ModelProductProductsByProductIdAndStoreAndPriceIdCompositeKeyInput | null,
  gt?: ModelProductProductsByProductIdAndStoreAndPriceIdCompositeKeyInput | null,
  le?: ModelProductProductsByProductIdAndStoreAndPriceIdCompositeKeyInput | null,
  lt?: ModelProductProductsByProductIdAndStoreAndPriceIdCompositeKeyInput | null,
};

export type ModelProductProductsByProductIdAndStoreAndPriceIdCompositeKeyInput = {
  priceId?: string | null,
  store?: ProductStore | null,
};

export type ModelProductConnection = {
  __typename: "ModelProductConnection",
  items:  Array<Product | null >,
  nextToken?: string | null,
};

export type ModelRecentlyPlayedFilterInput = {
  and?: Array< ModelRecentlyPlayedFilterInput | null > | null,
  completeTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  entityType?: ModelEntityTypeInput | null,
  id?: ModelIDInput | null,
  lastPlayedAt?: ModelStringInput | null,
  not?: ModelRecentlyPlayedFilterInput | null,
  or?: Array< ModelRecentlyPlayedFilterInput | null > | null,
  owner?: ModelStringInput | null,
  playbackPercentage?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelRecentlyPlayedConnection = {
  __typename: "ModelRecentlyPlayedConnection",
  items:  Array<RecentlyPlayed | null >,
  nextToken?: string | null,
};

export type ReferralLeadsPagination = {
  __typename: "ReferralLeadsPagination",
  currentPage: number,
  hasNextPage: boolean,
  items?:  Array<ReferralLead | null > | null,
  pageSize: number,
  totalItems: number,
  totalPages: number,
};

export type ReferralLead = {
  __typename: "ReferralLead",
  cancelledAt?: string | null,
  createdAt: string,
  customerSince?: string | null,
  email: string,
  id: string,
  promotion: ReferralPromotion,
  state?: string | null,
};

export type ReferralPromotion = {
  __typename: "ReferralPromotion",
  campaignId: string,
  campaignName: string,
  id: string,
};

export type ReferralRewardsPagination = {
  __typename: "ReferralRewardsPagination",
  currentPage: number,
  hasNextPage: boolean,
  items?:  Array<ReferralReward | null > | null,
  pageSize: number,
  totalItems: number,
  totalPages: number,
};

export type ReferralReward = {
  __typename: "ReferralReward",
  amount: number,
  conversionAmount: number,
  createdAt: string,
  id: string,
  lead: ReferralLead,
  promotion: ReferralPromotion,
  status?: string | null,
  unit?: string | null,
};

export type ModelSocialProofFilterInput = {
  and?: Array< ModelSocialProofFilterInput | null > | null,
  commentsCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  dashboardCardItemId?: ModelIDInput | null,
  entityId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  joinCount?: ModelIntInput | null,
  likesCount?: ModelIntInput | null,
  not?: ModelSocialProofFilterInput | null,
  or?: Array< ModelSocialProofFilterInput | null > | null,
  parentId?: ModelIDInput | null,
  parentType?: ModelSocialProofParentTypeInput | null,
  rsvpCount?: ModelIntInput | null,
  sharesCount?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  version?: ModelIntInput | null,
  viewerCount?: ModelIntInput | null,
};

export type ModelSocialProofParentTypeInput = {
  eq?: SocialProofParentType | null,
  ne?: SocialProofParentType | null,
};

export type ModelSocialProofConnection = {
  __typename: "ModelSocialProofConnection",
  items:  Array<SocialProof | null >,
  nextToken?: string | null,
};

export type ModelTeamFilterInput = {
  and?: Array< ModelTeamFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  invitationState?: ModelTeamInvitationStateInput | null,
  not?: ModelTeamFilterInput | null,
  or?: Array< ModelTeamFilterInput | null > | null,
  owner?: ModelStringInput | null,
  stripePriceId?: ModelStringInput | null,
  stripeProductId?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
  subscriptionItemId?: ModelStringInput | null,
  subscriptionState?: ModelTeamSubscriptionStateInput | null,
  totalSeats?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  usedSeats?: ModelIntInput | null,
  version?: ModelIntInput | null,
};

export type ModelTeamInvitationStateInput = {
  eq?: TeamInvitationState | null,
  ne?: TeamInvitationState | null,
};

export type ModelTeamSubscriptionStateInput = {
  eq?: TeamSubscriptionState | null,
  ne?: TeamSubscriptionState | null,
};

export type ModelTeamConnection = {
  __typename: "ModelTeamConnection",
  items:  Array<Team | null >,
  nextToken?: string | null,
};

export type ModelTeamMemberFilterInput = {
  and?: Array< ModelTeamMemberFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  lastName?: ModelStringInput | null,
  not?: ModelTeamMemberFilterInput | null,
  or?: Array< ModelTeamMemberFilterInput | null > | null,
  owner?: ModelStringInput | null,
  subscriptionState?: ModelTeamSubscriptionStateInput | null,
  teamId?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelTeamMemberTeamMembersByTeamIdAndFirstNameAndLastNameCompositeKeyConditionInput = {
  beginsWith?: ModelTeamMemberTeamMembersByTeamIdAndFirstNameAndLastNameCompositeKeyInput | null,
  between?: Array< ModelTeamMemberTeamMembersByTeamIdAndFirstNameAndLastNameCompositeKeyInput | null > | null,
  eq?: ModelTeamMemberTeamMembersByTeamIdAndFirstNameAndLastNameCompositeKeyInput | null,
  ge?: ModelTeamMemberTeamMembersByTeamIdAndFirstNameAndLastNameCompositeKeyInput | null,
  gt?: ModelTeamMemberTeamMembersByTeamIdAndFirstNameAndLastNameCompositeKeyInput | null,
  le?: ModelTeamMemberTeamMembersByTeamIdAndFirstNameAndLastNameCompositeKeyInput | null,
  lt?: ModelTeamMemberTeamMembersByTeamIdAndFirstNameAndLastNameCompositeKeyInput | null,
};

export type ModelTeamMemberTeamMembersByTeamIdAndFirstNameAndLastNameCompositeKeyInput = {
  firstName?: string | null,
  lastName?: string | null,
};

export type ModelUserExternalIdentifierFilterInput = {
  and?: Array< ModelUserExternalIdentifierFilterInput | null > | null,
  externalIdentifier?: ModelStringInput | null,
  not?: ModelUserExternalIdentifierFilterInput | null,
  or?: Array< ModelUserExternalIdentifierFilterInput | null > | null,
  owner?: ModelStringInput | null,
  type?: ModelUserExternalIdentifierTypeInput | null,
};

export type ModelUserExternalIdentifierTypeInput = {
  eq?: UserExternalIdentifierType | null,
  ne?: UserExternalIdentifierType | null,
};

export type ModelUserExternalIdentifierConnection = {
  __typename: "ModelUserExternalIdentifierConnection",
  items:  Array<UserExternalIdentifier | null >,
  nextToken?: string | null,
};

export type ModelUserProfileFilterInput = {
  and?: Array< ModelUserProfileFilterInput | null > | null,
  bio?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  displayName?: ModelStringInput | null,
  not?: ModelUserProfileFilterInput | null,
  or?: Array< ModelUserProfileFilterInput | null > | null,
  owner?: ModelStringInput | null,
  publicProfileId?: ModelStringInput | null,
  totalCoinsCount?: ModelIntInput | null,
};

export type ModelUserProfileConnection = {
  __typename: "ModelUserProfileConnection",
  items:  Array<UserProfile | null >,
  nextToken?: string | null,
};

export type ModelUserSubscriptionFilterInput = {
  and?: Array< ModelUserSubscriptionFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelUserSubscriptionFilterInput | null,
  or?: Array< ModelUserSubscriptionFilterInput | null > | null,
  owner?: ModelStringInput | null,
  productId?: ModelIDInput | null,
  purchaseDate?: ModelStringInput | null,
  renewalDate?: ModelStringInput | null,
  status?: ModelUserSubscriptionStatusInput | null,
  subscriptionId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelUserSubscriptionStatusInput = {
  eq?: UserSubscriptionStatus | null,
  ne?: UserSubscriptionStatus | null,
};

export type ModelUserTourFilterInput = {
  and?: Array< ModelUserTourFilterInput | null > | null,
  completed?: ModelBooleanInput | null,
  completedAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelUserTourFilterInput | null,
  or?: Array< ModelUserTourFilterInput | null > | null,
  owner?: ModelStringInput | null,
  type?: ModelUserTourTypeInput | null,
};

export type ModelUserTourTypeInput = {
  eq?: UserTourType | null,
  ne?: UserTourType | null,
};

export type ModelUserTourConnection = {
  __typename: "ModelUserTourConnection",
  items:  Array<UserTour | null >,
  nextToken?: string | null,
};

export type ModelUserTransactionFilterInput = {
  and?: Array< ModelUserTransactionFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelUserTransactionFilterInput | null,
  or?: Array< ModelUserTransactionFilterInput | null > | null,
  owner?: ModelStringInput | null,
  price?: ModelIntInput | null,
  productId?: ModelIDInput | null,
  store?: ModelStringInput | null,
  transactionDate?: ModelStringInput | null,
  type?: ModelUserTransactionTypeInput | null,
  updatedAt?: ModelStringInput | null,
  userSubscriptionId?: ModelIDInput | null,
};

export type ModelUserTransactionTypeInput = {
  eq?: UserTransactionType | null,
  ne?: UserTransactionType | null,
};

export enum SearchMeetupsSortDirection {
  asc = "asc",
  desc = "desc",
}


export enum SearchNotesPinnedState {
  PINNED = "PINNED",
  UNPINNED = "UNPINNED",
}


export enum AddMessagePinnedState {
  PINNED = "PINNED",
  UNPINNED = "UNPINNED",
}


export type StripeTax = {
  __typename: "StripeTax",
  amountTotal: number,
  currency?: string | null,
  id?: string | null,
  lineItems:  Array<StripeTaxLineItem >,
  taxAmount: number,
  taxBreakdown:  Array<StripeTaxBreakdown >,
};

export type StripeTaxLineItem = {
  __typename: "StripeTaxLineItem",
  amount: number,
  amountTax: number,
  id: string,
  product?: string | null,
  quantity: number,
  reference?: string | null,
  taxCode: string,
};

export type StripeTaxBreakdown = {
  __typename: "StripeTaxBreakdown",
  amount: number,
  flatAmount?: number | null,
  percentageDecimal?: string | null,
  rateType?: StripeTaxBreakdownRateType | null,
  taxType?: string | null,
  taxableAmount: number,
};

export enum StripeTaxBreakdownRateType {
  flat_amount = "flat_amount",
  percentage = "percentage",
}


export type UpdateMeetupBatchResponse = {
  __typename: "UpdateMeetupBatchResponse",
  errors:  Array<UpdateMeetupBatchErrorResponse >,
  instances:  Array<UpdateMeetupBatchSuccessResponse >,
};

export type UpdateMeetupBatchErrorResponse = {
  __typename: "UpdateMeetupBatchErrorResponse",
  reason?: string | null,
  slugId: string,
};

export type UpdateMeetupBatchSuccessResponse = {
  __typename: "UpdateMeetupBatchSuccessResponse",
  slugId: string,
};

export type CancelSubscriptionResult = {
  __typename: "CancelSubscriptionResult",
  message?: string | null,
  success?: boolean | null,
};

export type CancelTeamMemberRenewalsReturnType = {
  __typename: "CancelTeamMemberRenewalsReturnType",
  ids?: Array< string | null > | null,
};

export type ChangeEmailReturnType = {
  __typename: "ChangeEmailReturnType",
  newEmail?: string | null,
  oldEmail?: string | null,
  status?: string | null,
};

export type CompleteProfileReturnType = {
  __typename: "CompleteProfileReturnType",
  family_name?: string | null,
  given_name?: string | null,
  name?: string | null,
  phone_number?: string | null,
  username: string,
};

export type ModelActiveViewSessionConditionInput = {
  and?: Array< ModelActiveViewSessionConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  heartbeatCount?: ModelIntInput | null,
  not?: ModelActiveViewSessionConditionInput | null,
  or?: Array< ModelActiveViewSessionConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userProfileId?: ModelIDInput | null,
};

export type CreateActiveViewSessionInput = {
  createdAt?: string | null,
  entityId: string,
  heartbeatCount: number,
  id?: string | null,
  updatedAt?: string | null,
  userProfileId: string,
};

export type ModelAppNotificationConditionInput = {
  and?: Array< ModelAppNotificationConditionInput | null > | null,
  authorId?: ModelStringInput | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  deeplink?: ModelStringInput | null,
  not?: ModelAppNotificationConditionInput | null,
  notificationType?: ModelAppNotificationTypeInput | null,
  or?: Array< ModelAppNotificationConditionInput | null > | null,
  owner?: ModelStringInput | null,
  sourceId?: ModelIDInput | null,
  sourceType?: ModelAppNotificationSourceTypeInput | null,
  status?: ModelAppNotificationStatusInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateAppNotificationInput = {
  authorId?: string | null,
  content?: string | null,
  createdAt?: string | null,
  deeplink?: string | null,
  id?: string | null,
  image?: CdnImageInput | null,
  notificationType: AppNotificationType,
  owner: string,
  sourceId: string,
  sourceType?: AppNotificationSourceType | null,
  status: AppNotificationStatus,
  title: string,
  updatedAt?: string | null,
};

export type CdnImageInput = {
  cdnId?: string | null,
  height?: number | null,
  url?: string | null,
  width?: number | null,
};

export type ModelAssetConditionInput = {
  and?: Array< ModelAssetConditionInput | null > | null,
  assetType?: ModelAssetTypeInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  locator?: ModelStringInput | null,
  not?: ModelAssetConditionInput | null,
  offeringId?: ModelIDInput | null,
  or?: Array< ModelAssetConditionInput | null > | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateAssetInput = {
  assetType: AssetType,
  description?: string | null,
  entityId?: string | null,
  id?: string | null,
  locator: string,
  offeringId?: string | null,
  title?: string | null,
};

export type ModelBookmarkConditionInput = {
  and?: Array< ModelBookmarkConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  not?: ModelBookmarkConditionInput | null,
  or?: Array< ModelBookmarkConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateBookmarkInput = {
  createdAt?: string | null,
  entityType?: string | null,
  owner: string,
  parentId: string,
  parentType: string,
};

export type ModelCampaignConditionInput = {
  and?: Array< ModelCampaignConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  isDefault?: ModelBooleanInput | null,
  not?: ModelCampaignConditionInput | null,
  offeringStackId?: ModelIDInput | null,
  or?: Array< ModelCampaignConditionInput | null > | null,
  readableTitle?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateCampaignInput = {
  id?: string | null,
  isDefault?: boolean | null,
  offeringStackId?: string | null,
  readableTitle: string,
};

export type CdnAudio = {
  __typename: "CdnAudio",
  cdnUrl: string,
  id: string,
};

export type CdnAssetUploadResponse = {
  __typename: "CdnAssetUploadResponse",
  cdnUrl: string,
  checksum?: string | null,
  id: string,
  uploadUrl?: string | null,
  uploadUrlExpiration?: number | null,
  uploadUrlRequestMethod?: CdnAssetUploadResponseUploadUrlRequestMethod | null,
};

export enum CdnAssetUploadResponseUploadUrlRequestMethod {
  PUT = "PUT",
}


export type ModelChallengeProgressConditionInput = {
  and?: Array< ModelChallengeProgressConditionInput | null > | null,
  coinsEarned?: ModelIntInput | null,
  completeTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  not?: ModelChallengeProgressConditionInput | null,
  or?: Array< ModelChallengeProgressConditionInput | null > | null,
  owner?: ModelStringInput | null,
  startTime?: ModelStringInput | null,
  type?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateChallengeProgressInput = {
  children?: Array< ChallengeDayProgressInput | null > | null,
  coinsEarned?: number | null,
  completeTime?: string | null,
  endTime: string,
  entityId: string,
  id?: string | null,
  owner?: string | null,
  startTime: string,
  type?: string | null,
};

export type ChallengeDayProgressInput = {
  children?: Array< ChallengeTaskProgressInput | null > | null,
  coinsEarned?: number | null,
  completeTime?: string | null,
  entityId: string,
  id: string,
  startTime: string,
};

export type ChallengeTaskProgressInput = {
  completeTime?: string | null,
  entityId: string,
  id: string,
};

export type ModelChatRoomConditionInput = {
  and?: Array< ModelChatRoomConditionInput | null > | null,
  bannedUsers?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  moderators?: ModelIDInput | null,
  not?: ModelChatRoomConditionInput | null,
  or?: Array< ModelChatRoomConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateChatRoomInput = {
  bannedUsers?: Array< string | null > | null,
  createdAt?: string | null,
  entityId: string,
  id?: string | null,
  moderators?: Array< string | null > | null,
};

export type ModelChecklistConditionInput = {
  and?: Array< ModelChecklistConditionInput | null > | null,
  completed?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  not?: ModelChecklistConditionInput | null,
  or?: Array< ModelChecklistConditionInput | null > | null,
  owner?: ModelStringInput | null,
  started?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateChecklistInput = {
  completed?: boolean | null,
  date: string,
  items?: Array< ItemCompletionInput | null > | null,
  owner: string,
  started?: boolean | null,
};

export type ItemCompletionInput = {
  completed?: boolean | null,
  deleted?: boolean | null,
  itemId?: string | null,
  order?: number | null,
};

export type ModelChecklistItemConditionInput = {
  and?: Array< ModelChecklistItemConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  date?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  frequency?: ModelItemFrequencyInput | null,
  not?: ModelChecklistItemConditionInput | null,
  or?: Array< ModelChecklistItemConditionInput | null > | null,
  order?: ModelIntInput | null,
  owner?: ModelStringInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  weekday?: ModelDayOfWeekInput | null,
};

export type CreateChecklistItemInput = {
  date: string,
  endDate?: string | null,
  frequency: ItemFrequency,
  id?: string | null,
  order?: number | null,
  owner: string,
  title: string,
  weekday: DayOfWeek,
};

export type ModelCommentConditionInput = {
  and?: Array< ModelCommentConditionInput | null > | null,
  commentsCount?: ModelIntInput | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  isEdited?: ModelBooleanInput | null,
  likesCount?: ModelIntInput | null,
  not?: ModelCommentConditionInput | null,
  or?: Array< ModelCommentConditionInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  parentType?: ModelCommentParentTypeInput | null,
  pinnedState?: ModelCommentPinnedStateInput | null,
  threadId?: ModelStringInput | null,
  type?: ModelCommentTypeInput | null,
  updatedAt?: ModelStringInput | null,
  version?: ModelIntInput | null,
  visibility?: ModelCommentVisibilityInput | null,
};

export type CreateCommentInput = {
  commentsCount?: number | null,
  content: string,
  createdAt?: string | null,
  id?: string | null,
  images?: Array< CdnImageInput | null > | null,
  isEdited?: boolean | null,
  likesCount?: number | null,
  owner?: string | null,
  parentId: string,
  parentType?: CommentParentType | null,
  pinnedState?: CommentPinnedState | null,
  threadId: string,
  type?: CommentType | null,
  version?: number | null,
  visibility: CommentVisibility,
};

export type ModelCommentLikeConditionInput = {
  and?: Array< ModelCommentLikeConditionInput | null > | null,
  commentId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  not?: ModelCommentLikeConditionInput | null,
  or?: Array< ModelCommentLikeConditionInput | null > | null,
  owner?: ModelStringInput | null,
  threadId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userProfileId?: ModelIDInput | null,
};

export type CreateCommentLikeInput = {
  commentId: string,
  id?: string | null,
  threadId: string,
  userProfileId: string,
};

export enum CreateCommentWithSpamFilterParentType {
  CHECKLIST = "CHECKLIST",
  COMMENT = "COMMENT",
  COMMUNITY_CHAT = "COMMUNITY_CHAT",
  DASHBOARD_CARD = "DASHBOARD_CARD",
  ENTITY = "ENTITY",
  JOURNAL = "JOURNAL",
}


export enum CreateCommentWithSpamFilterPinnedState {
  PINNED = "PINNED",
  UNPINNED = "UNPINNED",
}


export enum CreateCommentWithSpamFilterType {
  COMMENT = "COMMENT",
  REPLY = "REPLY",
}


export enum CreateCommentWithSpamFilterVisibility {
  HIDDEN = "HIDDEN",
  VISIBLE = "VISIBLE",
}


export type CommentMutationOutput = {
  __typename: "CommentMutationOutput",
  author?: CommentMutationOutputAuthor | null,
  content: string,
  createdAt?: string | null,
  id: string,
  images?:  Array<CdnImage | null > | null,
  owner: string,
  parentId?: string | null,
  parentType?: CommentParentType | null,
  pinnedState?: CommentPinnedState | null,
  threadId?: string | null,
  type?: CommentType | null,
  updatedAt?: string | null,
  version?: number | null,
  visibility?: CommentVisibility | null,
};

export type CommentMutationOutputAuthor = {
  __typename: "CommentMutationOutputAuthor",
  badges?: CommentMutationOutputAuthorBadges | null,
  displayName?: string | null,
  profileImage?: CdnImage | null,
  publicProfileId?: string | null,
};

export type CommentMutationOutputAuthorBadges = {
  __typename: "CommentMutationOutputAuthorBadges",
  chpc?: boolean | null,
  growthday?: boolean | null,
  ultra?: boolean | null,
};

export type ModelCourseCertificateConditionInput = {
  and?: Array< ModelCourseCertificateConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  not?: ModelCourseCertificateConditionInput | null,
  or?: Array< ModelCourseCertificateConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
  userProfileId?: ModelIDInput | null,
};

export type CreateCourseCertificateInput = {
  createdAt?: string | null,
  entityId: string,
  image: CdnImageInput,
  owner: string,
  userProfileId: string,
};

export type ModelDailyLifescoreConditionInput = {
  and?: Array< ModelDailyLifescoreConditionInput | null > | null,
  averageScorePercentage?: ModelIntInput | null,
  clarityScore?: ModelIntInput | null,
  courageScore?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  energyScore?: ModelIntInput | null,
  influenceScore?: ModelIntInput | null,
  moodScore?: ModelIntInput | null,
  movementScore?: ModelIntInput | null,
  necessityScore?: ModelIntInput | null,
  not?: ModelDailyLifescoreConditionInput | null,
  nutritionScore?: ModelIntInput | null,
  or?: Array< ModelDailyLifescoreConditionInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelStringInput | null,
  productivityScore?: ModelIntInput | null,
  sleepScore?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateDailyLifescoreInput = {
  averageScorePercentage: number,
  clarityScore: number,
  courageScore: number,
  createdAt?: string | null,
  energyScore: number,
  id?: string | null,
  influenceScore: number,
  moodScore: number,
  movementScore: number,
  necessityScore: number,
  nutritionScore: number,
  owner?: string | null,
  parentId?: string | null,
  productivityScore: number,
  sleepScore: number,
};

export type ModelDashboardCardConditionInput = {
  and?: Array< ModelDashboardCardConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  not?: ModelDashboardCardConditionInput | null,
  or?: Array< ModelDashboardCardConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateDashboardCardInput = {
  date: string,
};

export type ModelDashboardCardItemConditionInput = {
  and?: Array< ModelDashboardCardItemConditionInput | null > | null,
  assessmentType?: ModelDashboardCardItemAssessmentTypeInput | null,
  createdAt?: ModelStringInput | null,
  customPrompt?: ModelStringInput | null,
  date?: ModelStringInput | null,
  entityHasEntitlements?: ModelBooleanInput | null,
  entityId?: ModelIDInput | null,
  nonEntitledEntityId?: ModelIDInput | null,
  not?: ModelDashboardCardItemConditionInput | null,
  or?: Array< ModelDashboardCardItemConditionInput | null > | null,
  order?: ModelIntInput | null,
  type?: ModelDashboardCardItemTypeInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateDashboardCardItemInput = {
  assessmentType?: DashboardCardItemAssessmentType | null,
  customPrompt?: string | null,
  date: string,
  entityHasEntitlements?: boolean | null,
  entityId?: string | null,
  id?: string | null,
  image?: CdnImageInput | null,
  nonEntitledEntityId?: string | null,
  order: number,
  type?: DashboardCardItemType | null,
};

export type ModelDashboardProgressConditionInput = {
  and?: Array< ModelDashboardProgressConditionInput | null > | null,
  completeTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  not?: ModelDashboardProgressConditionInput | null,
  or?: Array< ModelDashboardProgressConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateDashboardProgressInput = {
  children?: Array< DashboardProgressItemInput > | null,
  completeTime?: string | null,
  date: string,
  owner: string,
};

export type DashboardProgressItemInput = {
  completeTime?: string | null,
  parentId: string,
  upsellRejected?: boolean | null,
};

export type ModelDashboardStreakConditionInput = {
  and?: Array< ModelDashboardStreakConditionInput | null > | null,
  count?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  lastActiveDate?: ModelStringInput | null,
  not?: ModelDashboardStreakConditionInput | null,
  or?: Array< ModelDashboardStreakConditionInput | null > | null,
  owner?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateDashboardStreakInput = {
  count: number,
  id?: string | null,
  lastActiveDate: string,
  owner: string,
  startDate: string,
};

export type ModelEntityConditionInput = {
  and?: Array< ModelEntityConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  duration?: ModelFloatInput | null,
  enforceEntitlementsAt?: ModelIntInput | null,
  entityType?: ModelEntityTypeInput | null,
  liveState?: ModelEntityLiveStateInput | null,
  not?: ModelEntityConditionInput | null,
  or?: Array< ModelEntityConditionInput | null > | null,
  order?: ModelIntInput | null,
  parentId?: ModelIDInput | null,
  publishAt?: ModelStringInput | null,
  redirectId?: ModelIDInput | null,
  requiredEntitlements?: ModelStringInput | null,
  rootEntityId?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  validUntil?: ModelStringInput | null,
  visibility?: ModelEntityVisibilityInput | null,
};

export type CreateEntityInput = {
  description?: string | null,
  duration?: number | null,
  enforceEntitlementsAt?: number | null,
  entityType: EntityType,
  id?: string | null,
  images?: Array< EntityImageInput | null > | null,
  liveState?: EntityLiveState | null,
  order?: number | null,
  parentId?: string | null,
  publishAt?: string | null,
  redirectId?: string | null,
  requiredEntitlements?: Array< string | null > | null,
  rootEntityId?: string | null,
  shareContent?: EntityShareContentInput | null,
  startTime?: string | null,
  tags?: Array< string | null > | null,
  title: string,
  validUntil?: string | null,
  visibility: EntityVisibility,
};

export type EntityImageInput = {
  height?: number | null,
  imageType: EntityImageType,
  url: string,
  width?: number | null,
};

export type EntityShareContentInput = {
  description?: string | null,
  images?: Array< EntityImageInput | null > | null,
  title?: string | null,
};

export type ModelEntityLikeConditionInput = {
  and?: Array< ModelEntityLikeConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  not?: ModelEntityLikeConditionInput | null,
  or?: Array< ModelEntityLikeConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userProfileId?: ModelIDInput | null,
};

export type CreateEntityLikeInput = {
  entityId: string,
  id?: string | null,
  userProfileId: string,
};

export type ModelEntityRelationsConditionInput = {
  and?: Array< ModelEntityRelationsConditionInput | null > | null,
  childId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  not?: ModelEntityRelationsConditionInput | null,
  or?: Array< ModelEntityRelationsConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateEntityRelationsInput = {
  childId: string,
  id?: string | null,
};

export type ModelEventRsvpConditionInput = {
  and?: Array< ModelEventRsvpConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  eventStartTime?: ModelStringInput | null,
  meetupId?: ModelIDInput | null,
  not?: ModelEventRsvpConditionInput | null,
  or?: Array< ModelEventRsvpConditionInput | null > | null,
  owner?: ModelStringInput | null,
  parentType?: ModelEventRsvpParentTypeInput | null,
  socialProofId?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  userProfileId?: ModelIDInput | null,
};

export type CreateEventRsvpInput = {
  createdAt?: string | null,
  eventStartTime: string,
  meetupId?: string | null,
  owner: string,
  parentId: string,
  parentType?: EventRsvpParentType | null,
  socialProofId?: string | null,
  userProfileId: string,
};

export type ModelGiftRecipientConditionInput = {
  and?: Array< ModelGiftRecipientConditionInput | null > | null,
  buyerId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  not?: ModelGiftRecipientConditionInput | null,
  or?: Array< ModelGiftRecipientConditionInput | null > | null,
  owner?: ModelStringInput | null,
  stripePriceId?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateGiftRecipientInput = {
  buyerId: string,
  createdAt?: string | null,
  email?: string | null,
  firstName?: string | null,
  id?: string | null,
  lastName?: string | null,
  owner: string,
  stripePriceId?: string | null,
  subscriptionId?: string | null,
};

export type CreateGiftSubscriptionsReturnType = {
  __typename: "CreateGiftSubscriptionsReturnType",
  executionArn?: string | null,
};

export type ModelGrowthCoinStatsConditionInput = {
  and?: Array< ModelGrowthCoinStatsConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  currentMonth?: ModelStringInput | null,
  monthCoins?: ModelIntInput | null,
  not?: ModelGrowthCoinStatsConditionInput | null,
  or?: Array< ModelGrowthCoinStatsConditionInput | null > | null,
  owner?: ModelStringInput | null,
  totalCoins?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  version?: ModelIntInput | null,
};

export type CreateGrowthCoinStatsInput = {
  currentMonth: string,
  monthCoins: number,
  owner: string,
  source: string,
  sourceEvent: string,
  totalCoins: number,
  version?: number | null,
};

export type ModelGrowthCoinTransactionConditionInput = {
  and?: Array< ModelGrowthCoinTransactionConditionInput | null > | null,
  coinsAdded?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  endBalance?: ModelIntInput | null,
  not?: ModelGrowthCoinTransactionConditionInput | null,
  or?: Array< ModelGrowthCoinTransactionConditionInput | null > | null,
  owner?: ModelStringInput | null,
  source?: ModelGrowthCoinTransactionSourceInput | null,
  sourceEvent?: ModelGrowthCoinTransactionSourceEventInput | null,
  startBalance?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateGrowthCoinTransactionInput = {
  coinsAdded: number,
  createdAt?: string | null,
  endBalance: number,
  id?: string | null,
  owner?: string | null,
  source: GrowthCoinTransactionSource,
  sourceEvent: GrowthCoinTransactionSourceEvent,
  startBalance: number,
};

export type ModelJournalConditionInput = {
  and?: Array< ModelJournalConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  customPrompts?: ModelStringInput | null,
  datetime?: ModelStringInput | null,
  journalType?: ModelJournalTypeInput | null,
  not?: ModelJournalConditionInput | null,
  or?: Array< ModelJournalConditionInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelStringInput | null,
  responses?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateJournalInput = {
  customPrompts?: Array< string | null > | null,
  datetime: string,
  id?: string | null,
  images?: Array< JournalImageInput | null > | null,
  journalType: JournalType,
  owner?: string | null,
  parentId?: string | null,
  responses?: Array< string | null > | null,
};

export type JournalImageInput = {
  height?: number | null,
  s3Key: string,
  width?: number | null,
};

export type ModelLeaderboardConditionInput = {
  and?: Array< ModelLeaderboardConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  highestStreakCount?: ModelIntInput | null,
  highestStreakCountAndTotalCoinsCount?: ModelStringInput | null,
  not?: ModelLeaderboardConditionInput | null,
  or?: Array< ModelLeaderboardConditionInput | null > | null,
  owner?: ModelStringInput | null,
  ranking?: ModelIntInput | null,
  totalCoinsCount?: ModelIntInput | null,
  totalLeadsCount?: ModelIntInput | null,
  totalReferralsCount?: ModelIntInput | null,
  totalReferralsCountAndTotalLeadsCount?: ModelStringInput | null,
  totalStreaksCount?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userProfileId?: ModelIDInput | null,
};

export type CreateLeaderboardInput = {
  highestStreakCount: number,
  highestStreakCountAndTotalCoinsCount: string,
  month: string,
  owner: string,
  ranking?: number | null,
  totalCoinsCount: number,
  totalLeadsCount?: number | null,
  totalReferralsCount: number,
  totalReferralsCountAndTotalLeadsCount?: string | null,
  totalStreaksCount: number,
  userProfileId: string,
};

export type ModelLeaderboardDashboardStreakConditionInput = {
  and?: Array< ModelLeaderboardDashboardStreakConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  dashboardStreakId?: ModelStringInput | null,
  month?: ModelStringInput | null,
  not?: ModelLeaderboardDashboardStreakConditionInput | null,
  or?: Array< ModelLeaderboardDashboardStreakConditionInput | null > | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateLeaderboardDashboardStreakInput = {
  dashboardStreakId: string,
  id?: string | null,
  month: string,
  owner: string,
};

export type ModelMeetupConditionInput = {
  agenda?: ModelStringInput | null,
  and?: Array< ModelMeetupConditionInput | null > | null,
  chatRoomId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  duration?: ModelFloatInput | null,
  endTime?: ModelStringInput | null,
  hostReferralId?: ModelStringInput | null,
  liveState?: ModelMeetupLiveStateInput | null,
  not?: ModelMeetupConditionInput | null,
  or?: Array< ModelMeetupConditionInput | null > | null,
  owner?: ModelStringInput | null,
  recurrenceId?: ModelStringInput | null,
  recurrenceRule?: ModelStringInput | null,
  roomUrl?: ModelStringInput | null,
  rsvpCount?: ModelIntInput | null,
  startTime?: ModelStringInput | null,
  title?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  version?: ModelIntInput | null,
  visibility?: ModelEntityVisibilityInput | null,
};

export type CreateMeetupInput = {
  agenda: string,
  chatRoomId?: string | null,
  duration: number,
  endTime: string,
  hostReferralId?: string | null,
  liveState: MeetupLiveState,
  owner?: string | null,
  recurrenceId?: string | null,
  recurrenceRule?: string | null,
  roomUrl?: string | null,
  rsvpCount?: number | null,
  slugId: string,
  startTime: string,
  thumbnail?: MeetupThumbnailInput | null,
  title: string,
  version?: number | null,
  visibility: EntityVisibility,
};

export type MeetupThumbnailInput = {
  height?: number | null,
  url: string,
  width?: number | null,
};

export enum CreateMeetupsVisibility {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
}


export type CreateMeetupBatchResponse = {
  __typename: "CreateMeetupBatchResponse",
  errors:  Array<CreateMeetupBatchErrorResponse >,
  instances:  Array<CreateMeetupBatchSuccessResponse >,
};

export type CreateMeetupBatchErrorResponse = {
  __typename: "CreateMeetupBatchErrorResponse",
  reason?: string | null,
  startTime: string,
};

export type CreateMeetupBatchSuccessResponse = {
  __typename: "CreateMeetupBatchSuccessResponse",
  slugId: string,
  startTime: string,
};

export type ModelMessageConditionInput = {
  and?: Array< ModelMessageConditionInput | null > | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  isEdited?: ModelBooleanInput | null,
  mediaPosition?: ModelIntInput | null,
  metadata?: ModelStringInput | null,
  not?: ModelMessageConditionInput | null,
  or?: Array< ModelMessageConditionInput | null > | null,
  owner?: ModelStringInput | null,
  pinnedState?: ModelMessagePinnedStateInput | null,
  roomId?: ModelIDInput | null,
  type?: ModelMessageTypeInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateMessageInput = {
  content: string,
  createdAt?: string | null,
  id?: string | null,
  isEdited?: boolean | null,
  mediaPosition: number,
  metadata?: string | null,
  owner?: string | null,
  pinnedState?: MessagePinnedState | null,
  roomId: string,
  type: MessageType,
};

export type ModelMonthlyLifescoreConditionInput = {
  and?: Array< ModelMonthlyLifescoreConditionInput | null > | null,
  averageScorePercentage?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  experienceScore?: ModelIntInput | null,
  familyScore?: ModelIntInput | null,
  financeScore?: ModelIntInput | null,
  friendScore?: ModelIntInput | null,
  healthScore?: ModelIntInput | null,
  learningScore?: ModelIntInput | null,
  mentalAndEmotionalScore?: ModelIntInput | null,
  missionScore?: ModelIntInput | null,
  not?: ModelMonthlyLifescoreConditionInput | null,
  or?: Array< ModelMonthlyLifescoreConditionInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelStringInput | null,
  partnerAndLoveScore?: ModelIntInput | null,
  spiritScore?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateMonthlyLifescoreInput = {
  averageScorePercentage: number,
  createdAt?: string | null,
  experienceScore: number,
  familyScore: number,
  financeScore: number,
  friendScore: number,
  healthScore: number,
  id?: string | null,
  learningScore: number,
  mentalAndEmotionalScore: number,
  missionScore: number,
  owner?: string | null,
  parentId?: string | null,
  partnerAndLoveScore: number,
  spiritScore: number,
};

export type ModelNoteConditionInput = {
  and?: Array< ModelNoteConditionInput | null > | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  entityType?: ModelEntityTypeInput | null,
  not?: ModelNoteConditionInput | null,
  or?: Array< ModelNoteConditionInput | null > | null,
  owner?: ModelStringInput | null,
  parentType?: ModelNoteParentTypeInput | null,
  pinnedState?: ModelNotePinnedStateInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateNoteInput = {
  content: string,
  createdAt?: string | null,
  entityId: string,
  entityType?: EntityType | null,
  owner: string,
  parentId: string,
  parentType?: NoteParentType | null,
  pinnedState?: NotePinnedState | null,
};

export type ModelNoteItemConditionInput = {
  and?: Array< ModelNoteItemConditionInput | null > | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelStringInput | null,
  entityType?: ModelEntityTypeInput | null,
  not?: ModelNoteItemConditionInput | null,
  noteOwner?: ModelStringInput | null,
  or?: Array< ModelNoteItemConditionInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelStringInput | null,
  parentType?: ModelNoteItemParentTypeInput | null,
  timestamp?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelNoteItemParentTypeInput = {
  eq?: NoteItemParentType | null,
  ne?: NoteItemParentType | null,
};

export type CreateNoteItemInput = {
  content: string,
  entityId: string,
  entityType?: EntityType | null,
  id?: string | null,
  noteOwner: string,
  parentId: string,
  parentType?: NoteItemParentType | null,
  timestamp: number,
};

export type ModelNotificationLogConditionInput = {
  and?: Array< ModelNotificationLogConditionInput | null > | null,
  challengeDayProgressId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  meetupSlugId?: ModelIDInput | null,
  name?: ModelNotificationLogNameInput | null,
  not?: ModelNotificationLogConditionInput | null,
  or?: Array< ModelNotificationLogConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateNotificationLogInput = {
  challengeDayProgressId?: string | null,
  entityId?: string | null,
  id?: string | null,
  meetupSlugId?: string | null,
  name?: NotificationLogName | null,
};

export type ModelOfferingConditionInput = {
  and?: Array< ModelOfferingConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  cta?: ModelStringInput | null,
  description?: ModelStringInput | null,
  heading?: ModelStringInput | null,
  not?: ModelOfferingConditionInput | null,
  or?: Array< ModelOfferingConditionInput | null > | null,
  readableTitle?: ModelStringInput | null,
  redirectUrl?: ModelStringInput | null,
  shortDescription?: ModelStringInput | null,
  showGuarantee?: ModelBooleanInput | null,
  skipEmailCollectionStep?: ModelBooleanInput | null,
  step1Title?: ModelStringInput | null,
  step2Title?: ModelStringInput | null,
  type?: ModelOfferingTypeInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateOfferingInput = {
  cta?: string | null,
  description?: string | null,
  heading?: string | null,
  id?: string | null,
  image?: CdnImageInput | null,
  overrides?: OfferingOverridesInput | null,
  readableTitle: string,
  redirectUrl?: string | null,
  shortDescription?: string | null,
  showGuarantee?: boolean | null,
  skipEmailCollectionStep?: boolean | null,
  step1Title?: string | null,
  step2Title?: string | null,
  type?: OfferingType | null,
};

export type OfferingOverridesInput = {
  skipCreditCard?: boolean | null,
  trialDuration?: number | null,
  trialFrequency?: OfferingOverridesTrialFrequency | null,
};

export type ModelOfferingProductConditionInput = {
  and?: Array< ModelOfferingProductConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  not?: ModelOfferingProductConditionInput | null,
  offeringId?: ModelIDInput | null,
  or?: Array< ModelOfferingProductConditionInput | null > | null,
  productId?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateOfferingProductInput = {
  id?: string | null,
  offeringId: string,
  productId: string,
};

export type ModelOfferingProductBundleConditionInput = {
  and?: Array< ModelOfferingProductBundleConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  not?: ModelOfferingProductBundleConditionInput | null,
  offeringId?: ModelIDInput | null,
  or?: Array< ModelOfferingProductBundleConditionInput | null > | null,
  productId?: ModelIDInput | null,
  readableTitle?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateOfferingProductBundleInput = {
  id?: string | null,
  offeringId: string,
  overrides?: OfferingOverridesInput | null,
  productId: string,
  readableTitle: string,
};

export type ModelOfferingStackConditionInput = {
  and?: Array< ModelOfferingStackConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  not?: ModelOfferingStackConditionInput | null,
  offeringId?: ModelIDInput | null,
  or?: Array< ModelOfferingStackConditionInput | null > | null,
  orderBumpId?: ModelIDInput | null,
  readableTitle?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateOfferingStackInput = {
  id?: string | null,
  offeringId: string,
  orderBumpId?: string | null,
  readableTitle: string,
};

export type ModelOfferingStackUpsellConditionInput = {
  and?: Array< ModelOfferingStackUpsellConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  not?: ModelOfferingStackUpsellConditionInput | null,
  offeringId?: ModelIDInput | null,
  offeringStackId?: ModelIDInput | null,
  or?: Array< ModelOfferingStackUpsellConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
  upsellNoId?: ModelIDInput | null,
  upsellYesId?: ModelIDInput | null,
};

export type CreateOfferingStackUpsellInput = {
  id?: string | null,
  offeringId: string,
  offeringStackId?: string | null,
  upsellNoId?: string | null,
  upsellYesId?: string | null,
};

export type ModelProductConditionInput = {
  and?: Array< ModelProductConditionInput | null > | null,
  billingInterval?: ModelProductBillingIntervalInput | null,
  businessUnit?: ModelProductBusinessUnitInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelProductConditionInput | null,
  or?: Array< ModelProductConditionInput | null > | null,
  priceId?: ModelStringInput | null,
  productCategory?: ModelStringInput | null,
  productId?: ModelStringInput | null,
  productNamespace?: ModelStringInput | null,
  store?: ModelProductStoreInput | null,
  subscriptionGroup?: ModelProductSubscriptionGroupInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateProductInput = {
  billingInterval?: ProductBillingInterval | null,
  businessUnit?: ProductBusinessUnit | null,
  description?: string | null,
  entitlements?: Array< EntitlementCustomTypeInput | null > | null,
  id?: string | null,
  name: string,
  priceId?: string | null,
  productCategory?: string | null,
  productId: string,
  productNamespace: string,
  store?: ProductStore | null,
  subscriptionGroup?: ProductSubscriptionGroup | null,
};

export type EntitlementCustomTypeInput = {
  identifier: string,
  revenueCatEntitlementId?: string | null,
};

export type ModelRecentlyPlayedConditionInput = {
  and?: Array< ModelRecentlyPlayedConditionInput | null > | null,
  completeTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  entityType?: ModelEntityTypeInput | null,
  lastPlayedAt?: ModelStringInput | null,
  not?: ModelRecentlyPlayedConditionInput | null,
  or?: Array< ModelRecentlyPlayedConditionInput | null > | null,
  owner?: ModelStringInput | null,
  playbackPercentage?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateRecentlyPlayedInput = {
  children?: Array< RecentlyPlayedChildInput | null > | null,
  completeTime?: string | null,
  entityId: string,
  entityType: EntityType,
  id?: string | null,
  images?: Array< EntityImageInput | null > | null,
  lastPlayedAt: string,
  owner?: string | null,
  playbackPercentage: number,
};

export type RecentlyPlayedChildInput = {
  completeTime?: string | null,
  entityId?: string | null,
  lastPlayedAt: string,
  playbackPercentage: number,
};

export type ModelSocialProofConditionInput = {
  and?: Array< ModelSocialProofConditionInput | null > | null,
  commentsCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  dashboardCardItemId?: ModelIDInput | null,
  entityId?: ModelIDInput | null,
  joinCount?: ModelIntInput | null,
  likesCount?: ModelIntInput | null,
  not?: ModelSocialProofConditionInput | null,
  or?: Array< ModelSocialProofConditionInput | null > | null,
  parentType?: ModelSocialProofParentTypeInput | null,
  rsvpCount?: ModelIntInput | null,
  sharesCount?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  version?: ModelIntInput | null,
  viewerCount?: ModelIntInput | null,
};

export type CreateSocialProofInput = {
  commentsCount?: number | null,
  dashboardCardItemId?: string | null,
  entityId?: string | null,
  joinCount?: number | null,
  likesCount?: number | null,
  parentId: string,
  parentType?: SocialProofParentType | null,
  rsvpCount?: number | null,
  sharesCount?: number | null,
  version?: number | null,
  viewerCount?: number | null,
};

export type ModelTeamConditionInput = {
  and?: Array< ModelTeamConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  invitationState?: ModelTeamInvitationStateInput | null,
  not?: ModelTeamConditionInput | null,
  or?: Array< ModelTeamConditionInput | null > | null,
  owner?: ModelStringInput | null,
  stripePriceId?: ModelStringInput | null,
  stripeProductId?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
  subscriptionItemId?: ModelStringInput | null,
  subscriptionState?: ModelTeamSubscriptionStateInput | null,
  totalSeats?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  usedSeats?: ModelIntInput | null,
  version?: ModelIntInput | null,
};

export type CreateTeamInput = {
  id?: string | null,
  invitationState?: TeamInvitationState | null,
  owner: string,
  stripePriceId?: string | null,
  stripeProductId?: string | null,
  subscriptionId?: string | null,
  subscriptionItemId?: string | null,
  subscriptionState?: TeamSubscriptionState | null,
  totalSeats?: number | null,
  usedSeats?: number | null,
  version?: number | null,
};

export type ModelTeamMemberConditionInput = {
  and?: Array< ModelTeamMemberConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  not?: ModelTeamMemberConditionInput | null,
  or?: Array< ModelTeamMemberConditionInput | null > | null,
  owner?: ModelStringInput | null,
  subscriptionState?: ModelTeamSubscriptionStateInput | null,
  teamId?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateTeamMemberInput = {
  email?: string | null,
  firstName?: string | null,
  id?: string | null,
  lastName?: string | null,
  owner: string,
  subscriptionState?: TeamSubscriptionState | null,
  teamId: string,
};

export type ModelUserExternalIdentifierConditionInput = {
  and?: Array< ModelUserExternalIdentifierConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  not?: ModelUserExternalIdentifierConditionInput | null,
  or?: Array< ModelUserExternalIdentifierConditionInput | null > | null,
  owner?: ModelStringInput | null,
  type?: ModelUserExternalIdentifierTypeInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateUserExternalIdentifierInput = {
  externalIdentifier: string,
  owner: string,
  type?: UserExternalIdentifierType | null,
};

export type ModelUserProfileConditionInput = {
  and?: Array< ModelUserProfileConditionInput | null > | null,
  bio?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  displayName?: ModelStringInput | null,
  not?: ModelUserProfileConditionInput | null,
  or?: Array< ModelUserProfileConditionInput | null > | null,
  owner?: ModelStringInput | null,
  publicProfileId?: ModelStringInput | null,
  totalCoinsCount?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateUserProfileInput = {
  attributes?: UserAttributesInput | null,
  badges?: UserProfileBadgesInput | null,
  bio?: string | null,
  cover?: CdnImageInput | null,
  createdAt?: string | null,
  displayName?: string | null,
  experimentMetadata?: UserProfileExperimentMetadataInput | null,
  owner: string,
  profileImage?: CdnImageInput | null,
  publicProfileId: string,
  socialMediaLinks?: SocialMediaLinksInput | null,
  totalCoinsCount?: number | null,
};

export type UserAttributesInput = {
  intents?: Array< string | null > | null,
  surveyCustCategory?: UserAttributesSurveyCustCategory | null,
  surveyInterests?: Array< string | null > | null,
};

export type UserProfileBadgesInput = {
  chpc?: boolean | null,
  growthday?: boolean | null,
  ultra?: boolean | null,
};

export type UserProfileExperimentMetadataInput = {
  mozartUser?: boolean | null,
};

export type SocialMediaLinksInput = {
  facebook?: string | null,
  instagram?: string | null,
  linkedin?: string | null,
  website?: string | null,
  x?: string | null,
};

export type ModelUserSubscriptionConditionInput = {
  and?: Array< ModelUserSubscriptionConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  not?: ModelUserSubscriptionConditionInput | null,
  or?: Array< ModelUserSubscriptionConditionInput | null > | null,
  owner?: ModelStringInput | null,
  productId?: ModelIDInput | null,
  purchaseDate?: ModelStringInput | null,
  renewalDate?: ModelStringInput | null,
  status?: ModelUserSubscriptionStatusInput | null,
  subscriptionId?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateUserSubscriptionInput = {
  expirationDate?: string | null,
  id?: string | null,
  owner?: string | null,
  productId: string,
  purchaseDate?: string | null,
  renewalDate?: string | null,
  status?: UserSubscriptionStatus | null,
  subscriptionId: string,
};

export type ModelUserTourConditionInput = {
  and?: Array< ModelUserTourConditionInput | null > | null,
  completed?: ModelBooleanInput | null,
  completedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  not?: ModelUserTourConditionInput | null,
  or?: Array< ModelUserTourConditionInput | null > | null,
  owner?: ModelStringInput | null,
  type?: ModelUserTourTypeInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateUserTourInput = {
  completed?: boolean | null,
  completedAt?: string | null,
  id?: string | null,
  owner: string,
  type: UserTourType,
};

export type ModelUserTransactionConditionInput = {
  and?: Array< ModelUserTransactionConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  not?: ModelUserTransactionConditionInput | null,
  or?: Array< ModelUserTransactionConditionInput | null > | null,
  owner?: ModelStringInput | null,
  price?: ModelIntInput | null,
  productId?: ModelIDInput | null,
  store?: ModelStringInput | null,
  transactionDate?: ModelStringInput | null,
  type?: ModelUserTransactionTypeInput | null,
  updatedAt?: ModelStringInput | null,
  userSubscriptionId?: ModelIDInput | null,
};

export type CreateUserTransactionInput = {
  currency?: string | null,
  id?: string | null,
  owner?: string | null,
  price?: number | null,
  productId: string,
  store: string,
  transactionDate: string,
  type?: UserTransactionType | null,
  userSubscriptionId?: string | null,
};

export type DeleteActiveViewSessionInput = {
  id: string,
};

export type DeleteAssetInput = {
  id: string,
};

export type DeleteBookmarkInput = {
  owner: string,
  parentId: string,
  parentType: string,
};

export type DeleteCampaignInput = {
  id: string,
};

export type CdnAssetDeleteResponse = {
  __typename: "CdnAssetDeleteResponse",
  id: string,
};

export type DeleteChecklistInput = {
  date: string,
  owner: string,
};

export type DeleteChecklistItemInput = {
  id: string,
};

export type DeleteCommentInput = {
  id: string,
};

export type DeleteCommentLikeInput = {
  id: string,
};

export type DeleteDailyLifescoreInput = {
  id: string,
};

export type DeleteDashboardCardInput = {
  date: string,
};

export type DeleteDashboardCardItemInput = {
  id: string,
};

export type DeleteDashboardStreakInput = {
  id: string,
};

export type DeleteEntityInput = {
  id: string,
};

export type DeleteEntityLikeInput = {
  id: string,
};

export type DeleteEntityRelationsInput = {
  id: string,
};

export type DeleteEventRsvpInput = {
  owner: string,
  parentId: string,
};

export type DeleteGiftRecipientInput = {
  id: string,
};

export type DeleteGrowthCoinStatsInput = {
  owner: string,
  source: string,
  sourceEvent: string,
};

export type DeleteGrowthCoinTransactionInput = {
  id: string,
};

export type DeleteJournalInput = {
  id: string,
};

export type DeleteLeaderboardInput = {
  month: string,
  owner: string,
};

export type DeleteLeaderboardDashboardStreakInput = {
  id: string,
};

export type DeleteMeetupInput = {
  slugId: string,
};

export type DeleteMessageInput = {
  id: string,
};

export type DeleteMonthlyLifescoreInput = {
  id: string,
};

export type DeleteNoteInput = {
  entityId: string,
  owner: string,
  parentId: string,
};

export type DeleteNoteItemInput = {
  id: string,
};

export type DeleteNotificationLogInput = {
  id: string,
};

export type DeleteOfferingInput = {
  id: string,
};

export type DeleteOfferingProductInput = {
  id: string,
};

export type DeleteOfferingProductBundleInput = {
  id: string,
};

export type DeleteOfferingStackInput = {
  id: string,
};

export type DeleteOfferingStackUpsellInput = {
  id: string,
};

export type DeleteProductInput = {
  id: string,
};

export type DeleteRecentlyPlayedInput = {
  id: string,
};

export type DeleteTeamInput = {
  id: string,
};

export type DeleteTeamMemberInput = {
  id: string,
};

export type DeleteUserReturnType = {
  __typename: "DeleteUserReturnType",
  status?: string | null,
};

export type DeleteUserExternalIdentifierInput = {
  externalIdentifier: string,
  owner: string,
};

export type DeleteUserProfileInput = {
  owner: string,
};

export type DeleteUserSubscriptionInput = {
  id: string,
};

export type DeleteUserTransactionInput = {
  id: string,
};

export type FreeOfferingSignupResult = {
  __typename: "FreeOfferingSignupResult",
  accessToken?: string | null,
  entitlements?: Array< string | null > | null,
  idToken?: string | null,
  message?: string | null,
  refreshToken?: string | null,
  success: boolean,
  username?: string | null,
};

export type InviteTeamMembersReturnType = {
  __typename: "InviteTeamMembersReturnType",
  executionArn?: string | null,
};

export type JoinMeetupResponse = {
  __typename: "JoinMeetupResponse",
  token?: string | null,
};

export enum ProcessPurchaseV2PaymentMethodType {
  apple_pay = "apple_pay",
  card = "card",
  google_pay = "google_pay",
}


export type PurchaseV2Result = {
  __typename: "PurchaseV2Result",
  entitlements?: Array< string | null > | null,
  isAuthenticated?: boolean | null,
  isFirstTimeTrialOnlyUser?: boolean | null,
  message?: string | null,
  paymentIntents?:  Array<StripeIntentResponse | null > | null,
  requiresAction?: boolean | null,
  success: boolean,
  username?: string | null,
  uuid?: string | null,
};

export type StripeIntentResponse = {
  __typename: "StripeIntentResponse",
  clientSecret?: string | null,
  id?: string | null,
  type?: string | null,
};

export type PurchaseTeamResponse = {
  __typename: "PurchaseTeamResponse",
  message: string,
  requiresAction: boolean,
  stripeIntentClientSecret?: string | null,
  stripeIntentId?: string | null,
  stripeIntentType?: string | null,
  subscriptionId?: string | null,
  subscriptionItemId?: string | null,
  success: boolean,
  teamId?: string | null,
};

export type SendViewHeartbeatReturnType = {
  __typename: "SendViewHeartbeatReturnType",
  heartbeatCount?: number | null,
  sessionId?: string | null,
  updatedAt?: string | null,
};

export type StartMeetupResponse = {
  __typename: "StartMeetupResponse",
  chatRoomId?: string | null,
  token?: string | null,
  url?: string | null,
};

export type UpdateActiveViewSessionInput = {
  createdAt?: string | null,
  entityId?: string | null,
  heartbeatCount?: number | null,
  id: string,
  updatedAt?: string | null,
  userProfileId?: string | null,
};

export type UpdateAppNotificationsBatchResponse = {
  __typename: "UpdateAppNotificationsBatchResponse",
  errors:  Array<AppNotificationsErrorResponse >,
  instances:  Array<AppNotificationsResponse >,
};

export type AppNotificationsErrorResponse = {
  __typename: "AppNotificationsErrorResponse",
  id: string,
  reason?: string | null,
};

export type AppNotificationsResponse = {
  __typename: "AppNotificationsResponse",
  id: string,
  status?: AppNotificationStatus | null,
  updatedAt?: string | null,
};

export type UpdateAppNotificationInput = {
  authorId?: string | null,
  content?: string | null,
  createdAt?: string | null,
  deeplink?: string | null,
  id: string,
  image?: CdnImageInput | null,
  notificationType?: AppNotificationType | null,
  owner?: string | null,
  sourceId?: string | null,
  sourceType?: AppNotificationSourceType | null,
  status?: AppNotificationStatus | null,
  title?: string | null,
  updatedAt?: string | null,
};

export type UpdateAssetInput = {
  assetType?: AssetType | null,
  description?: string | null,
  entityId?: string | null,
  id: string,
  locator?: string | null,
  offeringId?: string | null,
  title?: string | null,
};

export type UpdateBookmarkInput = {
  createdAt?: string | null,
  entityType?: string | null,
  owner: string,
  parentId: string,
  parentType: string,
};

export type UpdateCampaignInput = {
  id: string,
  isDefault?: boolean | null,
  offeringStackId?: string | null,
  readableTitle?: string | null,
};

export type UpdateChallengeProgressInput = {
  children?: Array< ChallengeDayProgressInput | null > | null,
  coinsEarned?: number | null,
  completeTime?: string | null,
  endTime?: string | null,
  entityId?: string | null,
  id: string,
  owner?: string | null,
  startTime?: string | null,
  type?: string | null,
};

export type UpdateChatRoomInput = {
  bannedUsers?: Array< string | null > | null,
  createdAt?: string | null,
  entityId?: string | null,
  id: string,
  moderators?: Array< string | null > | null,
};

export type UpdateChecklistInput = {
  completed?: boolean | null,
  date: string,
  items?: Array< ItemCompletionInput | null > | null,
  owner: string,
  started?: boolean | null,
};

export type UpdateChecklistItemInput = {
  date?: string | null,
  endDate?: string | null,
  frequency?: ItemFrequency | null,
  id: string,
  order?: number | null,
  owner?: string | null,
  title?: string | null,
  weekday?: DayOfWeek | null,
};

export type UpdateCommentInput = {
  commentsCount?: number | null,
  content?: string | null,
  createdAt?: string | null,
  id: string,
  images?: Array< CdnImageInput | null > | null,
  isEdited?: boolean | null,
  likesCount?: number | null,
  owner?: string | null,
  parentId?: string | null,
  parentType?: CommentParentType | null,
  pinnedState?: CommentPinnedState | null,
  threadId?: string | null,
  type?: CommentType | null,
  version?: number | null,
  visibility?: CommentVisibility | null,
};

export type UpdateCommentLikeInput = {
  commentId?: string | null,
  id: string,
  threadId?: string | null,
  userProfileId?: string | null,
};

export enum UpdateCommentWithSpamFilterPinnedState {
  PINNED = "PINNED",
  UNPINNED = "UNPINNED",
}


export type UpdateCourseCertificateInput = {
  createdAt?: string | null,
  entityId: string,
  image?: CdnImageInput | null,
  owner: string,
  userProfileId?: string | null,
};

export type UpdateDashboardCardInput = {
  date: string,
};

export type UpdateDashboardCardItemInput = {
  assessmentType?: DashboardCardItemAssessmentType | null,
  customPrompt?: string | null,
  date?: string | null,
  entityHasEntitlements?: boolean | null,
  entityId?: string | null,
  id: string,
  image?: CdnImageInput | null,
  nonEntitledEntityId?: string | null,
  order?: number | null,
  type?: DashboardCardItemType | null,
};

export type UpdateDashboardProgressInput = {
  children?: Array< DashboardProgressItemInput > | null,
  completeTime?: string | null,
  date: string,
  owner: string,
};

export type UpdateDashboardStreakInput = {
  count?: number | null,
  id: string,
  lastActiveDate?: string | null,
  owner?: string | null,
  startDate?: string | null,
};

export type UpdateEntityInput = {
  description?: string | null,
  duration?: number | null,
  enforceEntitlementsAt?: number | null,
  entityType?: EntityType | null,
  id: string,
  images?: Array< EntityImageInput | null > | null,
  liveState?: EntityLiveState | null,
  order?: number | null,
  parentId?: string | null,
  publishAt?: string | null,
  redirectId?: string | null,
  requiredEntitlements?: Array< string | null > | null,
  rootEntityId?: string | null,
  shareContent?: EntityShareContentInput | null,
  startTime?: string | null,
  tags?: Array< string | null > | null,
  title?: string | null,
  validUntil?: string | null,
  visibility?: EntityVisibility | null,
};

export type UpdateEntityLikeInput = {
  entityId?: string | null,
  id: string,
  userProfileId?: string | null,
};

export type UpdateEntityRelationsInput = {
  childId?: string | null,
  id: string,
};

export type UpdateEventRsvpInput = {
  createdAt?: string | null,
  eventStartTime?: string | null,
  meetupId?: string | null,
  owner: string,
  parentId: string,
  parentType?: EventRsvpParentType | null,
  socialProofId?: string | null,
  userProfileId?: string | null,
};

export type UpdateGiftRecipientInput = {
  buyerId?: string | null,
  createdAt?: string | null,
  email?: string | null,
  firstName?: string | null,
  id: string,
  lastName?: string | null,
  owner?: string | null,
  stripePriceId?: string | null,
  subscriptionId?: string | null,
};

export type UpdateGrowthCoinStatsInput = {
  currentMonth?: string | null,
  monthCoins?: number | null,
  owner: string,
  source: string,
  sourceEvent: string,
  totalCoins?: number | null,
  version?: number | null,
};

export type UpdateJournalInput = {
  customPrompts?: Array< string | null > | null,
  datetime?: string | null,
  id: string,
  images?: Array< JournalImageInput | null > | null,
  journalType?: JournalType | null,
  owner?: string | null,
  parentId?: string | null,
  responses?: Array< string | null > | null,
};

export type UpdateLeaderboardInput = {
  highestStreakCount?: number | null,
  highestStreakCountAndTotalCoinsCount?: string | null,
  month: string,
  owner: string,
  ranking?: number | null,
  totalCoinsCount?: number | null,
  totalLeadsCount?: number | null,
  totalReferralsCount?: number | null,
  totalReferralsCountAndTotalLeadsCount?: string | null,
  totalStreaksCount?: number | null,
  userProfileId?: string | null,
};

export type UpdateLeaderboardDashboardStreakInput = {
  dashboardStreakId?: string | null,
  id: string,
  month?: string | null,
  owner?: string | null,
};

export type UpdateMeetupInput = {
  agenda?: string | null,
  chatRoomId?: string | null,
  duration?: number | null,
  endTime?: string | null,
  hostReferralId?: string | null,
  liveState?: MeetupLiveState | null,
  owner?: string | null,
  recurrenceId?: string | null,
  recurrenceRule?: string | null,
  roomUrl?: string | null,
  rsvpCount?: number | null,
  slugId: string,
  startTime?: string | null,
  thumbnail?: MeetupThumbnailInput | null,
  title?: string | null,
  version?: number | null,
  visibility?: EntityVisibility | null,
};

export type UpdateMessageInput = {
  content?: string | null,
  createdAt?: string | null,
  id: string,
  isEdited?: boolean | null,
  mediaPosition?: number | null,
  metadata?: string | null,
  owner?: string | null,
  pinnedState?: MessagePinnedState | null,
  roomId?: string | null,
  type?: MessageType | null,
};

export type UpdateNoteInput = {
  content?: string | null,
  createdAt?: string | null,
  entityId: string,
  entityType?: EntityType | null,
  owner: string,
  parentId: string,
  parentType?: NoteParentType | null,
  pinnedState?: NotePinnedState | null,
};

export type UpdateNoteItemInput = {
  content?: string | null,
  entityId?: string | null,
  entityType?: EntityType | null,
  id: string,
  noteOwner?: string | null,
  parentId?: string | null,
  parentType?: NoteItemParentType | null,
  timestamp?: number | null,
};

export type UpdateNotificationLogInput = {
  challengeDayProgressId?: string | null,
  entityId?: string | null,
  id: string,
  meetupSlugId?: string | null,
  name?: NotificationLogName | null,
};

export type UpdateOfferingInput = {
  cta?: string | null,
  description?: string | null,
  heading?: string | null,
  id: string,
  image?: CdnImageInput | null,
  overrides?: OfferingOverridesInput | null,
  readableTitle?: string | null,
  redirectUrl?: string | null,
  shortDescription?: string | null,
  showGuarantee?: boolean | null,
  skipEmailCollectionStep?: boolean | null,
  step1Title?: string | null,
  step2Title?: string | null,
  type?: OfferingType | null,
};

export type UpdateOfferingProductInput = {
  id: string,
  offeringId?: string | null,
  productId?: string | null,
};

export type UpdateOfferingProductBundleInput = {
  id: string,
  offeringId?: string | null,
  overrides?: OfferingOverridesInput | null,
  productId?: string | null,
  readableTitle?: string | null,
};

export type UpdateOfferingStackInput = {
  id: string,
  offeringId?: string | null,
  orderBumpId?: string | null,
  readableTitle?: string | null,
};

export type UpdateOfferingStackUpsellInput = {
  id: string,
  offeringId?: string | null,
  offeringStackId?: string | null,
  upsellNoId?: string | null,
  upsellYesId?: string | null,
};

export type UpdateProductInput = {
  billingInterval?: ProductBillingInterval | null,
  businessUnit?: ProductBusinessUnit | null,
  description?: string | null,
  entitlements?: Array< EntitlementCustomTypeInput | null > | null,
  id: string,
  name?: string | null,
  priceId?: string | null,
  productCategory?: string | null,
  productId?: string | null,
  productNamespace?: string | null,
  store?: ProductStore | null,
  subscriptionGroup?: ProductSubscriptionGroup | null,
};

export type UpdateRecentlyPlayedInput = {
  children?: Array< RecentlyPlayedChildInput | null > | null,
  completeTime?: string | null,
  entityId?: string | null,
  entityType?: EntityType | null,
  id: string,
  images?: Array< EntityImageInput | null > | null,
  lastPlayedAt?: string | null,
  owner?: string | null,
  playbackPercentage?: number | null,
};

export type UpdateSocialProofInput = {
  commentsCount?: number | null,
  dashboardCardItemId?: string | null,
  entityId?: string | null,
  joinCount?: number | null,
  likesCount?: number | null,
  parentId: string,
  parentType?: SocialProofParentType | null,
  rsvpCount?: number | null,
  sharesCount?: number | null,
  version?: number | null,
  viewerCount?: number | null,
};

export type UpdateTeamInput = {
  id: string,
  invitationState?: TeamInvitationState | null,
  owner?: string | null,
  stripePriceId?: string | null,
  stripeProductId?: string | null,
  subscriptionId?: string | null,
  subscriptionItemId?: string | null,
  subscriptionState?: TeamSubscriptionState | null,
  totalSeats?: number | null,
  usedSeats?: number | null,
  version?: number | null,
};

export type UpdateTeamMemberInput = {
  email?: string | null,
  firstName?: string | null,
  id: string,
  lastName?: string | null,
  owner?: string | null,
  subscriptionState?: TeamSubscriptionState | null,
  teamId?: string | null,
};

export type UpdateUserExternalIdentifierInput = {
  externalIdentifier: string,
  owner: string,
  type?: UserExternalIdentifierType | null,
};

export type UpdateUserProfileInput = {
  attributes?: UserAttributesInput | null,
  badges?: UserProfileBadgesInput | null,
  bio?: string | null,
  cover?: CdnImageInput | null,
  createdAt?: string | null,
  displayName?: string | null,
  experimentMetadata?: UserProfileExperimentMetadataInput | null,
  owner: string,
  profileImage?: CdnImageInput | null,
  publicProfileId?: string | null,
  socialMediaLinks?: SocialMediaLinksInput | null,
  totalCoinsCount?: number | null,
};

export type UpdateUserSubscriptionInput = {
  expirationDate?: string | null,
  id: string,
  owner?: string | null,
  productId?: string | null,
  purchaseDate?: string | null,
  renewalDate?: string | null,
  status?: UserSubscriptionStatus | null,
  subscriptionId?: string | null,
};

export type UpdateUserTourInput = {
  completed?: boolean | null,
  completedAt?: string | null,
  id: string,
  owner?: string | null,
  type?: UserTourType | null,
};

export type UpdateUserTransactionInput = {
  currency?: string | null,
  id: string,
  owner?: string | null,
  price?: number | null,
  productId?: string | null,
  store?: string | null,
  transactionDate?: string | null,
  type?: UserTransactionType | null,
  userSubscriptionId?: string | null,
};

export type ModelSubscriptionAppNotificationFilterInput = {
  and?: Array< ModelSubscriptionAppNotificationFilterInput | null > | null,
  authorId?: ModelSubscriptionStringInput | null,
  content?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  deeplink?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  notificationType?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionAppNotificationFilterInput | null > | null,
  owner?: ModelStringInput | null,
  sourceId?: ModelSubscriptionIDInput | null,
  sourceType?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionStringInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  in?: Array< string | null > | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIDInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  in?: Array< string | null > | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionBookmarkFilterInput = {
  and?: Array< ModelSubscriptionBookmarkFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionBookmarkFilterInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelSubscriptionStringInput | null,
  parentType?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionChatRoomFilterInput = {
  and?: Array< ModelSubscriptionChatRoomFilterInput | null > | null,
  bannedUsers?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  entityId?: ModelSubscriptionIDInput | null,
  id?: ModelSubscriptionIDInput | null,
  moderators?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionChatRoomFilterInput | null > | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionCommentFilterInput = {
  and?: Array< ModelSubscriptionCommentFilterInput | null > | null,
  commentsCount?: ModelSubscriptionIntInput | null,
  content?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  isEdited?: ModelSubscriptionBooleanInput | null,
  likesCount?: ModelSubscriptionIntInput | null,
  or?: Array< ModelSubscriptionCommentFilterInput | null > | null,
  owner?: ModelStringInput | null,
  parentId?: ModelSubscriptionIDInput | null,
  parentType?: ModelSubscriptionStringInput | null,
  pinnedState?: ModelSubscriptionStringInput | null,
  threadId?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  visibility?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionIntInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  in?: Array< number | null > | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type ModelSubscriptionDashboardStreakFilterInput = {
  and?: Array< ModelSubscriptionDashboardStreakFilterInput | null > | null,
  count?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  lastActiveDate?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionDashboardStreakFilterInput | null > | null,
  owner?: ModelStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionEntityFilterInput = {
  and?: Array< ModelSubscriptionEntityFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  duration?: ModelSubscriptionFloatInput | null,
  enforceEntitlementsAt?: ModelSubscriptionIntInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  liveState?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionEntityFilterInput | null > | null,
  order?: ModelSubscriptionIntInput | null,
  parentId?: ModelSubscriptionIDInput | null,
  publishAt?: ModelSubscriptionStringInput | null,
  redirectId?: ModelSubscriptionIDInput | null,
  requiredEntitlements?: ModelSubscriptionStringInput | null,
  rootEntityId?: ModelSubscriptionIDInput | null,
  startTime?: ModelSubscriptionStringInput | null,
  tags?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  validUntil?: ModelSubscriptionStringInput | null,
  visibility?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionFloatInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  in?: Array< number | null > | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionGrowthCoinStatsFilterInput = {
  and?: Array< ModelSubscriptionGrowthCoinStatsFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  currentMonth?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  monthCoins?: ModelSubscriptionIntInput | null,
  or?: Array< ModelSubscriptionGrowthCoinStatsFilterInput | null > | null,
  owner?: ModelStringInput | null,
  source?: ModelSubscriptionStringInput | null,
  sourceEvent?: ModelSubscriptionStringInput | null,
  totalCoins?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionLeaderboardFilterInput = {
  and?: Array< ModelSubscriptionLeaderboardFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  highestStreakCount?: ModelSubscriptionIntInput | null,
  highestStreakCountAndTotalCoinsCount?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  month?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionLeaderboardFilterInput | null > | null,
  owner?: ModelStringInput | null,
  ranking?: ModelSubscriptionIntInput | null,
  totalCoinsCount?: ModelSubscriptionIntInput | null,
  totalLeadsCount?: ModelSubscriptionIntInput | null,
  totalReferralsCount?: ModelSubscriptionIntInput | null,
  totalReferralsCountAndTotalLeadsCount?: ModelSubscriptionStringInput | null,
  totalStreaksCount?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userProfileId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionMeetupFilterInput = {
  agenda?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMeetupFilterInput | null > | null,
  chatRoomId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  duration?: ModelSubscriptionFloatInput | null,
  endTime?: ModelSubscriptionStringInput | null,
  hostReferralId?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  liveState?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionMeetupFilterInput | null > | null,
  owner?: ModelStringInput | null,
  recurrenceId?: ModelSubscriptionStringInput | null,
  recurrenceRule?: ModelSubscriptionStringInput | null,
  roomUrl?: ModelSubscriptionStringInput | null,
  rsvpCount?: ModelSubscriptionIntInput | null,
  slugId?: ModelSubscriptionIDInput | null,
  startTime?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  visibility?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionMessageFilterInput = {
  and?: Array< ModelSubscriptionMessageFilterInput | null > | null,
  content?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  isEdited?: ModelSubscriptionBooleanInput | null,
  mediaPosition?: ModelSubscriptionIntInput | null,
  metadata?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionMessageFilterInput | null > | null,
  owner?: ModelStringInput | null,
  pinnedState?: ModelSubscriptionStringInput | null,
  roomId?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionRecentlyPlayedFilterInput = {
  and?: Array< ModelSubscriptionRecentlyPlayedFilterInput | null > | null,
  completeTime?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  entityId?: ModelSubscriptionIDInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  lastPlayedAt?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionRecentlyPlayedFilterInput | null > | null,
  owner?: ModelStringInput | null,
  playbackPercentage?: ModelSubscriptionFloatInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionSocialProofFilterInput = {
  and?: Array< ModelSubscriptionSocialProofFilterInput | null > | null,
  commentsCount?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  dashboardCardItemId?: ModelSubscriptionIDInput | null,
  entityId?: ModelSubscriptionIDInput | null,
  id?: ModelSubscriptionIDInput | null,
  joinCount?: ModelSubscriptionIntInput | null,
  likesCount?: ModelSubscriptionIntInput | null,
  or?: Array< ModelSubscriptionSocialProofFilterInput | null > | null,
  parentId?: ModelSubscriptionIDInput | null,
  parentType?: ModelSubscriptionStringInput | null,
  rsvpCount?: ModelSubscriptionIntInput | null,
  sharesCount?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  viewerCount?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionTeamMemberFilterInput = {
  and?: Array< ModelSubscriptionTeamMemberFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionTeamMemberFilterInput | null > | null,
  owner?: ModelStringInput | null,
  subscriptionState?: ModelSubscriptionStringInput | null,
  teamId?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type BrowseEntitiesQueryVariables = {
  entityType?: string | null,
  includePurchasedOnly?: boolean | null,
  liveState?: string | null,
  pageSize?: number | null,
  pageStart?: number | null,
  randomize?: boolean | null,
  sortDirection?: string | null,
  sortField?: string | null,
  tags?: Array< string | null > | null,
  tagsOperator?: BrowseEntitiesTagsOperator | null,
  userEntitlements?: Array< string | null > | null,
};

export type BrowseEntitiesQuery = {
  browseEntities?:  {
    __typename: "searchResults",
    hits?:  Array< {
      __typename: "searchHitEntity",
      _id?: string | null,
      _index?: string | null,
      _score?: number | null,
    } | null > | null,
    suggest?: string | null,
    took?: number | null,
    total?: number | null,
  } | null,
};

export type GetActiveViewSessionQueryVariables = {
  id: string,
};

export type GetActiveViewSessionQuery = {
  getActiveViewSession?:  {
    __typename: "ActiveViewSession",
    createdAt?: string | null,
    entityId: string,
    heartbeatCount: number,
    id: string,
    owner?: string | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    updatedAt?: string | null,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type GetAppNotificationQueryVariables = {
  id: string,
};

export type GetAppNotificationQuery = {
  getAppNotification?:  {
    __typename: "AppNotification",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    content?: string | null,
    createdAt?: string | null,
    deeplink?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    notificationType: AppNotificationType,
    owner: string,
    sourceId: string,
    sourceType?: AppNotificationSourceType | null,
    status: AppNotificationStatus,
    title: string,
    updatedAt?: string | null,
  } | null,
};

export type GetAssetQueryVariables = {
  id: string,
};

export type GetAssetQuery = {
  getAsset?:  {
    __typename: "Asset",
    assetType: AssetType,
    createdAt: string,
    description?: string | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    id: string,
    locator: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId?: string | null,
    title?: string | null,
    updatedAt: string,
  } | null,
};

export type GetBookmarkQueryVariables = {
  owner: string,
  parentId: string,
  parentType: string,
};

export type GetBookmarkQuery = {
  getBookmark?:  {
    __typename: "Bookmark",
    createdAt?: string | null,
    entityType?: string | null,
    owner: string,
    parentId: string,
    parentType: string,
    updatedAt: string,
  } | null,
};

export type GetCampaignQueryVariables = {
  id: string,
};

export type GetCampaignQuery = {
  getCampaign?:  {
    __typename: "Campaign",
    createdAt: string,
    id: string,
    isDefault?: boolean | null,
    offeringStack?:  {
      __typename: "OfferingStack",
      createdAt: string,
      id: string,
      offeringId: string,
      orderBumpId?: string | null,
      readableTitle: string,
      updatedAt: string,
    } | null,
    offeringStackId?: string | null,
    readableTitle: string,
    updatedAt: string,
  } | null,
};

export type GetChallengeProgressQueryVariables = {
  id: string,
};

export type GetChallengeProgressQuery = {
  getChallengeProgress?:  {
    __typename: "ChallengeProgress",
    children?:  Array< {
      __typename: "ChallengeDayProgress",
      coinsEarned?: number | null,
      completeTime?: string | null,
      entityId: string,
      id: string,
      startTime: string,
    } | null > | null,
    coinsEarned?: number | null,
    completeTime?: string | null,
    createdAt: string,
    endTime: string,
    entityId: string,
    id: string,
    owner?: string | null,
    startTime: string,
    type?: string | null,
    updatedAt: string,
  } | null,
};

export type GetChatRoomQueryVariables = {
  id: string,
};

export type GetChatRoomQuery = {
  getChatRoom?:  {
    __typename: "ChatRoom",
    bannedUsers?: Array< string | null > | null,
    createdAt?: string | null,
    entityId: string,
    id: string,
    messages?:  {
      __typename: "ModelMessageConnection",
      nextToken?: string | null,
    } | null,
    moderators?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type GetChecklistQueryVariables = {
  date: string,
  owner: string,
};

export type GetChecklistQuery = {
  getChecklist?:  {
    __typename: "Checklist",
    completed?: boolean | null,
    createdAt: string,
    date: string,
    items?:  Array< {
      __typename: "ItemCompletion",
      completed?: boolean | null,
      deleted?: boolean | null,
      itemId?: string | null,
      order?: number | null,
    } | null > | null,
    owner: string,
    started?: boolean | null,
    updatedAt: string,
  } | null,
};

export type GetChecklistItemQueryVariables = {
  id: string,
};

export type GetChecklistItemQuery = {
  getChecklistItem?:  {
    __typename: "ChecklistItem",
    createdAt: string,
    date: string,
    endDate?: string | null,
    frequency: ItemFrequency,
    id: string,
    order?: number | null,
    owner: string,
    title: string,
    updatedAt: string,
    weekday: DayOfWeek,
  } | null,
};

export type GetCommentQueryVariables = {
  id: string,
};

export type GetCommentQuery = {
  getComment?:  {
    __typename: "Comment",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    commentsCount?: number | null,
    content: string,
    createdAt?: string | null,
    id: string,
    images?:  Array< {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null > | null,
    isEdited?: boolean | null,
    likes?:  {
      __typename: "ModelCommentLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount?: number | null,
    owner?: string | null,
    parent?:  {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null,
    parentId: string,
    parentType?: CommentParentType | null,
    pinnedState?: CommentPinnedState | null,
    replies?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    threadId: string,
    type?: CommentType | null,
    updatedAt: string,
    version?: number | null,
    visibility: CommentVisibility,
  } | null,
};

export type GetCommentLikeQueryVariables = {
  id: string,
};

export type GetCommentLikeQuery = {
  getCommentLike?:  {
    __typename: "CommentLike",
    comment?:  {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null,
    commentId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    threadId: string,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type GetCommunityFeedQueryVariables = {
  feedType?: GetCommunityFeedFeedType | null,
  limit?: number | null,
  nextToken?: string | null,
  since?: string | null,
};

export type GetCommunityFeedQuery = {
  getCommunityFeed:  {
    __typename: "CommunityFeedResponse",
    interactionId?: string | null,
    items?:  Array< {
      __typename: "CommunityItem",
      authorId?: string | null,
      commentId: string,
      commentsCount?: number | null,
      content?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      isEdited?: boolean | null,
      likesCount?: number | null,
      parentId?: string | null,
      parentType?: CommunityItemParentType | null,
      pinnedState?: CommunityItemPinnedState | null,
    } | null > | null,
    nextToken?: string | null,
  },
};

export type GetCommunityItemQueryVariables = {
  commentId?: string | null,
};

export type GetCommunityItemQuery = {
  getCommunityItem?:  {
    __typename: "CommunityItem",
    authorId?: string | null,
    commentId: string,
    commentsCount?: number | null,
    content?: string | null,
    createdAt?: string | null,
    dashboardCardInfo?:  {
      __typename: "CommunityItemDashboardCardInfo",
      assessmentType?: CommunityItemDashboardCardInfoAssessmentType | null,
      customPrompt?: string | null,
      date?: string | null,
      type?: CommunityItemDashboardCardInfoType | null,
    } | null,
    displayName?: string | null,
    entityInfo?:  {
      __typename: "CommunityItemEntityInfo",
      description?: string | null,
      duration?: number | null,
      entityId?: string | null,
      entityType?: string | null,
      liveState?: EntityLiveState | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      title?: string | null,
    } | null,
    images?:  Array< {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null > | null,
    isEdited?: boolean | null,
    likesCount?: number | null,
    parentId?: string | null,
    parentType?: CommunityItemParentType | null,
    pinnedState?: CommunityItemPinnedState | null,
    profileImage?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
  } | null,
};

export type GetCourseCertificateQueryVariables = {
  entityId: string,
  owner: string,
};

export type GetCourseCertificateQuery = {
  getCourseCertificate?:  {
    __typename: "CourseCertificate",
    createdAt?: string | null,
    entityId: string,
    image:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    },
    owner: string,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type GetDailyLifescoreQueryVariables = {
  id: string,
};

export type GetDailyLifescoreQuery = {
  getDailyLifescore?:  {
    __typename: "DailyLifescore",
    averageScorePercentage: number,
    clarityScore: number,
    courageScore: number,
    createdAt?: string | null,
    energyScore: number,
    id: string,
    influenceScore: number,
    moodScore: number,
    movementScore: number,
    necessityScore: number,
    nutritionScore: number,
    owner?: string | null,
    parentId?: string | null,
    productivityScore: number,
    sleepScore: number,
    updatedAt: string,
  } | null,
};

export type GetDashboardCardQueryVariables = {
  date: string,
};

export type GetDashboardCardQuery = {
  getDashboardCard?:  {
    __typename: "DashboardCard",
    children?:  {
      __typename: "ModelDashboardCardItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    date: string,
    updatedAt: string,
  } | null,
};

export type GetDashboardCardItemQueryVariables = {
  id: string,
};

export type GetDashboardCardItemQuery = {
  getDashboardCardItem?:  {
    __typename: "DashboardCardItem",
    assessmentType?: DashboardCardItemAssessmentType | null,
    createdAt: string,
    customPrompt?: string | null,
    date: string,
    entityHasEntitlements?: boolean | null,
    entityId?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    nonEntitledEntityId?: string | null,
    order: number,
    parent?:  {
      __typename: "DashboardCard",
      createdAt: string,
      date: string,
      updatedAt: string,
    } | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    type?: DashboardCardItemType | null,
    updatedAt: string,
  } | null,
};

export type GetDashboardProgressQueryVariables = {
  date: string,
  owner: string,
};

export type GetDashboardProgressQuery = {
  getDashboardProgress?:  {
    __typename: "DashboardProgress",
    children?:  Array< {
      __typename: "DashboardProgressItem",
      completeTime?: string | null,
      parentId: string,
      upsellRejected?: boolean | null,
    } > | null,
    completeTime?: string | null,
    createdAt: string,
    date: string,
    owner: string,
    updatedAt: string,
  } | null,
};

export type GetDashboardStreakQueryVariables = {
  id: string,
};

export type GetDashboardStreakQuery = {
  getDashboardStreak?:  {
    __typename: "DashboardStreak",
    count: number,
    createdAt: string,
    id: string,
    lastActiveDate: string,
    leaderboards?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    startDate: string,
    updatedAt: string,
  } | null,
};

export type GetDelphiJWTQueryVariables = {
};

export type GetDelphiJWTQuery = {
  getDelphiJWT?:  {
    __typename: "GetDelphiJWTReturnType",
    token?: string | null,
  } | null,
};

export type GetEntitlementsQueryVariables = {
};

export type GetEntitlementsQuery = {
  getEntitlements?:  {
    __typename: "RevenueCatEntitlementResponse",
    requestDate: string,
    subscriber:  {
      __typename: "RevenueCatSubscriber",
      entitlements?: string | null,
      firstSeen?: string | null,
      managementUrl?: string | null,
      nonSubscriptions?: string | null,
      originalAppUserId?: string | null,
      originalApplicationVersion?: string | null,
      originalPurchaseDate?: string | null,
      otherPurchases?: string | null,
      subscriptions?: string | null,
    },
  } | null,
};

export type GetEntityQueryVariables = {
  id: string,
};

export type GetEntityQuery = {
  getEntity?:  {
    __typename: "Entity",
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    description?: string | null,
    duration?: number | null,
    enforceEntitlementsAt?: number | null,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    liveState?: EntityLiveState | null,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    order?: number | null,
    parent?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    parentId?: string | null,
    publishAt?: string | null,
    redirectId?: string | null,
    requiredEntitlements?: Array< string | null > | null,
    rootEntityId?: string | null,
    shareContent?:  {
      __typename: "EntityShareContent",
      description?: string | null,
      title?: string | null,
    } | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    startTime?: string | null,
    tags?: Array< string | null > | null,
    title: string,
    updatedAt: string,
    validUntil?: string | null,
    visibility: EntityVisibility,
  } | null,
};

export type GetEntityLikeQueryVariables = {
  id: string,
};

export type GetEntityLikeQuery = {
  getEntityLike?:  {
    __typename: "EntityLike",
    createdAt: string,
    entityId: string,
    id: string,
    owner?: string | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type GetEntityRelationsQueryVariables = {
  id: string,
};

export type GetEntityRelationsQuery = {
  getEntityRelations?:  {
    __typename: "EntityRelations",
    childId: string,
    createdAt: string,
    entities?:  {
      __typename: "ModelEntityConnection",
      nextToken?: string | null,
    } | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    id: string,
    updatedAt: string,
  } | null,
};

export type GetEventRsvpQueryVariables = {
  owner: string,
  parentId: string,
};

export type GetEventRsvpQuery = {
  getEventRsvp?:  {
    __typename: "EventRsvp",
    createdAt?: string | null,
    eventStartTime: string,
    meetup?:  {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null,
    meetupId?: string | null,
    owner: string,
    parentId: string,
    parentType?: EventRsvpParentType | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    socialProofId?: string | null,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type GetGiftRecipientQueryVariables = {
  id: string,
};

export type GetGiftRecipientQuery = {
  getGiftRecipient?:  {
    __typename: "GiftRecipient",
    buyerId: string,
    createdAt?: string | null,
    email?: string | null,
    firstName?: string | null,
    id: string,
    lastName?: string | null,
    owner: string,
    stripePriceId?: string | null,
    subscriptionId?: string | null,
    updatedAt: string,
  } | null,
};

export type GetGrowthCoinStatsQueryVariables = {
  owner: string,
  source: string,
  sourceEvent: string,
};

export type GetGrowthCoinStatsQuery = {
  getGrowthCoinStats?:  {
    __typename: "GrowthCoinStats",
    createdAt: string,
    currentMonth: string,
    monthCoins: number,
    owner: string,
    source: string,
    sourceEvent: string,
    totalCoins: number,
    updatedAt: string,
    version?: number | null,
  } | null,
};

export type GetGrowthCoinTransactionQueryVariables = {
  id: string,
};

export type GetGrowthCoinTransactionQuery = {
  getGrowthCoinTransaction?:  {
    __typename: "GrowthCoinTransaction",
    coinsAdded: number,
    createdAt?: string | null,
    endBalance: number,
    id: string,
    owner?: string | null,
    source: GrowthCoinTransactionSource,
    sourceEvent: GrowthCoinTransactionSourceEvent,
    startBalance: number,
    updatedAt: string,
  } | null,
};

export type GetJournalQueryVariables = {
  id: string,
};

export type GetJournalQuery = {
  getJournal?:  {
    __typename: "Journal",
    createdAt: string,
    customPrompts?: Array< string | null > | null,
    datetime: string,
    id: string,
    images?:  Array< {
      __typename: "JournalImage",
      height?: number | null,
      s3Key: string,
      width?: number | null,
    } | null > | null,
    journalType: JournalType,
    owner?: string | null,
    parentId?: string | null,
    responses?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type GetLeaderboardQueryVariables = {
  month: string,
  owner: string,
};

export type GetLeaderboardQuery = {
  getLeaderboard?:  {
    __typename: "Leaderboard",
    createdAt: string,
    dashboardStreaks?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    highestStreakCount: number,
    highestStreakCountAndTotalCoinsCount: string,
    month: string,
    owner: string,
    profile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    ranking?: number | null,
    totalCoinsCount: number,
    totalLeadsCount?: number | null,
    totalReferralsCount: number,
    totalReferralsCountAndTotalLeadsCount?: string | null,
    totalStreaksCount: number,
    updatedAt: string,
    userProfileId: string,
  } | null,
};

export type GetLeaderboardDashboardStreakQueryVariables = {
  id: string,
};

export type GetLeaderboardDashboardStreakQuery = {
  getLeaderboardDashboardStreak?:  {
    __typename: "LeaderboardDashboardStreak",
    createdAt: string,
    dashboardStreak?:  {
      __typename: "DashboardStreak",
      count: number,
      createdAt: string,
      id: string,
      lastActiveDate: string,
      owner: string,
      startDate: string,
      updatedAt: string,
    } | null,
    dashboardStreakId: string,
    id: string,
    leaderboard?:  {
      __typename: "Leaderboard",
      createdAt: string,
      highestStreakCount: number,
      highestStreakCountAndTotalCoinsCount: string,
      month: string,
      owner: string,
      ranking?: number | null,
      totalCoinsCount: number,
      totalLeadsCount?: number | null,
      totalReferralsCount: number,
      totalReferralsCountAndTotalLeadsCount?: string | null,
      totalStreaksCount: number,
      updatedAt: string,
      userProfileId: string,
    } | null,
    month: string,
    owner: string,
    updatedAt: string,
  } | null,
};

export type GetMeetupQueryVariables = {
  slugId: string,
};

export type GetMeetupQuery = {
  getMeetup?:  {
    __typename: "Meetup",
    agenda: string,
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    chatRoomId?: string | null,
    createdAt: string,
    duration: number,
    endTime: string,
    hostReferralId?: string | null,
    liveState: MeetupLiveState,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    recurrenceId?: string | null,
    recurrenceRule?: string | null,
    roomUrl?: string | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    slugId: string,
    startTime: string,
    thumbnail?:  {
      __typename: "MeetupThumbnail",
      height?: number | null,
      url: string,
      width?: number | null,
    } | null,
    title: string,
    updatedAt: string,
    version?: number | null,
    visibility: EntityVisibility,
  } | null,
};

export type GetMessageQueryVariables = {
  id: string,
};

export type GetMessageQuery = {
  getMessage?:  {
    __typename: "Message",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    content: string,
    createdAt?: string | null,
    id: string,
    isEdited?: boolean | null,
    mediaPosition: number,
    metadata?: string | null,
    owner?: string | null,
    pinnedState?: MessagePinnedState | null,
    room?:  {
      __typename: "ChatRoom",
      bannedUsers?: Array< string | null > | null,
      createdAt?: string | null,
      entityId: string,
      id: string,
      moderators?: Array< string | null > | null,
      updatedAt: string,
    } | null,
    roomId: string,
    type: MessageType,
    updatedAt: string,
  } | null,
};

export type GetMonthReferralStatsQueryVariables = {
  month?: string | null,
};

export type GetMonthReferralStatsQuery = {
  getMonthReferralStats?:  {
    __typename: "ReferralStats",
    activeCustomersCount: number,
    cancellationsCount: number,
    clicksCount: number,
    customersCount: number,
    earnings: number,
    leadsCount: number,
    paidEarnings: number,
    refundsCount: number,
  } | null,
};

export type GetMonthlyLifescoreQueryVariables = {
  id: string,
};

export type GetMonthlyLifescoreQuery = {
  getMonthlyLifescore?:  {
    __typename: "MonthlyLifescore",
    averageScorePercentage: number,
    createdAt?: string | null,
    experienceScore: number,
    familyScore: number,
    financeScore: number,
    friendScore: number,
    healthScore: number,
    id: string,
    learningScore: number,
    mentalAndEmotionalScore: number,
    missionScore: number,
    owner?: string | null,
    parentId?: string | null,
    partnerAndLoveScore: number,
    spiritScore: number,
    updatedAt: string,
  } | null,
};

export type GetNoteQueryVariables = {
  entityId: string,
  owner: string,
  parentId: string,
};

export type GetNoteQuery = {
  getNote?:  {
    __typename: "Note",
    content: string,
    createdAt?: string | null,
    entityId: string,
    entityType?: EntityType | null,
    noteItems?:  {
      __typename: "ModelNoteItemConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    parentId: string,
    parentType?: NoteParentType | null,
    pinnedState?: NotePinnedState | null,
    updatedAt: string,
  } | null,
};

export type GetNoteItemQueryVariables = {
  id: string,
};

export type GetNoteItemQuery = {
  getNoteItem?:  {
    __typename: "NoteItem",
    content: string,
    createdAt: string,
    entityId: string,
    entityType?: EntityType | null,
    id: string,
    note?:  {
      __typename: "Note",
      content: string,
      createdAt?: string | null,
      entityId: string,
      entityType?: EntityType | null,
      owner: string,
      parentId: string,
      parentType?: NoteParentType | null,
      pinnedState?: NotePinnedState | null,
      updatedAt: string,
    } | null,
    noteOwner: string,
    owner?: string | null,
    parentId: string,
    parentType?: NoteItemParentType | null,
    timestamp: number,
    updatedAt: string,
  } | null,
};

export type GetNotificationLogQueryVariables = {
  id: string,
};

export type GetNotificationLogQuery = {
  getNotificationLog?:  {
    __typename: "NotificationLog",
    challengeDayProgressId?: string | null,
    createdAt: string,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    id: string,
    meetup?:  {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null,
    meetupSlugId?: string | null,
    name?: NotificationLogName | null,
    updatedAt: string,
  } | null,
};

export type GetOfferingQueryVariables = {
  id: string,
};

export type GetOfferingQuery = {
  getOffering?:  {
    __typename: "Offering",
    createdAt: string,
    cta?: string | null,
    description?: string | null,
    heading?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    media?:  {
      __typename: "Asset",
      assetType: AssetType,
      createdAt: string,
      description?: string | null,
      entityId?: string | null,
      id: string,
      locator: string,
      offeringId?: string | null,
      title?: string | null,
      updatedAt: string,
    } | null,
    offeringStackOfferings?:  {
      __typename: "ModelOfferingStackConnection",
      nextToken?: string | null,
    } | null,
    offeringStackOrderBumps?:  {
      __typename: "ModelOfferingStackConnection",
      nextToken?: string | null,
    } | null,
    offeringStackUpsellOfferings?:  {
      __typename: "ModelOfferingStackUpsellConnection",
      nextToken?: string | null,
    } | null,
    overrides?:  {
      __typename: "OfferingOverrides",
      skipCreditCard?: boolean | null,
      trialDuration?: number | null,
      trialFrequency?: OfferingOverridesTrialFrequency | null,
    } | null,
    productBundle?:  {
      __typename: "ModelOfferingProductBundleConnection",
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOfferingProductConnection",
      nextToken?: string | null,
    } | null,
    readableTitle: string,
    redirectUrl?: string | null,
    shortDescription?: string | null,
    showGuarantee?: boolean | null,
    skipEmailCollectionStep?: boolean | null,
    step1Title?: string | null,
    step2Title?: string | null,
    type?: OfferingType | null,
    updatedAt: string,
  } | null,
};

export type GetOfferingProductQueryVariables = {
  id: string,
};

export type GetOfferingProductQuery = {
  getOfferingProduct?:  {
    __typename: "OfferingProduct",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    updatedAt: string,
  } | null,
};

export type GetOfferingProductBundleQueryVariables = {
  id: string,
};

export type GetOfferingProductBundleQuery = {
  getOfferingProductBundle?:  {
    __typename: "OfferingProductBundle",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    overrides?:  {
      __typename: "OfferingOverrides",
      skipCreditCard?: boolean | null,
      trialDuration?: number | null,
      trialFrequency?: OfferingOverridesTrialFrequency | null,
    } | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    readableTitle: string,
    updatedAt: string,
  } | null,
};

export type GetOfferingStackQueryVariables = {
  id: string,
};

export type GetOfferingStackQuery = {
  getOfferingStack?:  {
    __typename: "OfferingStack",
    campaign?:  {
      __typename: "ModelCampaignConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    orderBump?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    orderBumpId?: string | null,
    readableTitle: string,
    updatedAt: string,
    upsell?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
  } | null,
};

export type GetOfferingStackUpsellQueryVariables = {
  id: string,
};

export type GetOfferingStackUpsellQuery = {
  getOfferingStackUpsell?:  {
    __typename: "OfferingStackUpsell",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    offeringStack?:  {
      __typename: "OfferingStack",
      createdAt: string,
      id: string,
      offeringId: string,
      orderBumpId?: string | null,
      readableTitle: string,
      updatedAt: string,
    } | null,
    offeringStackId?: string | null,
    updatedAt: string,
    upsellNo?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellNoId?: string | null,
    upsellNoParent?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellYes?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellYesId?: string | null,
    upsellYesParent?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
  } | null,
};

export type GetPaymentMethodQueryVariables = {
};

export type GetPaymentMethodQuery = {
  getPaymentMethod?:  {
    __typename: "PaymentMethod",
    address?:  {
      __typename: "Address",
      city?: string | null,
      country?: string | null,
      line1?: string | null,
      line2?: string | null,
      state?: string | null,
      zip?: string | null,
    } | null,
    brand: string,
    expMonth: number,
    expYear: number,
    id: string,
    last4: string,
    name?: string | null,
  } | null,
};

export type GetPlaybackMediaQueryVariables = {
  assetType: string,
  locator: string,
};

export type GetPlaybackMediaQuery = {
  getPlaybackMedia?:  {
    __typename: "PlaybackMedia",
    poster?: string | null,
    src: string,
    thumbPreview?:  {
      __typename: "ThumbPreview",
      duration: number,
      frameCount: number,
      frameHeight: number,
      frameWidth: number,
      height: number,
      url: string,
      width: number,
    } | null,
    tracks?:  Array< {
      __typename: "Track",
      content?: string | null,
      isDefault?: boolean | null,
      kind?: string | null,
      label: string,
      lang: string,
      src?: string | null,
      trackType?: string | null,
    } | null > | null,
  } | null,
};

export type GetProductQueryVariables = {
  id: string,
};

export type GetProductQuery = {
  getProduct?:  {
    __typename: "Product",
    billingInterval?: ProductBillingInterval | null,
    businessUnit?: ProductBusinessUnit | null,
    createdAt: string,
    description?: string | null,
    entitlements?:  Array< {
      __typename: "EntitlementCustomType",
      identifier: string,
      revenueCatEntitlementId?: string | null,
    } | null > | null,
    id: string,
    name: string,
    offerings?:  {
      __typename: "ModelOfferingProductConnection",
      nextToken?: string | null,
    } | null,
    priceId?: string | null,
    productBundle?:  {
      __typename: "ModelOfferingProductBundleConnection",
      nextToken?: string | null,
    } | null,
    productCategory?: string | null,
    productId: string,
    productNamespace: string,
    store?: ProductStore | null,
    subscriptionGroup?: ProductSubscriptionGroup | null,
    updatedAt: string,
    userSubscriptions?:  {
      __typename: "ModelUserSubscriptionConnection",
      nextToken?: string | null,
    } | null,
    userTransactions?:  {
      __typename: "ModelUserTransactionConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type GetRecentlyPlayedQueryVariables = {
  id: string,
};

export type GetRecentlyPlayedQuery = {
  getRecentlyPlayed?:  {
    __typename: "RecentlyPlayed",
    children?:  Array< {
      __typename: "RecentlyPlayedChild",
      completeTime?: string | null,
      entityId?: string | null,
      lastPlayedAt: string,
      playbackPercentage: number,
    } | null > | null,
    completeTime?: string | null,
    createdAt: string,
    entityId: string,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    lastPlayedAt: string,
    owner?: string | null,
    playbackPercentage: number,
    updatedAt: string,
  } | null,
};

export type GetRecommendationsQueryVariables = {
  entityTypes?: Array< string | null > | null,
  itemId?: string | null,
  numResults?: number | null,
  recommenderType?: GetRecommendationsRecommenderType | null,
  tags?: Array< string | null > | null,
};

export type GetRecommendationsQuery = {
  getRecommendations:  {
    __typename: "RecommendedResult",
    items?:  Array< {
      __typename: "RecommendedItem",
      createdAt?: string | null,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      recommendationId?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt?: string | null,
      validUntil?: string | null,
      visibility?: EntityVisibility | null,
    } | null > | null,
    recommendationId?: string | null,
  },
};

export type GetReferralEarningsSummaryQueryVariables = {
  startDate?: string | null,
};

export type GetReferralEarningsSummaryQuery = {
  getReferralEarningsSummary?:  {
    __typename: "ReferralEarningsSummary",
    currentMonthEarnings: number,
    nextPayDay: string,
    totalCustomerCount: number,
    totalEarningsPaid: number,
    totalLeadsCount: number,
    totalVisitorCount: number,
    transactions:  Array< {
      __typename: "ReferralTransactionDetail",
      customerCount: number,
      earnings: number,
      leadsCount: number,
      transactionMonth: string,
      visitorCount: number,
    } >,
  } | null,
};

export type GetReferralProfileQueryVariables = {
};

export type GetReferralProfileQuery = {
  getReferralProfile?:  {
    __typename: "ReferralProfile",
    activeCustomersCount: number,
    cancellationsCount: number,
    clicksCount: number,
    customersCount: number,
    earnings: number,
    leadsCount: number,
    nextPayDay: string,
    paidEarnings: number,
    paypalEmail?: string | null,
    referralCode: string,
    refundsCount: number,
    remainingBalance: number,
  } | null,
};

export type GetSocialProofQueryVariables = {
  parentId: string,
};

export type GetSocialProofQuery = {
  getSocialProof?:  {
    __typename: "SocialProof",
    commentsCount?: number | null,
    createdAt: string,
    dashboardCardItem?:  {
      __typename: "DashboardCardItem",
      assessmentType?: DashboardCardItemAssessmentType | null,
      createdAt: string,
      customPrompt?: string | null,
      date: string,
      entityHasEntitlements?: boolean | null,
      entityId?: string | null,
      id: string,
      nonEntitledEntityId?: string | null,
      order: number,
      type?: DashboardCardItemType | null,
      updatedAt: string,
    } | null,
    dashboardCardItemId?: string | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    entityLikes?:  {
      __typename: "ModelEntityLikeConnection",
      nextToken?: string | null,
    } | null,
    joinCount?: number | null,
    likesCount?: number | null,
    parentId: string,
    parentType?: SocialProofParentType | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    sharesCount?: number | null,
    updatedAt: string,
    version?: number | null,
    viewSessions?:  {
      __typename: "ModelActiveViewSessionConnection",
      nextToken?: string | null,
    } | null,
    viewerCount?: number | null,
  } | null,
};

export type GetStripeExternalSubscriptionsQueryVariables = {
};

export type GetStripeExternalSubscriptionsQuery = {
  getStripeExternalSubscriptions:  Array< {
    __typename: "StripeSubscription",
    canceledAt?: string | null,
    createdAt?: string | null,
    endedAt?: string | null,
    id: string,
    item:  {
      __typename: "StripePurchaseLineItem",
      amount: number,
      currency: string,
      id: string,
      interval?: StripePurchaseLineItemInterval | null,
      name: string,
      priceId: string,
      quantity: number,
    },
    periodEnd?: string | null,
    periodStart?: string | null,
    product:  {
      __typename: "ProductCustomType",
      billingInterval?: ProductCustomTypeBillingInterval | null,
      businessUnit?: ProductCustomTypeBusinessUnit | null,
      description?: string | null,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductCustomTypeStore | null,
      subscriptionGroup?: ProductCustomTypeSubscriptionGroup | null,
    },
    scheduleId?: string | null,
    startDate?: string | null,
    status?: StripeSubscriptionStatus | null,
    trialEnd?: string | null,
    trialStart?: string | null,
    type?: StripeSubscriptionType | null,
  } | null >,
};

export type GetStripePriceQueryVariables = {
  stripePriceId: string,
};

export type GetStripePriceQuery = {
  getStripePrice:  {
    __typename: "StripePrice",
    amount: number,
    currency: string,
    id: string,
    interval?: StripePriceInterval | null,
    name: string,
    productId: string,
  },
};

export type GetStripeScheduledSubscriptionQueryVariables = {
  scheduleId: string,
};

export type GetStripeScheduledSubscriptionQuery = {
  getStripeScheduledSubscription?:  {
    __typename: "StripeSubscriptionSchedule",
    canceledAt?: string | null,
    createdAt?: string | null,
    id: string,
    item:  {
      __typename: "StripePurchaseLineItem",
      amount: number,
      currency: string,
      id: string,
      interval?: StripePurchaseLineItemInterval | null,
      name: string,
      priceId: string,
      quantity: number,
    },
    periodEnd?: string | null,
    periodStart?: string | null,
    product:  {
      __typename: "ProductCustomType",
      billingInterval?: ProductCustomTypeBillingInterval | null,
      businessUnit?: ProductCustomTypeBusinessUnit | null,
      description?: string | null,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductCustomTypeStore | null,
      subscriptionGroup?: ProductCustomTypeSubscriptionGroup | null,
    },
    releasedAt?: string | null,
    status?: StripeSubscriptionScheduleStatus | null,
  } | null,
};

export type GetStripeSubscriptionProratedAmountQueryVariables = {
  newQuantity: number,
  stripePriceId: string,
  subscriptionId: string,
  subscriptionItemId: string,
};

export type GetStripeSubscriptionProratedAmountQuery = {
  getStripeSubscriptionProratedAmount?:  {
    __typename: "StripeSubscriptionProratedAmount",
    currency?: string | null,
    subTotalInCents?: number | null,
    taxInCents?: number | null,
    totalInCents?: number | null,
  } | null,
};

export type GetStripeSubscriptionsQueryVariables = {
};

export type GetStripeSubscriptionsQuery = {
  getStripeSubscriptions:  Array< {
    __typename: "StripeSubscription",
    canceledAt?: string | null,
    createdAt?: string | null,
    endedAt?: string | null,
    id: string,
    item:  {
      __typename: "StripePurchaseLineItem",
      amount: number,
      currency: string,
      id: string,
      interval?: StripePurchaseLineItemInterval | null,
      name: string,
      priceId: string,
      quantity: number,
    },
    periodEnd?: string | null,
    periodStart?: string | null,
    product:  {
      __typename: "ProductCustomType",
      billingInterval?: ProductCustomTypeBillingInterval | null,
      businessUnit?: ProductCustomTypeBusinessUnit | null,
      description?: string | null,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductCustomTypeStore | null,
      subscriptionGroup?: ProductCustomTypeSubscriptionGroup | null,
    },
    scheduleId?: string | null,
    startDate?: string | null,
    status?: StripeSubscriptionStatus | null,
    trialEnd?: string | null,
    trialStart?: string | null,
    type?: StripeSubscriptionType | null,
  } | null >,
};

export type GetStripeTransactionsQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
};

export type GetStripeTransactionsQuery = {
  getStripeTransactions?:  {
    __typename: "StripeTransactionsResponse",
    items:  Array< {
      __typename: "StripeTransaction",
      amount: number,
      currency: string,
      date: string,
      description: string,
      id: string,
      invoicePdfUrl?: string | null,
      status?: StripeTransactionStatus | null,
      tax: number,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTeamQueryVariables = {
  id: string,
};

export type GetTeamQuery = {
  getTeam?:  {
    __typename: "Team",
    createdAt: string,
    id: string,
    invitationState?: TeamInvitationState | null,
    members?:  {
      __typename: "ModelTeamMemberConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    subscriptionId?: string | null,
    subscriptionItemId?: string | null,
    subscriptionState?: TeamSubscriptionState | null,
    totalSeats?: number | null,
    updatedAt: string,
    usedSeats?: number | null,
    version?: number | null,
  } | null,
};

export type GetTeamMemberQueryVariables = {
  id: string,
};

export type GetTeamMemberQuery = {
  getTeamMember?:  {
    __typename: "TeamMember",
    createdAt: string,
    email?: string | null,
    firstName?: string | null,
    id: string,
    lastName?: string | null,
    owner: string,
    subscriptionState?: TeamSubscriptionState | null,
    team?:  {
      __typename: "Team",
      createdAt: string,
      id: string,
      invitationState?: TeamInvitationState | null,
      owner: string,
      stripePriceId?: string | null,
      stripeProductId?: string | null,
      subscriptionId?: string | null,
      subscriptionItemId?: string | null,
      subscriptionState?: TeamSubscriptionState | null,
      totalSeats?: number | null,
      updatedAt: string,
      usedSeats?: number | null,
      version?: number | null,
    } | null,
    teamId: string,
    updatedAt: string,
  } | null,
};

export type GetUserExternalIdentifierQueryVariables = {
  externalIdentifier: string,
  owner: string,
};

export type GetUserExternalIdentifierQuery = {
  getUserExternalIdentifier?:  {
    __typename: "UserExternalIdentifier",
    createdAt: string,
    externalIdentifier: string,
    owner: string,
    type?: UserExternalIdentifierType | null,
    updatedAt: string,
  } | null,
};

export type GetUserProfileQueryVariables = {
  owner: string,
};

export type GetUserProfileQuery = {
  getUserProfile?:  {
    __typename: "UserProfile",
    activeViewSessions?:  {
      __typename: "ModelActiveViewSessionConnection",
      nextToken?: string | null,
    } | null,
    attributes?:  {
      __typename: "UserAttributes",
      intents?: Array< string | null > | null,
      surveyCustCategory?: UserAttributesSurveyCustCategory | null,
      surveyInterests?: Array< string | null > | null,
    } | null,
    badges?:  {
      __typename: "UserProfileBadges",
      chpc?: boolean | null,
      growthday?: boolean | null,
      ultra?: boolean | null,
    } | null,
    bio?: string | null,
    certificates?:  {
      __typename: "ModelCourseCertificateConnection",
      nextToken?: string | null,
    } | null,
    commentLikes?:  {
      __typename: "ModelCommentLikeConnection",
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    cover?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    createdAt?: string | null,
    displayName?: string | null,
    entityLikes?:  {
      __typename: "ModelEntityLikeConnection",
      nextToken?: string | null,
    } | null,
    experimentMetadata?:  {
      __typename: "UserProfileExperimentMetadata",
      mozartUser?: boolean | null,
    } | null,
    leaderboards?:  {
      __typename: "ModelLeaderboardConnection",
      nextToken?: string | null,
    } | null,
    meetups?:  {
      __typename: "ModelMeetupConnection",
      nextToken?: string | null,
    } | null,
    messages?:  {
      __typename: "ModelMessageConnection",
      nextToken?: string | null,
    } | null,
    notifications?:  {
      __typename: "ModelAppNotificationConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    profileImage?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    publicProfileId: string,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    socialMediaLinks?:  {
      __typename: "SocialMediaLinks",
      facebook?: string | null,
      instagram?: string | null,
      linkedin?: string | null,
      website?: string | null,
      x?: string | null,
    } | null,
    totalCoinsCount?: number | null,
    updatedAt: string,
  } | null,
};

export type GetUserSubscriptionQueryVariables = {
  id: string,
};

export type GetUserSubscriptionQuery = {
  getUserSubscription?:  {
    __typename: "UserSubscription",
    createdAt: string,
    expirationDate?: string | null,
    id: string,
    owner?: string | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    purchaseDate?: string | null,
    renewalDate?: string | null,
    status?: UserSubscriptionStatus | null,
    subscriptionId: string,
    updatedAt: string,
    userTransactions?:  {
      __typename: "ModelUserTransactionConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type GetUserTourQueryVariables = {
  id: string,
};

export type GetUserTourQuery = {
  getUserTour?:  {
    __typename: "UserTour",
    completed?: boolean | null,
    completedAt?: string | null,
    createdAt: string,
    id: string,
    owner: string,
    type: UserTourType,
    updatedAt: string,
  } | null,
};

export type GetUserTransactionQueryVariables = {
  id: string,
};

export type GetUserTransactionQuery = {
  getUserTransaction?:  {
    __typename: "UserTransaction",
    createdAt: string,
    currency?: string | null,
    id: string,
    owner?: string | null,
    price?: number | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    store: string,
    transactionDate: string,
    type?: UserTransactionType | null,
    updatedAt: string,
    userSubscription?:  {
      __typename: "UserSubscription",
      createdAt: string,
      expirationDate?: string | null,
      id: string,
      owner?: string | null,
      productId: string,
      purchaseDate?: string | null,
      renewalDate?: string | null,
      status?: UserSubscriptionStatus | null,
      subscriptionId: string,
      updatedAt: string,
    } | null,
    userSubscriptionId?: string | null,
  } | null,
};

export type GetWatchNextQueryVariables = {
  numResults?: number | null,
};

export type GetWatchNextQuery = {
  getWatchNext:  {
    __typename: "WatchNextResult",
    items?:  Array< {
      __typename: "WatchNextItem",
      description?: string | null,
      id: string,
      link: string,
      order?: number | null,
      recommendationId?: string | null,
      source: string,
      tags?: Array< string | null > | null,
      title: string,
    } | null > | null,
  },
};

export type ListActiveViewSessionByEntityIdAndUpdatedAtQueryVariables = {
  entityId: string,
  filter?: ModelActiveViewSessionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  updatedAt?: ModelStringKeyConditionInput | null,
};

export type ListActiveViewSessionByEntityIdAndUpdatedAtQuery = {
  listActiveViewSessionByEntityIdAndUpdatedAt?:  {
    __typename: "ModelActiveViewSessionConnection",
    items:  Array< {
      __typename: "ActiveViewSession",
      createdAt?: string | null,
      entityId: string,
      heartbeatCount: number,
      id: string,
      owner?: string | null,
      updatedAt?: string | null,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListActiveViewSessionByUserProfileIdQueryVariables = {
  filter?: ModelActiveViewSessionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userProfileId: string,
};

export type ListActiveViewSessionByUserProfileIdQuery = {
  listActiveViewSessionByUserProfileId?:  {
    __typename: "ModelActiveViewSessionConnection",
    items:  Array< {
      __typename: "ActiveViewSession",
      createdAt?: string | null,
      entityId: string,
      heartbeatCount: number,
      id: string,
      owner?: string | null,
      updatedAt?: string | null,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListActiveViewSessionsQueryVariables = {
  filter?: ModelActiveViewSessionFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListActiveViewSessionsQuery = {
  listActiveViewSessions?:  {
    __typename: "ModelActiveViewSessionConnection",
    items:  Array< {
      __typename: "ActiveViewSession",
      createdAt?: string | null,
      entityId: string,
      heartbeatCount: number,
      id: string,
      owner?: string | null,
      updatedAt?: string | null,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAppNotificationByOwnerAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAppNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListAppNotificationByOwnerAndCreatedAtQuery = {
  listAppNotificationByOwnerAndCreatedAt?:  {
    __typename: "ModelAppNotificationConnection",
    items:  Array< {
      __typename: "AppNotification",
      authorId?: string | null,
      content?: string | null,
      createdAt?: string | null,
      deeplink?: string | null,
      id: string,
      notificationType: AppNotificationType,
      owner: string,
      sourceId: string,
      sourceType?: AppNotificationSourceType | null,
      status: AppNotificationStatus,
      title: string,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAppNotificationByOwnerAndStatusAndCreatedAtQueryVariables = {
  filter?: ModelAppNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
  statusCreatedAt?: ModelAppNotificationAppNotificationsByOwnerAndStatusAndCreatedAtCompositeKeyConditionInput | null,
};

export type ListAppNotificationByOwnerAndStatusAndCreatedAtQuery = {
  listAppNotificationByOwnerAndStatusAndCreatedAt?:  {
    __typename: "ModelAppNotificationConnection",
    items:  Array< {
      __typename: "AppNotification",
      authorId?: string | null,
      content?: string | null,
      createdAt?: string | null,
      deeplink?: string | null,
      id: string,
      notificationType: AppNotificationType,
      owner: string,
      sourceId: string,
      sourceType?: AppNotificationSourceType | null,
      status: AppNotificationStatus,
      title: string,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssetByEntityIdQueryVariables = {
  entityId: string,
  filter?: ModelAssetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAssetByEntityIdQuery = {
  listAssetByEntityId?:  {
    __typename: "ModelAssetConnection",
    items:  Array< {
      __typename: "Asset",
      assetType: AssetType,
      createdAt: string,
      description?: string | null,
      entityId?: string | null,
      id: string,
      locator: string,
      offeringId?: string | null,
      title?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssetByOfferingIdQueryVariables = {
  filter?: ModelAssetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  offeringId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListAssetByOfferingIdQuery = {
  listAssetByOfferingId?:  {
    __typename: "ModelAssetConnection",
    items:  Array< {
      __typename: "Asset",
      assetType: AssetType,
      createdAt: string,
      description?: string | null,
      entityId?: string | null,
      id: string,
      locator: string,
      offeringId?: string | null,
      title?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssetsQueryVariables = {
  filter?: ModelAssetFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssetsQuery = {
  listAssets?:  {
    __typename: "ModelAssetConnection",
    items:  Array< {
      __typename: "Asset",
      assetType: AssetType,
      createdAt: string,
      description?: string | null,
      entityId?: string | null,
      id: string,
      locator: string,
      offeringId?: string | null,
      title?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBookmarkByOwnerAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelBookmarkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListBookmarkByOwnerAndCreatedAtQuery = {
  listBookmarkByOwnerAndCreatedAt?:  {
    __typename: "ModelBookmarkConnection",
    items:  Array< {
      __typename: "Bookmark",
      createdAt?: string | null,
      entityType?: string | null,
      owner: string,
      parentId: string,
      parentType: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBookmarkByOwnerAndParentTypeAndCreatedAtQueryVariables = {
  filter?: ModelBookmarkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  parentTypeCreatedAt?: ModelBookmarkBookmarksByOwnerAndParentTypeAndCreatedAtCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBookmarkByOwnerAndParentTypeAndCreatedAtQuery = {
  listBookmarkByOwnerAndParentTypeAndCreatedAt?:  {
    __typename: "ModelBookmarkConnection",
    items:  Array< {
      __typename: "Bookmark",
      createdAt?: string | null,
      entityType?: string | null,
      owner: string,
      parentId: string,
      parentType: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBookmarkByOwnerAndParentTypeAndEntityTypeAndCreatedAtQueryVariables = {
  filter?: ModelBookmarkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  parentTypeEntityTypeCreatedAt?: ModelBookmarkBookmarksByOwnerAndParentTypeAndEntityTypeAndCreatedAtCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBookmarkByOwnerAndParentTypeAndEntityTypeAndCreatedAtQuery = {
  listBookmarkByOwnerAndParentTypeAndEntityTypeAndCreatedAt?:  {
    __typename: "ModelBookmarkConnection",
    items:  Array< {
      __typename: "Bookmark",
      createdAt?: string | null,
      entityType?: string | null,
      owner: string,
      parentId: string,
      parentType: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBookmarksQueryVariables = {
  filter?: ModelBookmarkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner?: string | null,
  parentTypeParentId?: ModelBookmarkPrimaryCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBookmarksQuery = {
  listBookmarks?:  {
    __typename: "ModelBookmarkConnection",
    items:  Array< {
      __typename: "Bookmark",
      createdAt?: string | null,
      entityType?: string | null,
      owner: string,
      parentId: string,
      parentType: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBookmarksWithParentQueryVariables = {
  entityType?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  parentType?: string | null,
  skipRelationships?: boolean | null,
};

export type ListBookmarksWithParentQuery = {
  listBookmarksWithParent?:  {
    __typename: "BookmarkWithParentResults",
    data:  Array< {
      __typename: "BookmarkWithParent",
      createdAt?: string | null,
      entityType?: string | null,
      owner: string,
      parentId: string,
      parentType: string,
    } >,
    nextToken?: string | null,
  } | null,
};

export type ListCampaignsQueryVariables = {
  filter?: ModelCampaignFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCampaignsQuery = {
  listCampaigns?:  {
    __typename: "ModelCampaignConnection",
    items:  Array< {
      __typename: "Campaign",
      createdAt: string,
      id: string,
      isDefault?: boolean | null,
      offeringStackId?: string | null,
      readableTitle: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChallengeProgressByOwnerAndEndTimeQueryVariables = {
  endTime?: ModelStringKeyConditionInput | null,
  filter?: ModelChallengeProgressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListChallengeProgressByOwnerAndEndTimeQuery = {
  listChallengeProgressByOwnerAndEndTime?:  {
    __typename: "ModelChallengeProgressConnection",
    items:  Array< {
      __typename: "ChallengeProgress",
      coinsEarned?: number | null,
      completeTime?: string | null,
      createdAt: string,
      endTime: string,
      entityId: string,
      id: string,
      owner?: string | null,
      startTime: string,
      type?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChallengeProgressByTypeAndEndTimeQueryVariables = {
  endTime?: ModelStringKeyConditionInput | null,
  filter?: ModelChallengeProgressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  type: string,
};

export type ListChallengeProgressByTypeAndEndTimeQuery = {
  listChallengeProgressByTypeAndEndTime?:  {
    __typename: "ModelChallengeProgressConnection",
    items:  Array< {
      __typename: "ChallengeProgress",
      coinsEarned?: number | null,
      completeTime?: string | null,
      createdAt: string,
      endTime: string,
      entityId: string,
      id: string,
      owner?: string | null,
      startTime: string,
      type?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChallengeProgressesQueryVariables = {
  filter?: ModelChallengeProgressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListChallengeProgressesQuery = {
  listChallengeProgresses?:  {
    __typename: "ModelChallengeProgressConnection",
    items:  Array< {
      __typename: "ChallengeProgress",
      coinsEarned?: number | null,
      completeTime?: string | null,
      createdAt: string,
      endTime: string,
      entityId: string,
      id: string,
      owner?: string | null,
      startTime: string,
      type?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChatRoomsQueryVariables = {
  filter?: ModelChatRoomFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListChatRoomsQuery = {
  listChatRooms?:  {
    __typename: "ModelChatRoomConnection",
    items:  Array< {
      __typename: "ChatRoom",
      bannedUsers?: Array< string | null > | null,
      createdAt?: string | null,
      entityId: string,
      id: string,
      moderators?: Array< string | null > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChatRoomsByEntityQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  entityId: string,
  filter?: ModelChatRoomFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListChatRoomsByEntityQuery = {
  listChatRoomsByEntity?:  {
    __typename: "ModelChatRoomConnection",
    items:  Array< {
      __typename: "ChatRoom",
      bannedUsers?: Array< string | null > | null,
      createdAt?: string | null,
      entityId: string,
      id: string,
      moderators?: Array< string | null > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChecklistItemByOwnerAndDateQueryVariables = {
  date?: ModelStringKeyConditionInput | null,
  filter?: ModelChecklistItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListChecklistItemByOwnerAndDateQuery = {
  listChecklistItemByOwnerAndDate?:  {
    __typename: "ModelChecklistItemConnection",
    items:  Array< {
      __typename: "ChecklistItem",
      createdAt: string,
      date: string,
      endDate?: string | null,
      frequency: ItemFrequency,
      id: string,
      order?: number | null,
      owner: string,
      title: string,
      updatedAt: string,
      weekday: DayOfWeek,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChecklistItemByOwnerAndFrequencyAndWeekdayQueryVariables = {
  filter?: ModelChecklistItemFilterInput | null,
  frequencyWeekday?: ModelChecklistItemChecklistItemsByOwnerAndFrequencyAndWeekdayCompositeKeyConditionInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListChecklistItemByOwnerAndFrequencyAndWeekdayQuery = {
  listChecklistItemByOwnerAndFrequencyAndWeekday?:  {
    __typename: "ModelChecklistItemConnection",
    items:  Array< {
      __typename: "ChecklistItem",
      createdAt: string,
      date: string,
      endDate?: string | null,
      frequency: ItemFrequency,
      id: string,
      order?: number | null,
      owner: string,
      title: string,
      updatedAt: string,
      weekday: DayOfWeek,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCommentByThreadIdAndParentIdAndCreatedAtQueryVariables = {
  filter?: ModelCommentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  parentIdCreatedAt?: ModelCommentCommentsByThreadIdAndParentIdAndCreatedAtCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  threadId: string,
};

export type ListCommentByThreadIdAndParentIdAndCreatedAtQuery = {
  listCommentByThreadIdAndParentIdAndCreatedAt?:  {
    __typename: "ModelCommentConnection",
    items:  Array< {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCommentByThreadIdAndPinnedStateAndCreatedAtQueryVariables = {
  filter?: ModelCommentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  pinnedStateCreatedAt?: ModelCommentCommentsByThreadIdAndPinnedStateAndCreatedAtCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  threadId: string,
};

export type ListCommentByThreadIdAndPinnedStateAndCreatedAtQuery = {
  listCommentByThreadIdAndPinnedStateAndCreatedAt?:  {
    __typename: "ModelCommentConnection",
    items:  Array< {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCommentByTypeQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelCommentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  type: CommentType,
};

export type ListCommentByTypeQuery = {
  listCommentByType?:  {
    __typename: "ModelCommentConnection",
    items:  Array< {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCommentLikeByCommentIdAndUserProfileIdQueryVariables = {
  commentId: string,
  filter?: ModelCommentLikeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userProfileId?: ModelIDKeyConditionInput | null,
};

export type ListCommentLikeByCommentIdAndUserProfileIdQuery = {
  listCommentLikeByCommentIdAndUserProfileId?:  {
    __typename: "ModelCommentLikeConnection",
    items:  Array< {
      __typename: "CommentLike",
      commentId: string,
      createdAt: string,
      id: string,
      owner?: string | null,
      threadId: string,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCommentLikeByUserProfileIdAndThreadIdQueryVariables = {
  filter?: ModelCommentLikeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  threadId?: ModelStringKeyConditionInput | null,
  userProfileId: string,
};

export type ListCommentLikeByUserProfileIdAndThreadIdQuery = {
  listCommentLikeByUserProfileIdAndThreadId?:  {
    __typename: "ModelCommentLikeConnection",
    items:  Array< {
      __typename: "CommentLike",
      commentId: string,
      createdAt: string,
      id: string,
      owner?: string | null,
      threadId: string,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCommentsQueryVariables = {
  filter?: ModelCommentFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCommentsQuery = {
  listComments?:  {
    __typename: "ModelCommentConnection",
    items:  Array< {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCourseCertificateByOwnerQueryVariables = {
  filter?: ModelCourseCertificateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListCourseCertificateByOwnerQuery = {
  listCourseCertificateByOwner?:  {
    __typename: "ModelCourseCertificateConnection",
    items:  Array< {
      __typename: "CourseCertificate",
      createdAt?: string | null,
      entityId: string,
      owner: string,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCourseCertificatesQueryVariables = {
  entityId?: ModelStringKeyConditionInput | null,
  filter?: ModelCourseCertificateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCourseCertificatesQuery = {
  listCourseCertificates?:  {
    __typename: "ModelCourseCertificateConnection",
    items:  Array< {
      __typename: "CourseCertificate",
      createdAt?: string | null,
      entityId: string,
      owner: string,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDailyLifescoreByOwnerAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelDailyLifescoreFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListDailyLifescoreByOwnerAndCreatedAtQuery = {
  listDailyLifescoreByOwnerAndCreatedAt?:  {
    __typename: "ModelDailyLifescoreConnection",
    items:  Array< {
      __typename: "DailyLifescore",
      averageScorePercentage: number,
      clarityScore: number,
      courageScore: number,
      createdAt?: string | null,
      energyScore: number,
      id: string,
      influenceScore: number,
      moodScore: number,
      movementScore: number,
      necessityScore: number,
      nutritionScore: number,
      owner?: string | null,
      parentId?: string | null,
      productivityScore: number,
      sleepScore: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDailyLifescoreByParentIdAndOwnerQueryVariables = {
  filter?: ModelDailyLifescoreFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner?: ModelStringKeyConditionInput | null,
  parentId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListDailyLifescoreByParentIdAndOwnerQuery = {
  listDailyLifescoreByParentIdAndOwner?:  {
    __typename: "ModelDailyLifescoreConnection",
    items:  Array< {
      __typename: "DailyLifescore",
      averageScorePercentage: number,
      clarityScore: number,
      courageScore: number,
      createdAt?: string | null,
      energyScore: number,
      id: string,
      influenceScore: number,
      moodScore: number,
      movementScore: number,
      necessityScore: number,
      nutritionScore: number,
      owner?: string | null,
      parentId?: string | null,
      productivityScore: number,
      sleepScore: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDashboardCardItemsQueryVariables = {
  filter?: ModelDashboardCardItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDashboardCardItemsQuery = {
  listDashboardCardItems?:  {
    __typename: "ModelDashboardCardItemConnection",
    items:  Array< {
      __typename: "DashboardCardItem",
      assessmentType?: DashboardCardItemAssessmentType | null,
      createdAt: string,
      customPrompt?: string | null,
      date: string,
      entityHasEntitlements?: boolean | null,
      entityId?: string | null,
      id: string,
      nonEntitledEntityId?: string | null,
      order: number,
      type?: DashboardCardItemType | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDashboardCardsQueryVariables = {
  date?: string | null,
  filter?: ModelDashboardCardFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDashboardCardsQuery = {
  listDashboardCards?:  {
    __typename: "ModelDashboardCardConnection",
    items:  Array< {
      __typename: "DashboardCard",
      createdAt: string,
      date: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDashboardStreakByOwnerAndLastActiveDateQueryVariables = {
  filter?: ModelDashboardStreakFilterInput | null,
  lastActiveDate?: ModelStringKeyConditionInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListDashboardStreakByOwnerAndLastActiveDateQuery = {
  listDashboardStreakByOwnerAndLastActiveDate?:  {
    __typename: "ModelDashboardStreakConnection",
    items:  Array< {
      __typename: "DashboardStreak",
      count: number,
      createdAt: string,
      id: string,
      lastActiveDate: string,
      owner: string,
      startDate: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDashboardStreaksQueryVariables = {
  filter?: ModelDashboardStreakFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDashboardStreaksQuery = {
  listDashboardStreaks?:  {
    __typename: "ModelDashboardStreakConnection",
    items:  Array< {
      __typename: "DashboardStreak",
      count: number,
      createdAt: string,
      id: string,
      lastActiveDate: string,
      owner: string,
      startDate: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEntitiesQueryVariables = {
  filter?: ModelEntityFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEntitiesQuery = {
  listEntities?:  {
    __typename: "ModelEntityConnection",
    items:  Array< {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEntityByEntityTypeAndPublishAtQueryVariables = {
  entityType: EntityType,
  filter?: ModelEntityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  publishAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEntityByEntityTypeAndPublishAtQuery = {
  listEntityByEntityTypeAndPublishAt?:  {
    __typename: "ModelEntityConnection",
    items:  Array< {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEntityByEntityTypeAndStartTimeQueryVariables = {
  entityType: EntityType,
  filter?: ModelEntityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  startTime?: ModelStringKeyConditionInput | null,
};

export type ListEntityByEntityTypeAndStartTimeQuery = {
  listEntityByEntityTypeAndStartTime?:  {
    __typename: "ModelEntityConnection",
    items:  Array< {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEntityLikeByEntityIdAndUserProfileIdQueryVariables = {
  entityId: string,
  filter?: ModelEntityLikeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userProfileId?: ModelIDKeyConditionInput | null,
};

export type ListEntityLikeByEntityIdAndUserProfileIdQuery = {
  listEntityLikeByEntityIdAndUserProfileId?:  {
    __typename: "ModelEntityLikeConnection",
    items:  Array< {
      __typename: "EntityLike",
      createdAt: string,
      entityId: string,
      id: string,
      owner?: string | null,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEntityLikeByUserProfileIdQueryVariables = {
  filter?: ModelEntityLikeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userProfileId: string,
};

export type ListEntityLikeByUserProfileIdQuery = {
  listEntityLikeByUserProfileId?:  {
    __typename: "ModelEntityLikeConnection",
    items:  Array< {
      __typename: "EntityLike",
      createdAt: string,
      entityId: string,
      id: string,
      owner?: string | null,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEntityRelationsQueryVariables = {
  filter?: ModelEntityRelationsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEntityRelationsQuery = {
  listEntityRelations?:  {
    __typename: "ModelEntityRelationsConnection",
    items:  Array< {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEventRsvpByOwnerAndParentTypeAndEventStartTimeAndCreatedAtQueryVariables = {
  filter?: ModelEventRsvpFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  parentTypeEventStartTimeCreatedAt?: ModelEventRsvpEventRsvpsByOwnerAndParentTypeAndEventStartTimeAndCreatedAtCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEventRsvpByOwnerAndParentTypeAndEventStartTimeAndCreatedAtQuery = {
  listEventRsvpByOwnerAndParentTypeAndEventStartTimeAndCreatedAt?:  {
    __typename: "ModelEventRsvpConnection",
    items:  Array< {
      __typename: "EventRsvp",
      createdAt?: string | null,
      eventStartTime: string,
      meetupId?: string | null,
      owner: string,
      parentId: string,
      parentType?: EventRsvpParentType | null,
      socialProofId?: string | null,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGiftRecipientByBuyerIdAndCreatedAtQueryVariables = {
  buyerId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelGiftRecipientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListGiftRecipientByBuyerIdAndCreatedAtQuery = {
  listGiftRecipientByBuyerIdAndCreatedAt?:  {
    __typename: "ModelGiftRecipientConnection",
    items:  Array< {
      __typename: "GiftRecipient",
      buyerId: string,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      id: string,
      lastName?: string | null,
      owner: string,
      stripePriceId?: string | null,
      subscriptionId?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGiftRecipientByOwnerAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelGiftRecipientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListGiftRecipientByOwnerAndCreatedAtQuery = {
  listGiftRecipientByOwnerAndCreatedAt?:  {
    __typename: "ModelGiftRecipientConnection",
    items:  Array< {
      __typename: "GiftRecipient",
      buyerId: string,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      id: string,
      lastName?: string | null,
      owner: string,
      stripePriceId?: string | null,
      subscriptionId?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGrowthCoinStatsQueryVariables = {
  filter?: ModelGrowthCoinStatsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner?: string | null,
  sortDirection?: ModelSortDirection | null,
  sourceSourceEvent?: ModelGrowthCoinStatsPrimaryCompositeKeyConditionInput | null,
};

export type ListGrowthCoinStatsQuery = {
  listGrowthCoinStats?:  {
    __typename: "ModelGrowthCoinStatsConnection",
    items:  Array< {
      __typename: "GrowthCoinStats",
      createdAt: string,
      currentMonth: string,
      monthCoins: number,
      owner: string,
      source: string,
      sourceEvent: string,
      totalCoins: number,
      updatedAt: string,
      version?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGrowthCoinStatsByOwnerAndSourceAndSourceEventQueryVariables = {
  filter?: ModelGrowthCoinStatsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
  sourceSourceEvent?: ModelGrowthCoinStatsGrowthCoinStatsByOwnerAndSourceAndSourceEventCompositeKeyConditionInput | null,
};

export type ListGrowthCoinStatsByOwnerAndSourceAndSourceEventQuery = {
  listGrowthCoinStatsByOwnerAndSourceAndSourceEvent?:  {
    __typename: "ModelGrowthCoinStatsConnection",
    items:  Array< {
      __typename: "GrowthCoinStats",
      createdAt: string,
      currentMonth: string,
      monthCoins: number,
      owner: string,
      source: string,
      sourceEvent: string,
      totalCoins: number,
      updatedAt: string,
      version?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGrowthCoinTransactionByOwnerAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelGrowthCoinTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListGrowthCoinTransactionByOwnerAndCreatedAtQuery = {
  listGrowthCoinTransactionByOwnerAndCreatedAt?:  {
    __typename: "ModelGrowthCoinTransactionConnection",
    items:  Array< {
      __typename: "GrowthCoinTransaction",
      coinsAdded: number,
      createdAt?: string | null,
      endBalance: number,
      id: string,
      owner?: string | null,
      source: GrowthCoinTransactionSource,
      sourceEvent: GrowthCoinTransactionSourceEvent,
      startBalance: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGrowthCoinTransactionByOwnerAndSourceAndCreatedAtQueryVariables = {
  filter?: ModelGrowthCoinTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
  sourceCreatedAt?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceAndCreatedAtCompositeKeyConditionInput | null,
};

export type ListGrowthCoinTransactionByOwnerAndSourceAndCreatedAtQuery = {
  listGrowthCoinTransactionByOwnerAndSourceAndCreatedAt?:  {
    __typename: "ModelGrowthCoinTransactionConnection",
    items:  Array< {
      __typename: "GrowthCoinTransaction",
      coinsAdded: number,
      createdAt?: string | null,
      endBalance: number,
      id: string,
      owner?: string | null,
      source: GrowthCoinTransactionSource,
      sourceEvent: GrowthCoinTransactionSourceEvent,
      startBalance: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGrowthCoinTransactionByOwnerAndSourceEventAndCreatedAtQueryVariables = {
  filter?: ModelGrowthCoinTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
  sourceEventCreatedAt?: ModelGrowthCoinTransactionGrowthCoinTransactionsByOwnerAndSourceEventAndCreatedAtCompositeKeyConditionInput | null,
};

export type ListGrowthCoinTransactionByOwnerAndSourceEventAndCreatedAtQuery = {
  listGrowthCoinTransactionByOwnerAndSourceEventAndCreatedAt?:  {
    __typename: "ModelGrowthCoinTransactionConnection",
    items:  Array< {
      __typename: "GrowthCoinTransaction",
      coinsAdded: number,
      createdAt?: string | null,
      endBalance: number,
      id: string,
      owner?: string | null,
      source: GrowthCoinTransactionSource,
      sourceEvent: GrowthCoinTransactionSourceEvent,
      startBalance: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListGrowthCoinTransactionsQueryVariables = {
  filter?: ModelGrowthCoinTransactionFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListGrowthCoinTransactionsQuery = {
  listGrowthCoinTransactions?:  {
    __typename: "ModelGrowthCoinTransactionConnection",
    items:  Array< {
      __typename: "GrowthCoinTransaction",
      coinsAdded: number,
      createdAt?: string | null,
      endBalance: number,
      id: string,
      owner?: string | null,
      source: GrowthCoinTransactionSource,
      sourceEvent: GrowthCoinTransactionSourceEvent,
      startBalance: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListJournalByOwnerQueryVariables = {
  datetime?: ModelStringKeyConditionInput | null,
  filter?: ModelJournalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListJournalByOwnerQuery = {
  listJournalByOwner?:  {
    __typename: "ModelJournalConnection",
    items:  Array< {
      __typename: "Journal",
      createdAt: string,
      customPrompts?: Array< string | null > | null,
      datetime: string,
      id: string,
      journalType: JournalType,
      owner?: string | null,
      parentId?: string | null,
      responses?: Array< string | null > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListJournalByOwnerAndParentIdQueryVariables = {
  filter?: ModelJournalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  parentId?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListJournalByOwnerAndParentIdQuery = {
  listJournalByOwnerAndParentId?:  {
    __typename: "ModelJournalConnection",
    items:  Array< {
      __typename: "Journal",
      createdAt: string,
      customPrompts?: Array< string | null > | null,
      datetime: string,
      id: string,
      journalType: JournalType,
      owner?: string | null,
      parentId?: string | null,
      responses?: Array< string | null > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListJournalByParentIdQueryVariables = {
  datetime?: ModelStringKeyConditionInput | null,
  filter?: ModelJournalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  parentId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListJournalByParentIdQuery = {
  listJournalByParentId?:  {
    __typename: "ModelJournalConnection",
    items:  Array< {
      __typename: "Journal",
      createdAt: string,
      customPrompts?: Array< string | null > | null,
      datetime: string,
      id: string,
      journalType: JournalType,
      owner?: string | null,
      parentId?: string | null,
      responses?: Array< string | null > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLeaderboardByMonthAndHighestStreakCountAndTotalCoinsCountQueryVariables = {
  filter?: ModelLeaderboardFilterInput | null,
  highestStreakCountAndTotalCoinsCount?: ModelStringKeyConditionInput | null,
  limit?: number | null,
  month: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLeaderboardByMonthAndHighestStreakCountAndTotalCoinsCountQuery = {
  listLeaderboardByMonthAndHighestStreakCountAndTotalCoinsCount?:  {
    __typename: "ModelLeaderboardConnection",
    items:  Array< {
      __typename: "Leaderboard",
      createdAt: string,
      highestStreakCount: number,
      highestStreakCountAndTotalCoinsCount: string,
      month: string,
      owner: string,
      ranking?: number | null,
      totalCoinsCount: number,
      totalLeadsCount?: number | null,
      totalReferralsCount: number,
      totalReferralsCountAndTotalLeadsCount?: string | null,
      totalStreaksCount: number,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLeaderboardByMonthAndRankingQueryVariables = {
  filter?: ModelLeaderboardFilterInput | null,
  limit?: number | null,
  month: string,
  nextToken?: string | null,
  ranking?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLeaderboardByMonthAndRankingQuery = {
  listLeaderboardByMonthAndRanking?:  {
    __typename: "ModelLeaderboardConnection",
    items:  Array< {
      __typename: "Leaderboard",
      createdAt: string,
      highestStreakCount: number,
      highestStreakCountAndTotalCoinsCount: string,
      month: string,
      owner: string,
      ranking?: number | null,
      totalCoinsCount: number,
      totalLeadsCount?: number | null,
      totalReferralsCount: number,
      totalReferralsCountAndTotalLeadsCount?: string | null,
      totalStreaksCount: number,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLeaderboardByMonthAndTotalCoinsCountQueryVariables = {
  filter?: ModelLeaderboardFilterInput | null,
  limit?: number | null,
  month: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  totalCoinsCount?: ModelIntKeyConditionInput | null,
};

export type ListLeaderboardByMonthAndTotalCoinsCountQuery = {
  listLeaderboardByMonthAndTotalCoinsCount?:  {
    __typename: "ModelLeaderboardConnection",
    items:  Array< {
      __typename: "Leaderboard",
      createdAt: string,
      highestStreakCount: number,
      highestStreakCountAndTotalCoinsCount: string,
      month: string,
      owner: string,
      ranking?: number | null,
      totalCoinsCount: number,
      totalLeadsCount?: number | null,
      totalReferralsCount: number,
      totalReferralsCountAndTotalLeadsCount?: string | null,
      totalStreaksCount: number,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLeaderboardByMonthAndTotalReferralsCountQueryVariables = {
  filter?: ModelLeaderboardFilterInput | null,
  limit?: number | null,
  month: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  totalReferralsCount?: ModelIntKeyConditionInput | null,
};

export type ListLeaderboardByMonthAndTotalReferralsCountQuery = {
  listLeaderboardByMonthAndTotalReferralsCount?:  {
    __typename: "ModelLeaderboardConnection",
    items:  Array< {
      __typename: "Leaderboard",
      createdAt: string,
      highestStreakCount: number,
      highestStreakCountAndTotalCoinsCount: string,
      month: string,
      owner: string,
      ranking?: number | null,
      totalCoinsCount: number,
      totalLeadsCount?: number | null,
      totalReferralsCount: number,
      totalReferralsCountAndTotalLeadsCount?: string | null,
      totalStreaksCount: number,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLeaderboardByMonthAndTotalReferralsCountAndTotalLeadsCountQueryVariables = {
  filter?: ModelLeaderboardFilterInput | null,
  limit?: number | null,
  month: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  totalReferralsCountAndTotalLeadsCount?: ModelStringKeyConditionInput | null,
};

export type ListLeaderboardByMonthAndTotalReferralsCountAndTotalLeadsCountQuery = {
  listLeaderboardByMonthAndTotalReferralsCountAndTotalLeadsCount?:  {
    __typename: "ModelLeaderboardConnection",
    items:  Array< {
      __typename: "Leaderboard",
      createdAt: string,
      highestStreakCount: number,
      highestStreakCountAndTotalCoinsCount: string,
      month: string,
      owner: string,
      ranking?: number | null,
      totalCoinsCount: number,
      totalLeadsCount?: number | null,
      totalReferralsCount: number,
      totalReferralsCountAndTotalLeadsCount?: string | null,
      totalStreaksCount: number,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLeaderboardDashboardStreaksQueryVariables = {
  filter?: ModelLeaderboardDashboardStreakFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLeaderboardDashboardStreaksQuery = {
  listLeaderboardDashboardStreaks?:  {
    __typename: "ModelLeaderboardDashboardStreakConnection",
    items:  Array< {
      __typename: "LeaderboardDashboardStreak",
      createdAt: string,
      dashboardStreakId: string,
      id: string,
      month: string,
      owner: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLeaderboardsQueryVariables = {
  filter?: ModelLeaderboardFilterInput | null,
  limit?: number | null,
  month?: ModelStringKeyConditionInput | null,
  nextToken?: string | null,
  owner?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLeaderboardsQuery = {
  listLeaderboards?:  {
    __typename: "ModelLeaderboardConnection",
    items:  Array< {
      __typename: "Leaderboard",
      createdAt: string,
      highestStreakCount: number,
      highestStreakCountAndTotalCoinsCount: string,
      month: string,
      owner: string,
      ranking?: number | null,
      totalCoinsCount: number,
      totalLeadsCount?: number | null,
      totalReferralsCount: number,
      totalReferralsCountAndTotalLeadsCount?: string | null,
      totalStreaksCount: number,
      updatedAt: string,
      userProfileId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMeetupByLiveStateAndStartTimeQueryVariables = {
  filter?: ModelMeetupFilterInput | null,
  limit?: number | null,
  liveState: MeetupLiveState,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  startTime?: ModelStringKeyConditionInput | null,
};

export type ListMeetupByLiveStateAndStartTimeQuery = {
  listMeetupByLiveStateAndStartTime?:  {
    __typename: "ModelMeetupConnection",
    items:  Array< {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMeetupByOwnerAndStartTimeQueryVariables = {
  filter?: ModelMeetupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
  startTime?: ModelStringKeyConditionInput | null,
};

export type ListMeetupByOwnerAndStartTimeQuery = {
  listMeetupByOwnerAndStartTime?:  {
    __typename: "ModelMeetupConnection",
    items:  Array< {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMeetupByRecurrenceIdAndEndTimeQueryVariables = {
  endTime?: ModelStringKeyConditionInput | null,
  filter?: ModelMeetupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  recurrenceId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListMeetupByRecurrenceIdAndEndTimeQuery = {
  listMeetupByRecurrenceIdAndEndTime?:  {
    __typename: "ModelMeetupConnection",
    items:  Array< {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMeetupsQueryVariables = {
  filter?: ModelMeetupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  slugId?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMeetupsQuery = {
  listMeetups?:  {
    __typename: "ModelMeetupConnection",
    items:  Array< {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMessageByRoomIdAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  roomId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListMessageByRoomIdAndCreatedAtQuery = {
  listMessageByRoomIdAndCreatedAt?:  {
    __typename: "ModelMessageConnection",
    items:  Array< {
      __typename: "Message",
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      mediaPosition: number,
      metadata?: string | null,
      owner?: string | null,
      pinnedState?: MessagePinnedState | null,
      roomId: string,
      type: MessageType,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMessageByRoomIdAndMediaPositionQueryVariables = {
  filter?: ModelMessageFilterInput | null,
  limit?: number | null,
  mediaPosition?: ModelIntKeyConditionInput | null,
  nextToken?: string | null,
  roomId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListMessageByRoomIdAndMediaPositionQuery = {
  listMessageByRoomIdAndMediaPosition?:  {
    __typename: "ModelMessageConnection",
    items:  Array< {
      __typename: "Message",
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      mediaPosition: number,
      metadata?: string | null,
      owner?: string | null,
      pinnedState?: MessagePinnedState | null,
      roomId: string,
      type: MessageType,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMessageByRoomIdAndPinnedStateQueryVariables = {
  filter?: ModelMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  pinnedState?: ModelStringKeyConditionInput | null,
  roomId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListMessageByRoomIdAndPinnedStateQuery = {
  listMessageByRoomIdAndPinnedState?:  {
    __typename: "ModelMessageConnection",
    items:  Array< {
      __typename: "Message",
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      mediaPosition: number,
      metadata?: string | null,
      owner?: string | null,
      pinnedState?: MessagePinnedState | null,
      roomId: string,
      type: MessageType,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMonthlyLifescoreByOwnerAndCreatedAtQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelMonthlyLifescoreFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListMonthlyLifescoreByOwnerAndCreatedAtQuery = {
  listMonthlyLifescoreByOwnerAndCreatedAt?:  {
    __typename: "ModelMonthlyLifescoreConnection",
    items:  Array< {
      __typename: "MonthlyLifescore",
      averageScorePercentage: number,
      createdAt?: string | null,
      experienceScore: number,
      familyScore: number,
      financeScore: number,
      friendScore: number,
      healthScore: number,
      id: string,
      learningScore: number,
      mentalAndEmotionalScore: number,
      missionScore: number,
      owner?: string | null,
      parentId?: string | null,
      partnerAndLoveScore: number,
      spiritScore: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMonthlyLifescoreByParentIdAndOwnerQueryVariables = {
  filter?: ModelMonthlyLifescoreFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner?: ModelStringKeyConditionInput | null,
  parentId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListMonthlyLifescoreByParentIdAndOwnerQuery = {
  listMonthlyLifescoreByParentIdAndOwner?:  {
    __typename: "ModelMonthlyLifescoreConnection",
    items:  Array< {
      __typename: "MonthlyLifescore",
      averageScorePercentage: number,
      createdAt?: string | null,
      experienceScore: number,
      familyScore: number,
      financeScore: number,
      friendScore: number,
      healthScore: number,
      id: string,
      learningScore: number,
      mentalAndEmotionalScore: number,
      missionScore: number,
      owner?: string | null,
      parentId?: string | null,
      partnerAndLoveScore: number,
      spiritScore: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListNoteByOwnerAndPinnedStateQueryVariables = {
  filter?: ModelNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  pinnedState?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListNoteByOwnerAndPinnedStateQuery = {
  listNoteByOwnerAndPinnedState?:  {
    __typename: "ModelNoteConnection",
    items:  Array< {
      __typename: "Note",
      content: string,
      createdAt?: string | null,
      entityId: string,
      entityType?: EntityType | null,
      owner: string,
      parentId: string,
      parentType?: NoteParentType | null,
      pinnedState?: NotePinnedState | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListNotesByOwnerQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListNotesByOwnerQuery = {
  listNotesByOwner?:  {
    __typename: "ModelNoteConnection",
    items:  Array< {
      __typename: "Note",
      content: string,
      createdAt?: string | null,
      entityId: string,
      entityType?: EntityType | null,
      owner: string,
      parentId: string,
      parentType?: NoteParentType | null,
      pinnedState?: NotePinnedState | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListNotificationLogByChallengeDayProgressIdAndNameQueryVariables = {
  challengeDayProgressId: string,
  filter?: ModelNotificationLogFilterInput | null,
  limit?: number | null,
  name?: ModelStringKeyConditionInput | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListNotificationLogByChallengeDayProgressIdAndNameQuery = {
  listNotificationLogByChallengeDayProgressIdAndName?:  {
    __typename: "ModelNotificationLogConnection",
    items:  Array< {
      __typename: "NotificationLog",
      challengeDayProgressId?: string | null,
      createdAt: string,
      entityId?: string | null,
      id: string,
      meetupSlugId?: string | null,
      name?: NotificationLogName | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListNotificationLogsQueryVariables = {
  filter?: ModelNotificationLogFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListNotificationLogsQuery = {
  listNotificationLogs?:  {
    __typename: "ModelNotificationLogConnection",
    items:  Array< {
      __typename: "NotificationLog",
      challengeDayProgressId?: string | null,
      createdAt: string,
      entityId?: string | null,
      id: string,
      meetupSlugId?: string | null,
      name?: NotificationLogName | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOfferingByTypeQueryVariables = {
  filter?: ModelOfferingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  type: OfferingType,
};

export type ListOfferingByTypeQuery = {
  listOfferingByType?:  {
    __typename: "ModelOfferingConnection",
    items:  Array< {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOfferingProductBundlesQueryVariables = {
  filter?: ModelOfferingProductBundleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOfferingProductBundlesQuery = {
  listOfferingProductBundles?:  {
    __typename: "ModelOfferingProductBundleConnection",
    items:  Array< {
      __typename: "OfferingProductBundle",
      createdAt: string,
      id: string,
      offeringId: string,
      productId: string,
      readableTitle: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOfferingProductsQueryVariables = {
  filter?: ModelOfferingProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOfferingProductsQuery = {
  listOfferingProducts?:  {
    __typename: "ModelOfferingProductConnection",
    items:  Array< {
      __typename: "OfferingProduct",
      createdAt: string,
      id: string,
      offeringId: string,
      productId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOfferingStackUpsellsQueryVariables = {
  filter?: ModelOfferingStackUpsellFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOfferingStackUpsellsQuery = {
  listOfferingStackUpsells?:  {
    __typename: "ModelOfferingStackUpsellConnection",
    items:  Array< {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOfferingStacksQueryVariables = {
  filter?: ModelOfferingStackFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOfferingStacksQuery = {
  listOfferingStacks?:  {
    __typename: "ModelOfferingStackConnection",
    items:  Array< {
      __typename: "OfferingStack",
      createdAt: string,
      id: string,
      offeringId: string,
      orderBumpId?: string | null,
      readableTitle: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOfferingsQueryVariables = {
  filter?: ModelOfferingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOfferingsQuery = {
  listOfferings?:  {
    __typename: "ModelOfferingConnection",
    items:  Array< {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListProductByProductIdAndStoreAndPriceIdQueryVariables = {
  filter?: ModelProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  productId: string,
  sortDirection?: ModelSortDirection | null,
  storePriceId?: ModelProductProductsByProductIdAndStoreAndPriceIdCompositeKeyConditionInput | null,
};

export type ListProductByProductIdAndStoreAndPriceIdQuery = {
  listProductByProductIdAndStoreAndPriceId?:  {
    __typename: "ModelProductConnection",
    items:  Array< {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListProductByStoreAndSubscriptionGroupQueryVariables = {
  filter?: ModelProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  store: ProductStore,
  subscriptionGroup?: ModelStringKeyConditionInput | null,
};

export type ListProductByStoreAndSubscriptionGroupQuery = {
  listProductByStoreAndSubscriptionGroup?:  {
    __typename: "ModelProductConnection",
    items:  Array< {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListProductsQueryVariables = {
  filter?: ModelProductFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProductsQuery = {
  listProducts?:  {
    __typename: "ModelProductConnection",
    items:  Array< {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRecentlyPlayedByOwnerAndEntityIdQueryVariables = {
  entityId?: ModelIDKeyConditionInput | null,
  filter?: ModelRecentlyPlayedFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListRecentlyPlayedByOwnerAndEntityIdQuery = {
  listRecentlyPlayedByOwnerAndEntityId?:  {
    __typename: "ModelRecentlyPlayedConnection",
    items:  Array< {
      __typename: "RecentlyPlayed",
      completeTime?: string | null,
      createdAt: string,
      entityId: string,
      entityType: EntityType,
      id: string,
      lastPlayedAt: string,
      owner?: string | null,
      playbackPercentage: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRecentlyPlayedByOwnerAndLastPlayedAtQueryVariables = {
  filter?: ModelRecentlyPlayedFilterInput | null,
  lastPlayedAt?: ModelStringKeyConditionInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListRecentlyPlayedByOwnerAndLastPlayedAtQuery = {
  listRecentlyPlayedByOwnerAndLastPlayedAt?:  {
    __typename: "ModelRecentlyPlayedConnection",
    items:  Array< {
      __typename: "RecentlyPlayed",
      completeTime?: string | null,
      createdAt: string,
      entityId: string,
      entityType: EntityType,
      id: string,
      lastPlayedAt: string,
      owner?: string | null,
      playbackPercentage: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRecentlyPlayedsQueryVariables = {
  filter?: ModelRecentlyPlayedFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRecentlyPlayedsQuery = {
  listRecentlyPlayeds?:  {
    __typename: "ModelRecentlyPlayedConnection",
    items:  Array< {
      __typename: "RecentlyPlayed",
      completeTime?: string | null,
      createdAt: string,
      entityId: string,
      entityType: EntityType,
      id: string,
      lastPlayedAt: string,
      owner?: string | null,
      playbackPercentage: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReferralLeadsQueryVariables = {
  page?: number | null,
  pageSize?: number | null,
};

export type ListReferralLeadsQuery = {
  listReferralLeads?:  {
    __typename: "ReferralLeadsPagination",
    currentPage: number,
    hasNextPage: boolean,
    items?:  Array< {
      __typename: "ReferralLead",
      cancelledAt?: string | null,
      createdAt: string,
      customerSince?: string | null,
      email: string,
      id: string,
      state?: string | null,
    } | null > | null,
    pageSize: number,
    totalItems: number,
    totalPages: number,
  } | null,
};

export type ListReferralRewardsQueryVariables = {
  page?: number | null,
  pageSize?: number | null,
};

export type ListReferralRewardsQuery = {
  listReferralRewards?:  {
    __typename: "ReferralRewardsPagination",
    currentPage: number,
    hasNextPage: boolean,
    items?:  Array< {
      __typename: "ReferralReward",
      amount: number,
      conversionAmount: number,
      createdAt: string,
      id: string,
      status?: string | null,
      unit?: string | null,
    } | null > | null,
    pageSize: number,
    totalItems: number,
    totalPages: number,
  } | null,
};

export type ListSocialProofsQueryVariables = {
  filter?: ModelSocialProofFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  parentId?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSocialProofsQuery = {
  listSocialProofs?:  {
    __typename: "ModelSocialProofConnection",
    items:  Array< {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTeamByOwnerQueryVariables = {
  filter?: ModelTeamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListTeamByOwnerQuery = {
  listTeamByOwner?:  {
    __typename: "ModelTeamConnection",
    items:  Array< {
      __typename: "Team",
      createdAt: string,
      id: string,
      invitationState?: TeamInvitationState | null,
      owner: string,
      stripePriceId?: string | null,
      stripeProductId?: string | null,
      subscriptionId?: string | null,
      subscriptionItemId?: string | null,
      subscriptionState?: TeamSubscriptionState | null,
      totalSeats?: number | null,
      updatedAt: string,
      usedSeats?: number | null,
      version?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTeamMemberByEmailAndTeamIdQueryVariables = {
  email: string,
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  teamId?: ModelIDKeyConditionInput | null,
};

export type ListTeamMemberByEmailAndTeamIdQuery = {
  listTeamMemberByEmailAndTeamId?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      createdAt: string,
      email?: string | null,
      firstName?: string | null,
      id: string,
      lastName?: string | null,
      owner: string,
      subscriptionState?: TeamSubscriptionState | null,
      teamId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTeamMemberByOwnerAndTeamIdQueryVariables = {
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
  teamId?: ModelIDKeyConditionInput | null,
};

export type ListTeamMemberByOwnerAndTeamIdQuery = {
  listTeamMemberByOwnerAndTeamId?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      createdAt: string,
      email?: string | null,
      firstName?: string | null,
      id: string,
      lastName?: string | null,
      owner: string,
      subscriptionState?: TeamSubscriptionState | null,
      teamId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTeamMemberByTeamIdAndFirstNameAndLastNameQueryVariables = {
  filter?: ModelTeamMemberFilterInput | null,
  firstNameLastName?: ModelTeamMemberTeamMembersByTeamIdAndFirstNameAndLastNameCompositeKeyConditionInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  teamId: string,
};

export type ListTeamMemberByTeamIdAndFirstNameAndLastNameQuery = {
  listTeamMemberByTeamIdAndFirstNameAndLastName?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      createdAt: string,
      email?: string | null,
      firstName?: string | null,
      id: string,
      lastName?: string | null,
      owner: string,
      subscriptionState?: TeamSubscriptionState | null,
      teamId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTeamMembersQueryVariables = {
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeamMembersQuery = {
  listTeamMembers?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      createdAt: string,
      email?: string | null,
      firstName?: string | null,
      id: string,
      lastName?: string | null,
      owner: string,
      subscriptionState?: TeamSubscriptionState | null,
      teamId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTeamsQueryVariables = {
  filter?: ModelTeamFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTeamsQuery = {
  listTeams?:  {
    __typename: "ModelTeamConnection",
    items:  Array< {
      __typename: "Team",
      createdAt: string,
      id: string,
      invitationState?: TeamInvitationState | null,
      owner: string,
      stripePriceId?: string | null,
      stripeProductId?: string | null,
      subscriptionId?: string | null,
      subscriptionItemId?: string | null,
      subscriptionState?: TeamSubscriptionState | null,
      totalSeats?: number | null,
      updatedAt: string,
      usedSeats?: number | null,
      version?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserExternalIdentifierByExternalIdentifierQueryVariables = {
  externalIdentifier: string,
  filter?: ModelUserExternalIdentifierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserExternalIdentifierByExternalIdentifierQuery = {
  listUserExternalIdentifierByExternalIdentifier?:  {
    __typename: "ModelUserExternalIdentifierConnection",
    items:  Array< {
      __typename: "UserExternalIdentifier",
      createdAt: string,
      externalIdentifier: string,
      owner: string,
      type?: UserExternalIdentifierType | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserExternalIdentifierByOwnerAndTypeQueryVariables = {
  filter?: ModelUserExternalIdentifierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
  type?: ModelStringKeyConditionInput | null,
};

export type ListUserExternalIdentifierByOwnerAndTypeQuery = {
  listUserExternalIdentifierByOwnerAndType?:  {
    __typename: "ModelUserExternalIdentifierConnection",
    items:  Array< {
      __typename: "UserExternalIdentifier",
      createdAt: string,
      externalIdentifier: string,
      owner: string,
      type?: UserExternalIdentifierType | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserProfileByPublicProfileIdQueryVariables = {
  filter?: ModelUserProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  publicProfileId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserProfileByPublicProfileIdQuery = {
  listUserProfileByPublicProfileId?:  {
    __typename: "ModelUserProfileConnection",
    items:  Array< {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserSubscriptionByOwnerAndStatusQueryVariables = {
  filter?: ModelUserSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
  status?: ModelStringKeyConditionInput | null,
};

export type ListUserSubscriptionByOwnerAndStatusQuery = {
  listUserSubscriptionByOwnerAndStatus?:  {
    __typename: "ModelUserSubscriptionConnection",
    items:  Array< {
      __typename: "UserSubscription",
      createdAt: string,
      expirationDate?: string | null,
      id: string,
      owner?: string | null,
      productId: string,
      purchaseDate?: string | null,
      renewalDate?: string | null,
      status?: UserSubscriptionStatus | null,
      subscriptionId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserSubscriptionBySubscriptionIdQueryVariables = {
  filter?: ModelUserSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  subscriptionId: string,
};

export type ListUserSubscriptionBySubscriptionIdQuery = {
  listUserSubscriptionBySubscriptionId?:  {
    __typename: "ModelUserSubscriptionConnection",
    items:  Array< {
      __typename: "UserSubscription",
      createdAt: string,
      expirationDate?: string | null,
      id: string,
      owner?: string | null,
      productId: string,
      purchaseDate?: string | null,
      renewalDate?: string | null,
      status?: UserSubscriptionStatus | null,
      subscriptionId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserSubscriptionsQueryVariables = {
  filter?: ModelUserSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserSubscriptionsQuery = {
  listUserSubscriptions?:  {
    __typename: "ModelUserSubscriptionConnection",
    items:  Array< {
      __typename: "UserSubscription",
      createdAt: string,
      expirationDate?: string | null,
      id: string,
      owner?: string | null,
      productId: string,
      purchaseDate?: string | null,
      renewalDate?: string | null,
      status?: UserSubscriptionStatus | null,
      subscriptionId: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserTourByOwnerAndTypeQueryVariables = {
  filter?: ModelUserTourFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
  type?: ModelStringKeyConditionInput | null,
};

export type ListUserTourByOwnerAndTypeQuery = {
  listUserTourByOwnerAndType?:  {
    __typename: "ModelUserTourConnection",
    items:  Array< {
      __typename: "UserTour",
      completed?: boolean | null,
      completedAt?: string | null,
      createdAt: string,
      id: string,
      owner: string,
      type: UserTourType,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserTransactionByOwnerAndTransactionDateQueryVariables = {
  filter?: ModelUserTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  owner: string,
  sortDirection?: ModelSortDirection | null,
  transactionDate?: ModelStringKeyConditionInput | null,
};

export type ListUserTransactionByOwnerAndTransactionDateQuery = {
  listUserTransactionByOwnerAndTransactionDate?:  {
    __typename: "ModelUserTransactionConnection",
    items:  Array< {
      __typename: "UserTransaction",
      createdAt: string,
      currency?: string | null,
      id: string,
      owner?: string | null,
      price?: number | null,
      productId: string,
      store: string,
      transactionDate: string,
      type?: UserTransactionType | null,
      updatedAt: string,
      userSubscriptionId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserTransactionsQueryVariables = {
  filter?: ModelUserTransactionFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserTransactionsQuery = {
  listUserTransactions?:  {
    __typename: "ModelUserTransactionConnection",
    items:  Array< {
      __typename: "UserTransaction",
      createdAt: string,
      currency?: string | null,
      id: string,
      owner?: string | null,
      price?: number | null,
      productId: string,
      store: string,
      transactionDate: string,
      type?: UserTransactionType | null,
      updatedAt: string,
      userSubscriptionId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchEntitiesQueryVariables = {
  enableAutocomplete?: boolean | null,
  enableSuggestions?: boolean | null,
  pageSize?: number | null,
  pageStart?: number | null,
  query: string,
  userEntitlements?: Array< string | null > | null,
};

export type SearchEntitiesQuery = {
  searchEntities?:  {
    __typename: "searchResults",
    hits?:  Array< {
      __typename: "searchHitEntity",
      _id?: string | null,
      _index?: string | null,
      _score?: number | null,
    } | null > | null,
    suggest?: string | null,
    took?: number | null,
    total?: number | null,
  } | null,
};

export type SearchJournalsQueryVariables = {
  from?: number | null,
  journalType?: Array< string | null > | null,
  query?: string | null,
  size?: number | null,
  sortDirections?: Array< string | null > | null,
  sortFields?: Array< string | null > | null,
};

export type SearchJournalsQuery = {
  searchJournals:  Array< {
    __typename: "Journal",
    createdAt: string,
    customPrompts?: Array< string | null > | null,
    datetime: string,
    id: string,
    images?:  Array< {
      __typename: "JournalImage",
      height?: number | null,
      s3Key: string,
      width?: number | null,
    } | null > | null,
    journalType: JournalType,
    owner?: string | null,
    parentId?: string | null,
    responses?: Array< string | null > | null,
    updatedAt: string,
  } >,
};

export type SearchMeetupsQueryVariables = {
  from?: number | null,
  hosting?: boolean | null,
  liveState?: Array< string | null > | null,
  query?: string | null,
  size?: number | null,
  sortDirection?: SearchMeetupsSortDirection | null,
  sortField?: string | null,
  visibility?: Array< string | null > | null,
};

export type SearchMeetupsQuery = {
  searchMeetups?:  Array< {
    __typename: "Meetup",
    agenda: string,
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    chatRoomId?: string | null,
    createdAt: string,
    duration: number,
    endTime: string,
    hostReferralId?: string | null,
    liveState: MeetupLiveState,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    recurrenceId?: string | null,
    recurrenceRule?: string | null,
    roomUrl?: string | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    slugId: string,
    startTime: string,
    thumbnail?:  {
      __typename: "MeetupThumbnail",
      height?: number | null,
      url: string,
      width?: number | null,
    } | null,
    title: string,
    updatedAt: string,
    version?: number | null,
    visibility: EntityVisibility,
  } | null > | null,
};

export type SearchNotesQueryVariables = {
  entityType?: Array< string | null > | null,
  from?: number | null,
  parentType?: Array< string | null > | null,
  pinnedState?: SearchNotesPinnedState | null,
  query?: string | null,
  size?: number | null,
  sortDirections?: Array< string | null > | null,
  sortFields?: Array< string | null > | null,
};

export type SearchNotesQuery = {
  searchNotes:  Array< {
    __typename: "Note",
    content: string,
    createdAt?: string | null,
    entityId: string,
    entityType?: EntityType | null,
    noteItems?:  {
      __typename: "ModelNoteItemConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    parentId: string,
    parentType?: NoteParentType | null,
    pinnedState?: NotePinnedState | null,
    updatedAt: string,
  } >,
};

export type AddMessageMutationVariables = {
  content: string,
  mediaPosition: number,
  metadata?: string | null,
  pinnedState?: AddMessagePinnedState | null,
  roomId: string,
  type: string,
};

export type AddMessageMutation = {
  addMessage?:  {
    __typename: "Message",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    content: string,
    createdAt?: string | null,
    id: string,
    isEdited?: boolean | null,
    mediaPosition: number,
    metadata?: string | null,
    owner?: string | null,
    pinnedState?: MessagePinnedState | null,
    room?:  {
      __typename: "ChatRoom",
      bannedUsers?: Array< string | null > | null,
      createdAt?: string | null,
      entityId: string,
      id: string,
      moderators?: Array< string | null > | null,
      updatedAt: string,
    } | null,
    roomId: string,
    type: MessageType,
    updatedAt: string,
  } | null,
};

export type CalculateStripeTaxMutationVariables = {
  amounts: Array< number >,
  country: string,
  postalCode?: string | null,
  products: Array< string >,
  references: Array< string >,
};

export type CalculateStripeTaxMutation = {
  calculateStripeTax:  {
    __typename: "StripeTax",
    amountTotal: number,
    currency?: string | null,
    id?: string | null,
    lineItems:  Array< {
      __typename: "StripeTaxLineItem",
      amount: number,
      amountTax: number,
      id: string,
      product?: string | null,
      quantity: number,
      reference?: string | null,
      taxCode: string,
    } >,
    taxAmount: number,
    taxBreakdown:  Array< {
      __typename: "StripeTaxBreakdown",
      amount: number,
      flatAmount?: number | null,
      percentageDecimal?: string | null,
      rateType?: StripeTaxBreakdownRateType | null,
      taxType?: string | null,
      taxableAmount: number,
    } >,
  },
};

export type CancelMeetupsMutationVariables = {
  recurrenceId?: string | null,
  selectSeries?: boolean | null,
  slugId: string,
};

export type CancelMeetupsMutation = {
  cancelMeetups?:  {
    __typename: "UpdateMeetupBatchResponse",
    errors:  Array< {
      __typename: "UpdateMeetupBatchErrorResponse",
      reason?: string | null,
      slugId: string,
    } >,
    instances:  Array< {
      __typename: "UpdateMeetupBatchSuccessResponse",
      slugId: string,
    } >,
  } | null,
};

export type CancelRsvpToMeetupsMutationVariables = {
  recurrenceId?: string | null,
  selectSeries?: boolean | null,
  slugId: string,
};

export type CancelRsvpToMeetupsMutation = {
  cancelRsvpToMeetups?:  {
    __typename: "UpdateMeetupBatchResponse",
    errors:  Array< {
      __typename: "UpdateMeetupBatchErrorResponse",
      reason?: string | null,
      slugId: string,
    } >,
    instances:  Array< {
      __typename: "UpdateMeetupBatchSuccessResponse",
      slugId: string,
    } >,
  } | null,
};

export type CancelSubscriptionMutationVariables = {
  subscriptionId: string,
};

export type CancelSubscriptionMutation = {
  cancelSubscription?:  {
    __typename: "CancelSubscriptionResult",
    message?: string | null,
    success?: boolean | null,
  } | null,
};

export type CancelTeamMemberRenewalsMutationVariables = {
  ids?: Array< string | null > | null,
  teamId?: string | null,
};

export type CancelTeamMemberRenewalsMutation = {
  cancelTeamMemberRenewals?:  {
    __typename: "CancelTeamMemberRenewalsReturnType",
    ids?: Array< string | null > | null,
  } | null,
};

export type ChangeEmailMutationVariables = {
  newEmail: string,
};

export type ChangeEmailMutation = {
  changeEmail?:  {
    __typename: "ChangeEmailReturnType",
    newEmail?: string | null,
    oldEmail?: string | null,
    status?: string | null,
  } | null,
};

export type CompleteProfileMutationVariables = {
  family_name?: string | null,
  given_name?: string | null,
  name?: string | null,
  password?: string | null,
  phone_number?: string | null,
  subscribeToSms?: boolean | null,
};

export type CompleteProfileMutation = {
  completeProfile?:  {
    __typename: "CompleteProfileReturnType",
    family_name?: string | null,
    given_name?: string | null,
    name?: string | null,
    phone_number?: string | null,
    username: string,
  } | null,
};

export type CreateActiveViewSessionMutationVariables = {
  condition?: ModelActiveViewSessionConditionInput | null,
  input: CreateActiveViewSessionInput,
};

export type CreateActiveViewSessionMutation = {
  createActiveViewSession?:  {
    __typename: "ActiveViewSession",
    createdAt?: string | null,
    entityId: string,
    heartbeatCount: number,
    id: string,
    owner?: string | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    updatedAt?: string | null,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type CreateAppNotificationMutationVariables = {
  condition?: ModelAppNotificationConditionInput | null,
  input: CreateAppNotificationInput,
};

export type CreateAppNotificationMutation = {
  createAppNotification?:  {
    __typename: "AppNotification",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    content?: string | null,
    createdAt?: string | null,
    deeplink?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    notificationType: AppNotificationType,
    owner: string,
    sourceId: string,
    sourceType?: AppNotificationSourceType | null,
    status: AppNotificationStatus,
    title: string,
    updatedAt?: string | null,
  } | null,
};

export type CreateAssetMutationVariables = {
  condition?: ModelAssetConditionInput | null,
  input: CreateAssetInput,
};

export type CreateAssetMutation = {
  createAsset?:  {
    __typename: "Asset",
    assetType: AssetType,
    createdAt: string,
    description?: string | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    id: string,
    locator: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId?: string | null,
    title?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateBookmarkMutationVariables = {
  condition?: ModelBookmarkConditionInput | null,
  input: CreateBookmarkInput,
};

export type CreateBookmarkMutation = {
  createBookmark?:  {
    __typename: "Bookmark",
    createdAt?: string | null,
    entityType?: string | null,
    owner: string,
    parentId: string,
    parentType: string,
    updatedAt: string,
  } | null,
};

export type CreateCampaignMutationVariables = {
  condition?: ModelCampaignConditionInput | null,
  input: CreateCampaignInput,
};

export type CreateCampaignMutation = {
  createCampaign?:  {
    __typename: "Campaign",
    createdAt: string,
    id: string,
    isDefault?: boolean | null,
    offeringStack?:  {
      __typename: "OfferingStack",
      createdAt: string,
      id: string,
      offeringId: string,
      orderBumpId?: string | null,
      readableTitle: string,
      updatedAt: string,
    } | null,
    offeringStackId?: string | null,
    readableTitle: string,
    updatedAt: string,
  } | null,
};

export type CreateCdnAudioMutationVariables = {
  filename: string,
  partitionId: string,
  url: string,
};

export type CreateCdnAudioMutation = {
  createCdnAudio?:  {
    __typename: "CdnAudio",
    cdnUrl: string,
    id: string,
  } | null,
};

export type CreateCdnImageMutationVariables = {
  filename: string,
  partitionId: string,
};

export type CreateCdnImageMutation = {
  createCdnImage?:  {
    __typename: "CdnAssetUploadResponse",
    cdnUrl: string,
    checksum?: string | null,
    id: string,
    uploadUrl?: string | null,
    uploadUrlExpiration?: number | null,
    uploadUrlRequestMethod?: CdnAssetUploadResponseUploadUrlRequestMethod | null,
  } | null,
};

export type CreateChallengeProgressMutationVariables = {
  condition?: ModelChallengeProgressConditionInput | null,
  input: CreateChallengeProgressInput,
};

export type CreateChallengeProgressMutation = {
  createChallengeProgress?:  {
    __typename: "ChallengeProgress",
    children?:  Array< {
      __typename: "ChallengeDayProgress",
      coinsEarned?: number | null,
      completeTime?: string | null,
      entityId: string,
      id: string,
      startTime: string,
    } | null > | null,
    coinsEarned?: number | null,
    completeTime?: string | null,
    createdAt: string,
    endTime: string,
    entityId: string,
    id: string,
    owner?: string | null,
    startTime: string,
    type?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateChatRoomMutationVariables = {
  condition?: ModelChatRoomConditionInput | null,
  input: CreateChatRoomInput,
};

export type CreateChatRoomMutation = {
  createChatRoom?:  {
    __typename: "ChatRoom",
    bannedUsers?: Array< string | null > | null,
    createdAt?: string | null,
    entityId: string,
    id: string,
    messages?:  {
      __typename: "ModelMessageConnection",
      nextToken?: string | null,
    } | null,
    moderators?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type CreateChecklistMutationVariables = {
  condition?: ModelChecklistConditionInput | null,
  input: CreateChecklistInput,
};

export type CreateChecklistMutation = {
  createChecklist?:  {
    __typename: "Checklist",
    completed?: boolean | null,
    createdAt: string,
    date: string,
    items?:  Array< {
      __typename: "ItemCompletion",
      completed?: boolean | null,
      deleted?: boolean | null,
      itemId?: string | null,
      order?: number | null,
    } | null > | null,
    owner: string,
    started?: boolean | null,
    updatedAt: string,
  } | null,
};

export type CreateChecklistItemMutationVariables = {
  condition?: ModelChecklistItemConditionInput | null,
  input: CreateChecklistItemInput,
};

export type CreateChecklistItemMutation = {
  createChecklistItem?:  {
    __typename: "ChecklistItem",
    createdAt: string,
    date: string,
    endDate?: string | null,
    frequency: ItemFrequency,
    id: string,
    order?: number | null,
    owner: string,
    title: string,
    updatedAt: string,
    weekday: DayOfWeek,
  } | null,
};

export type CreateCommentMutationVariables = {
  condition?: ModelCommentConditionInput | null,
  input: CreateCommentInput,
};

export type CreateCommentMutation = {
  createComment?:  {
    __typename: "Comment",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    commentsCount?: number | null,
    content: string,
    createdAt?: string | null,
    id: string,
    images?:  Array< {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null > | null,
    isEdited?: boolean | null,
    likes?:  {
      __typename: "ModelCommentLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount?: number | null,
    owner?: string | null,
    parent?:  {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null,
    parentId: string,
    parentType?: CommentParentType | null,
    pinnedState?: CommentPinnedState | null,
    replies?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    threadId: string,
    type?: CommentType | null,
    updatedAt: string,
    version?: number | null,
    visibility: CommentVisibility,
  } | null,
};

export type CreateCommentLikeMutationVariables = {
  condition?: ModelCommentLikeConditionInput | null,
  input: CreateCommentLikeInput,
};

export type CreateCommentLikeMutation = {
  createCommentLike?:  {
    __typename: "CommentLike",
    comment?:  {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null,
    commentId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    threadId: string,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type CreateCommentWithSpamFilterMutationVariables = {
  content: string,
  images?: string | null,
  parentId: string,
  parentType?: CreateCommentWithSpamFilterParentType | null,
  pinnedState?: CreateCommentWithSpamFilterPinnedState | null,
  threadId: string,
  type?: CreateCommentWithSpamFilterType | null,
  version?: number | null,
  visibility?: CreateCommentWithSpamFilterVisibility | null,
};

export type CreateCommentWithSpamFilterMutation = {
  createCommentWithSpamFilter?:  {
    __typename: "CommentMutationOutput",
    author?:  {
      __typename: "CommentMutationOutputAuthor",
      displayName?: string | null,
      publicProfileId?: string | null,
    } | null,
    content: string,
    createdAt?: string | null,
    id: string,
    images?:  Array< {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null > | null,
    owner: string,
    parentId?: string | null,
    parentType?: CommentParentType | null,
    pinnedState?: CommentPinnedState | null,
    threadId?: string | null,
    type?: CommentType | null,
    updatedAt?: string | null,
    version?: number | null,
    visibility?: CommentVisibility | null,
  } | null,
};

export type CreateCourseCertificateMutationVariables = {
  condition?: ModelCourseCertificateConditionInput | null,
  input: CreateCourseCertificateInput,
};

export type CreateCourseCertificateMutation = {
  createCourseCertificate?:  {
    __typename: "CourseCertificate",
    createdAt?: string | null,
    entityId: string,
    image:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    },
    owner: string,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type CreateDailyLifescoreMutationVariables = {
  condition?: ModelDailyLifescoreConditionInput | null,
  input: CreateDailyLifescoreInput,
};

export type CreateDailyLifescoreMutation = {
  createDailyLifescore?:  {
    __typename: "DailyLifescore",
    averageScorePercentage: number,
    clarityScore: number,
    courageScore: number,
    createdAt?: string | null,
    energyScore: number,
    id: string,
    influenceScore: number,
    moodScore: number,
    movementScore: number,
    necessityScore: number,
    nutritionScore: number,
    owner?: string | null,
    parentId?: string | null,
    productivityScore: number,
    sleepScore: number,
    updatedAt: string,
  } | null,
};

export type CreateDashboardCardMutationVariables = {
  condition?: ModelDashboardCardConditionInput | null,
  input: CreateDashboardCardInput,
};

export type CreateDashboardCardMutation = {
  createDashboardCard?:  {
    __typename: "DashboardCard",
    children?:  {
      __typename: "ModelDashboardCardItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    date: string,
    updatedAt: string,
  } | null,
};

export type CreateDashboardCardItemMutationVariables = {
  condition?: ModelDashboardCardItemConditionInput | null,
  input: CreateDashboardCardItemInput,
};

export type CreateDashboardCardItemMutation = {
  createDashboardCardItem?:  {
    __typename: "DashboardCardItem",
    assessmentType?: DashboardCardItemAssessmentType | null,
    createdAt: string,
    customPrompt?: string | null,
    date: string,
    entityHasEntitlements?: boolean | null,
    entityId?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    nonEntitledEntityId?: string | null,
    order: number,
    parent?:  {
      __typename: "DashboardCard",
      createdAt: string,
      date: string,
      updatedAt: string,
    } | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    type?: DashboardCardItemType | null,
    updatedAt: string,
  } | null,
};

export type CreateDashboardProgressMutationVariables = {
  condition?: ModelDashboardProgressConditionInput | null,
  input: CreateDashboardProgressInput,
};

export type CreateDashboardProgressMutation = {
  createDashboardProgress?:  {
    __typename: "DashboardProgress",
    children?:  Array< {
      __typename: "DashboardProgressItem",
      completeTime?: string | null,
      parentId: string,
      upsellRejected?: boolean | null,
    } > | null,
    completeTime?: string | null,
    createdAt: string,
    date: string,
    owner: string,
    updatedAt: string,
  } | null,
};

export type CreateDashboardStreakMutationVariables = {
  condition?: ModelDashboardStreakConditionInput | null,
  input: CreateDashboardStreakInput,
};

export type CreateDashboardStreakMutation = {
  createDashboardStreak?:  {
    __typename: "DashboardStreak",
    count: number,
    createdAt: string,
    id: string,
    lastActiveDate: string,
    leaderboards?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    startDate: string,
    updatedAt: string,
  } | null,
};

export type CreateEntityMutationVariables = {
  condition?: ModelEntityConditionInput | null,
  input: CreateEntityInput,
};

export type CreateEntityMutation = {
  createEntity?:  {
    __typename: "Entity",
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    description?: string | null,
    duration?: number | null,
    enforceEntitlementsAt?: number | null,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    liveState?: EntityLiveState | null,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    order?: number | null,
    parent?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    parentId?: string | null,
    publishAt?: string | null,
    redirectId?: string | null,
    requiredEntitlements?: Array< string | null > | null,
    rootEntityId?: string | null,
    shareContent?:  {
      __typename: "EntityShareContent",
      description?: string | null,
      title?: string | null,
    } | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    startTime?: string | null,
    tags?: Array< string | null > | null,
    title: string,
    updatedAt: string,
    validUntil?: string | null,
    visibility: EntityVisibility,
  } | null,
};

export type CreateEntityLikeMutationVariables = {
  condition?: ModelEntityLikeConditionInput | null,
  input: CreateEntityLikeInput,
};

export type CreateEntityLikeMutation = {
  createEntityLike?:  {
    __typename: "EntityLike",
    createdAt: string,
    entityId: string,
    id: string,
    owner?: string | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type CreateEntityRelationsMutationVariables = {
  condition?: ModelEntityRelationsConditionInput | null,
  input: CreateEntityRelationsInput,
};

export type CreateEntityRelationsMutation = {
  createEntityRelations?:  {
    __typename: "EntityRelations",
    childId: string,
    createdAt: string,
    entities?:  {
      __typename: "ModelEntityConnection",
      nextToken?: string | null,
    } | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    id: string,
    updatedAt: string,
  } | null,
};

export type CreateEventRsvpMutationVariables = {
  condition?: ModelEventRsvpConditionInput | null,
  input: CreateEventRsvpInput,
};

export type CreateEventRsvpMutation = {
  createEventRsvp?:  {
    __typename: "EventRsvp",
    createdAt?: string | null,
    eventStartTime: string,
    meetup?:  {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null,
    meetupId?: string | null,
    owner: string,
    parentId: string,
    parentType?: EventRsvpParentType | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    socialProofId?: string | null,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type CreateGiftRecipientMutationVariables = {
  condition?: ModelGiftRecipientConditionInput | null,
  input: CreateGiftRecipientInput,
};

export type CreateGiftRecipientMutation = {
  createGiftRecipient?:  {
    __typename: "GiftRecipient",
    buyerId: string,
    createdAt?: string | null,
    email?: string | null,
    firstName?: string | null,
    id: string,
    lastName?: string | null,
    owner: string,
    stripePriceId?: string | null,
    subscriptionId?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateGiftSubscriptionsMutationVariables = {
  buyerFirstName?: string | null,
  buyerLastName?: string | null,
  emails?: Array< string | null > | null,
  firstNames?: Array< string | null > | null,
  lastNames?: Array< string | null > | null,
  paymentMethodId: string,
  stripePriceIds?: Array< string | null > | null,
};

export type CreateGiftSubscriptionsMutation = {
  createGiftSubscriptions?:  {
    __typename: "CreateGiftSubscriptionsReturnType",
    executionArn?: string | null,
  } | null,
};

export type CreateGrowthCoinStatsMutationVariables = {
  condition?: ModelGrowthCoinStatsConditionInput | null,
  input: CreateGrowthCoinStatsInput,
};

export type CreateGrowthCoinStatsMutation = {
  createGrowthCoinStats?:  {
    __typename: "GrowthCoinStats",
    createdAt: string,
    currentMonth: string,
    monthCoins: number,
    owner: string,
    source: string,
    sourceEvent: string,
    totalCoins: number,
    updatedAt: string,
    version?: number | null,
  } | null,
};

export type CreateGrowthCoinTransactionMutationVariables = {
  condition?: ModelGrowthCoinTransactionConditionInput | null,
  input: CreateGrowthCoinTransactionInput,
};

export type CreateGrowthCoinTransactionMutation = {
  createGrowthCoinTransaction?:  {
    __typename: "GrowthCoinTransaction",
    coinsAdded: number,
    createdAt?: string | null,
    endBalance: number,
    id: string,
    owner?: string | null,
    source: GrowthCoinTransactionSource,
    sourceEvent: GrowthCoinTransactionSourceEvent,
    startBalance: number,
    updatedAt: string,
  } | null,
};

export type CreateJournalMutationVariables = {
  condition?: ModelJournalConditionInput | null,
  input: CreateJournalInput,
};

export type CreateJournalMutation = {
  createJournal?:  {
    __typename: "Journal",
    createdAt: string,
    customPrompts?: Array< string | null > | null,
    datetime: string,
    id: string,
    images?:  Array< {
      __typename: "JournalImage",
      height?: number | null,
      s3Key: string,
      width?: number | null,
    } | null > | null,
    journalType: JournalType,
    owner?: string | null,
    parentId?: string | null,
    responses?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type CreateLeaderboardMutationVariables = {
  condition?: ModelLeaderboardConditionInput | null,
  input: CreateLeaderboardInput,
};

export type CreateLeaderboardMutation = {
  createLeaderboard?:  {
    __typename: "Leaderboard",
    createdAt: string,
    dashboardStreaks?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    highestStreakCount: number,
    highestStreakCountAndTotalCoinsCount: string,
    month: string,
    owner: string,
    profile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    ranking?: number | null,
    totalCoinsCount: number,
    totalLeadsCount?: number | null,
    totalReferralsCount: number,
    totalReferralsCountAndTotalLeadsCount?: string | null,
    totalStreaksCount: number,
    updatedAt: string,
    userProfileId: string,
  } | null,
};

export type CreateLeaderboardDashboardStreakMutationVariables = {
  condition?: ModelLeaderboardDashboardStreakConditionInput | null,
  input: CreateLeaderboardDashboardStreakInput,
};

export type CreateLeaderboardDashboardStreakMutation = {
  createLeaderboardDashboardStreak?:  {
    __typename: "LeaderboardDashboardStreak",
    createdAt: string,
    dashboardStreak?:  {
      __typename: "DashboardStreak",
      count: number,
      createdAt: string,
      id: string,
      lastActiveDate: string,
      owner: string,
      startDate: string,
      updatedAt: string,
    } | null,
    dashboardStreakId: string,
    id: string,
    leaderboard?:  {
      __typename: "Leaderboard",
      createdAt: string,
      highestStreakCount: number,
      highestStreakCountAndTotalCoinsCount: string,
      month: string,
      owner: string,
      ranking?: number | null,
      totalCoinsCount: number,
      totalLeadsCount?: number | null,
      totalReferralsCount: number,
      totalReferralsCountAndTotalLeadsCount?: string | null,
      totalStreaksCount: number,
      updatedAt: string,
      userProfileId: string,
    } | null,
    month: string,
    owner: string,
    updatedAt: string,
  } | null,
};

export type CreateMeetupMutationVariables = {
  condition?: ModelMeetupConditionInput | null,
  input: CreateMeetupInput,
};

export type CreateMeetupMutation = {
  createMeetup?:  {
    __typename: "Meetup",
    agenda: string,
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    chatRoomId?: string | null,
    createdAt: string,
    duration: number,
    endTime: string,
    hostReferralId?: string | null,
    liveState: MeetupLiveState,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    recurrenceId?: string | null,
    recurrenceRule?: string | null,
    roomUrl?: string | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    slugId: string,
    startTime: string,
    thumbnail?:  {
      __typename: "MeetupThumbnail",
      height?: number | null,
      url: string,
      width?: number | null,
    } | null,
    title: string,
    updatedAt: string,
    version?: number | null,
    visibility: EntityVisibility,
  } | null,
};

export type CreateMeetupsMutationVariables = {
  agenda: string,
  duration: number,
  hostReferralId?: string | null,
  recurrenceRule?: string | null,
  startTime: string,
  thumbnailHeight: number,
  thumbnailUrl: string,
  thumbnailWidth: number,
  title: string,
  visibility?: CreateMeetupsVisibility | null,
};

export type CreateMeetupsMutation = {
  createMeetups?:  {
    __typename: "CreateMeetupBatchResponse",
    errors:  Array< {
      __typename: "CreateMeetupBatchErrorResponse",
      reason?: string | null,
      startTime: string,
    } >,
    instances:  Array< {
      __typename: "CreateMeetupBatchSuccessResponse",
      slugId: string,
      startTime: string,
    } >,
  } | null,
};

export type CreateMessageMutationVariables = {
  condition?: ModelMessageConditionInput | null,
  input: CreateMessageInput,
};

export type CreateMessageMutation = {
  createMessage?:  {
    __typename: "Message",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    content: string,
    createdAt?: string | null,
    id: string,
    isEdited?: boolean | null,
    mediaPosition: number,
    metadata?: string | null,
    owner?: string | null,
    pinnedState?: MessagePinnedState | null,
    room?:  {
      __typename: "ChatRoom",
      bannedUsers?: Array< string | null > | null,
      createdAt?: string | null,
      entityId: string,
      id: string,
      moderators?: Array< string | null > | null,
      updatedAt: string,
    } | null,
    roomId: string,
    type: MessageType,
    updatedAt: string,
  } | null,
};

export type CreateMonthlyLifescoreMutationVariables = {
  condition?: ModelMonthlyLifescoreConditionInput | null,
  input: CreateMonthlyLifescoreInput,
};

export type CreateMonthlyLifescoreMutation = {
  createMonthlyLifescore?:  {
    __typename: "MonthlyLifescore",
    averageScorePercentage: number,
    createdAt?: string | null,
    experienceScore: number,
    familyScore: number,
    financeScore: number,
    friendScore: number,
    healthScore: number,
    id: string,
    learningScore: number,
    mentalAndEmotionalScore: number,
    missionScore: number,
    owner?: string | null,
    parentId?: string | null,
    partnerAndLoveScore: number,
    spiritScore: number,
    updatedAt: string,
  } | null,
};

export type CreateNoteMutationVariables = {
  condition?: ModelNoteConditionInput | null,
  input: CreateNoteInput,
};

export type CreateNoteMutation = {
  createNote?:  {
    __typename: "Note",
    content: string,
    createdAt?: string | null,
    entityId: string,
    entityType?: EntityType | null,
    noteItems?:  {
      __typename: "ModelNoteItemConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    parentId: string,
    parentType?: NoteParentType | null,
    pinnedState?: NotePinnedState | null,
    updatedAt: string,
  } | null,
};

export type CreateNoteItemMutationVariables = {
  condition?: ModelNoteItemConditionInput | null,
  input: CreateNoteItemInput,
};

export type CreateNoteItemMutation = {
  createNoteItem?:  {
    __typename: "NoteItem",
    content: string,
    createdAt: string,
    entityId: string,
    entityType?: EntityType | null,
    id: string,
    note?:  {
      __typename: "Note",
      content: string,
      createdAt?: string | null,
      entityId: string,
      entityType?: EntityType | null,
      owner: string,
      parentId: string,
      parentType?: NoteParentType | null,
      pinnedState?: NotePinnedState | null,
      updatedAt: string,
    } | null,
    noteOwner: string,
    owner?: string | null,
    parentId: string,
    parentType?: NoteItemParentType | null,
    timestamp: number,
    updatedAt: string,
  } | null,
};

export type CreateNotificationLogMutationVariables = {
  condition?: ModelNotificationLogConditionInput | null,
  input: CreateNotificationLogInput,
};

export type CreateNotificationLogMutation = {
  createNotificationLog?:  {
    __typename: "NotificationLog",
    challengeDayProgressId?: string | null,
    createdAt: string,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    id: string,
    meetup?:  {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null,
    meetupSlugId?: string | null,
    name?: NotificationLogName | null,
    updatedAt: string,
  } | null,
};

export type CreateOfferingMutationVariables = {
  condition?: ModelOfferingConditionInput | null,
  input: CreateOfferingInput,
};

export type CreateOfferingMutation = {
  createOffering?:  {
    __typename: "Offering",
    createdAt: string,
    cta?: string | null,
    description?: string | null,
    heading?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    media?:  {
      __typename: "Asset",
      assetType: AssetType,
      createdAt: string,
      description?: string | null,
      entityId?: string | null,
      id: string,
      locator: string,
      offeringId?: string | null,
      title?: string | null,
      updatedAt: string,
    } | null,
    offeringStackOfferings?:  {
      __typename: "ModelOfferingStackConnection",
      nextToken?: string | null,
    } | null,
    offeringStackOrderBumps?:  {
      __typename: "ModelOfferingStackConnection",
      nextToken?: string | null,
    } | null,
    offeringStackUpsellOfferings?:  {
      __typename: "ModelOfferingStackUpsellConnection",
      nextToken?: string | null,
    } | null,
    overrides?:  {
      __typename: "OfferingOverrides",
      skipCreditCard?: boolean | null,
      trialDuration?: number | null,
      trialFrequency?: OfferingOverridesTrialFrequency | null,
    } | null,
    productBundle?:  {
      __typename: "ModelOfferingProductBundleConnection",
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOfferingProductConnection",
      nextToken?: string | null,
    } | null,
    readableTitle: string,
    redirectUrl?: string | null,
    shortDescription?: string | null,
    showGuarantee?: boolean | null,
    skipEmailCollectionStep?: boolean | null,
    step1Title?: string | null,
    step2Title?: string | null,
    type?: OfferingType | null,
    updatedAt: string,
  } | null,
};

export type CreateOfferingProductMutationVariables = {
  condition?: ModelOfferingProductConditionInput | null,
  input: CreateOfferingProductInput,
};

export type CreateOfferingProductMutation = {
  createOfferingProduct?:  {
    __typename: "OfferingProduct",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    updatedAt: string,
  } | null,
};

export type CreateOfferingProductBundleMutationVariables = {
  condition?: ModelOfferingProductBundleConditionInput | null,
  input: CreateOfferingProductBundleInput,
};

export type CreateOfferingProductBundleMutation = {
  createOfferingProductBundle?:  {
    __typename: "OfferingProductBundle",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    overrides?:  {
      __typename: "OfferingOverrides",
      skipCreditCard?: boolean | null,
      trialDuration?: number | null,
      trialFrequency?: OfferingOverridesTrialFrequency | null,
    } | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    readableTitle: string,
    updatedAt: string,
  } | null,
};

export type CreateOfferingStackMutationVariables = {
  condition?: ModelOfferingStackConditionInput | null,
  input: CreateOfferingStackInput,
};

export type CreateOfferingStackMutation = {
  createOfferingStack?:  {
    __typename: "OfferingStack",
    campaign?:  {
      __typename: "ModelCampaignConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    orderBump?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    orderBumpId?: string | null,
    readableTitle: string,
    updatedAt: string,
    upsell?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
  } | null,
};

export type CreateOfferingStackUpsellMutationVariables = {
  condition?: ModelOfferingStackUpsellConditionInput | null,
  input: CreateOfferingStackUpsellInput,
};

export type CreateOfferingStackUpsellMutation = {
  createOfferingStackUpsell?:  {
    __typename: "OfferingStackUpsell",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    offeringStack?:  {
      __typename: "OfferingStack",
      createdAt: string,
      id: string,
      offeringId: string,
      orderBumpId?: string | null,
      readableTitle: string,
      updatedAt: string,
    } | null,
    offeringStackId?: string | null,
    updatedAt: string,
    upsellNo?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellNoId?: string | null,
    upsellNoParent?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellYes?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellYesId?: string | null,
    upsellYesParent?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
  } | null,
};

export type CreateProductMutationVariables = {
  condition?: ModelProductConditionInput | null,
  input: CreateProductInput,
};

export type CreateProductMutation = {
  createProduct?:  {
    __typename: "Product",
    billingInterval?: ProductBillingInterval | null,
    businessUnit?: ProductBusinessUnit | null,
    createdAt: string,
    description?: string | null,
    entitlements?:  Array< {
      __typename: "EntitlementCustomType",
      identifier: string,
      revenueCatEntitlementId?: string | null,
    } | null > | null,
    id: string,
    name: string,
    offerings?:  {
      __typename: "ModelOfferingProductConnection",
      nextToken?: string | null,
    } | null,
    priceId?: string | null,
    productBundle?:  {
      __typename: "ModelOfferingProductBundleConnection",
      nextToken?: string | null,
    } | null,
    productCategory?: string | null,
    productId: string,
    productNamespace: string,
    store?: ProductStore | null,
    subscriptionGroup?: ProductSubscriptionGroup | null,
    updatedAt: string,
    userSubscriptions?:  {
      __typename: "ModelUserSubscriptionConnection",
      nextToken?: string | null,
    } | null,
    userTransactions?:  {
      __typename: "ModelUserTransactionConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateRecentlyPlayedMutationVariables = {
  condition?: ModelRecentlyPlayedConditionInput | null,
  input: CreateRecentlyPlayedInput,
};

export type CreateRecentlyPlayedMutation = {
  createRecentlyPlayed?:  {
    __typename: "RecentlyPlayed",
    children?:  Array< {
      __typename: "RecentlyPlayedChild",
      completeTime?: string | null,
      entityId?: string | null,
      lastPlayedAt: string,
      playbackPercentage: number,
    } | null > | null,
    completeTime?: string | null,
    createdAt: string,
    entityId: string,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    lastPlayedAt: string,
    owner?: string | null,
    playbackPercentage: number,
    updatedAt: string,
  } | null,
};

export type CreateSocialProofMutationVariables = {
  condition?: ModelSocialProofConditionInput | null,
  input: CreateSocialProofInput,
};

export type CreateSocialProofMutation = {
  createSocialProof?:  {
    __typename: "SocialProof",
    commentsCount?: number | null,
    createdAt: string,
    dashboardCardItem?:  {
      __typename: "DashboardCardItem",
      assessmentType?: DashboardCardItemAssessmentType | null,
      createdAt: string,
      customPrompt?: string | null,
      date: string,
      entityHasEntitlements?: boolean | null,
      entityId?: string | null,
      id: string,
      nonEntitledEntityId?: string | null,
      order: number,
      type?: DashboardCardItemType | null,
      updatedAt: string,
    } | null,
    dashboardCardItemId?: string | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    entityLikes?:  {
      __typename: "ModelEntityLikeConnection",
      nextToken?: string | null,
    } | null,
    joinCount?: number | null,
    likesCount?: number | null,
    parentId: string,
    parentType?: SocialProofParentType | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    sharesCount?: number | null,
    updatedAt: string,
    version?: number | null,
    viewSessions?:  {
      __typename: "ModelActiveViewSessionConnection",
      nextToken?: string | null,
    } | null,
    viewerCount?: number | null,
  } | null,
};

export type CreateTeamMutationVariables = {
  condition?: ModelTeamConditionInput | null,
  input: CreateTeamInput,
};

export type CreateTeamMutation = {
  createTeam?:  {
    __typename: "Team",
    createdAt: string,
    id: string,
    invitationState?: TeamInvitationState | null,
    members?:  {
      __typename: "ModelTeamMemberConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    subscriptionId?: string | null,
    subscriptionItemId?: string | null,
    subscriptionState?: TeamSubscriptionState | null,
    totalSeats?: number | null,
    updatedAt: string,
    usedSeats?: number | null,
    version?: number | null,
  } | null,
};

export type CreateTeamMemberMutationVariables = {
  condition?: ModelTeamMemberConditionInput | null,
  input: CreateTeamMemberInput,
};

export type CreateTeamMemberMutation = {
  createTeamMember?:  {
    __typename: "TeamMember",
    createdAt: string,
    email?: string | null,
    firstName?: string | null,
    id: string,
    lastName?: string | null,
    owner: string,
    subscriptionState?: TeamSubscriptionState | null,
    team?:  {
      __typename: "Team",
      createdAt: string,
      id: string,
      invitationState?: TeamInvitationState | null,
      owner: string,
      stripePriceId?: string | null,
      stripeProductId?: string | null,
      subscriptionId?: string | null,
      subscriptionItemId?: string | null,
      subscriptionState?: TeamSubscriptionState | null,
      totalSeats?: number | null,
      updatedAt: string,
      usedSeats?: number | null,
      version?: number | null,
    } | null,
    teamId: string,
    updatedAt: string,
  } | null,
};

export type CreateUserExternalIdentifierMutationVariables = {
  condition?: ModelUserExternalIdentifierConditionInput | null,
  input: CreateUserExternalIdentifierInput,
};

export type CreateUserExternalIdentifierMutation = {
  createUserExternalIdentifier?:  {
    __typename: "UserExternalIdentifier",
    createdAt: string,
    externalIdentifier: string,
    owner: string,
    type?: UserExternalIdentifierType | null,
    updatedAt: string,
  } | null,
};

export type CreateUserProfileMutationVariables = {
  condition?: ModelUserProfileConditionInput | null,
  input: CreateUserProfileInput,
};

export type CreateUserProfileMutation = {
  createUserProfile?:  {
    __typename: "UserProfile",
    activeViewSessions?:  {
      __typename: "ModelActiveViewSessionConnection",
      nextToken?: string | null,
    } | null,
    attributes?:  {
      __typename: "UserAttributes",
      intents?: Array< string | null > | null,
      surveyCustCategory?: UserAttributesSurveyCustCategory | null,
      surveyInterests?: Array< string | null > | null,
    } | null,
    badges?:  {
      __typename: "UserProfileBadges",
      chpc?: boolean | null,
      growthday?: boolean | null,
      ultra?: boolean | null,
    } | null,
    bio?: string | null,
    certificates?:  {
      __typename: "ModelCourseCertificateConnection",
      nextToken?: string | null,
    } | null,
    commentLikes?:  {
      __typename: "ModelCommentLikeConnection",
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    cover?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    createdAt?: string | null,
    displayName?: string | null,
    entityLikes?:  {
      __typename: "ModelEntityLikeConnection",
      nextToken?: string | null,
    } | null,
    experimentMetadata?:  {
      __typename: "UserProfileExperimentMetadata",
      mozartUser?: boolean | null,
    } | null,
    leaderboards?:  {
      __typename: "ModelLeaderboardConnection",
      nextToken?: string | null,
    } | null,
    meetups?:  {
      __typename: "ModelMeetupConnection",
      nextToken?: string | null,
    } | null,
    messages?:  {
      __typename: "ModelMessageConnection",
      nextToken?: string | null,
    } | null,
    notifications?:  {
      __typename: "ModelAppNotificationConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    profileImage?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    publicProfileId: string,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    socialMediaLinks?:  {
      __typename: "SocialMediaLinks",
      facebook?: string | null,
      instagram?: string | null,
      linkedin?: string | null,
      website?: string | null,
      x?: string | null,
    } | null,
    totalCoinsCount?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateUserSubscriptionMutationVariables = {
  condition?: ModelUserSubscriptionConditionInput | null,
  input: CreateUserSubscriptionInput,
};

export type CreateUserSubscriptionMutation = {
  createUserSubscription?:  {
    __typename: "UserSubscription",
    createdAt: string,
    expirationDate?: string | null,
    id: string,
    owner?: string | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    purchaseDate?: string | null,
    renewalDate?: string | null,
    status?: UserSubscriptionStatus | null,
    subscriptionId: string,
    updatedAt: string,
    userTransactions?:  {
      __typename: "ModelUserTransactionConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateUserTourMutationVariables = {
  condition?: ModelUserTourConditionInput | null,
  input: CreateUserTourInput,
};

export type CreateUserTourMutation = {
  createUserTour?:  {
    __typename: "UserTour",
    completed?: boolean | null,
    completedAt?: string | null,
    createdAt: string,
    id: string,
    owner: string,
    type: UserTourType,
    updatedAt: string,
  } | null,
};

export type CreateUserTransactionMutationVariables = {
  condition?: ModelUserTransactionConditionInput | null,
  input: CreateUserTransactionInput,
};

export type CreateUserTransactionMutation = {
  createUserTransaction?:  {
    __typename: "UserTransaction",
    createdAt: string,
    currency?: string | null,
    id: string,
    owner?: string | null,
    price?: number | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    store: string,
    transactionDate: string,
    type?: UserTransactionType | null,
    updatedAt: string,
    userSubscription?:  {
      __typename: "UserSubscription",
      createdAt: string,
      expirationDate?: string | null,
      id: string,
      owner?: string | null,
      productId: string,
      purchaseDate?: string | null,
      renewalDate?: string | null,
      status?: UserSubscriptionStatus | null,
      subscriptionId: string,
      updatedAt: string,
    } | null,
    userSubscriptionId?: string | null,
  } | null,
};

export type DeleteActiveViewSessionMutationVariables = {
  condition?: ModelActiveViewSessionConditionInput | null,
  input: DeleteActiveViewSessionInput,
};

export type DeleteActiveViewSessionMutation = {
  deleteActiveViewSession?:  {
    __typename: "ActiveViewSession",
    createdAt?: string | null,
    entityId: string,
    heartbeatCount: number,
    id: string,
    owner?: string | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    updatedAt?: string | null,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type DeleteAssetMutationVariables = {
  condition?: ModelAssetConditionInput | null,
  input: DeleteAssetInput,
};

export type DeleteAssetMutation = {
  deleteAsset?:  {
    __typename: "Asset",
    assetType: AssetType,
    createdAt: string,
    description?: string | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    id: string,
    locator: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId?: string | null,
    title?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteBookmarkMutationVariables = {
  condition?: ModelBookmarkConditionInput | null,
  input: DeleteBookmarkInput,
};

export type DeleteBookmarkMutation = {
  deleteBookmark?:  {
    __typename: "Bookmark",
    createdAt?: string | null,
    entityType?: string | null,
    owner: string,
    parentId: string,
    parentType: string,
    updatedAt: string,
  } | null,
};

export type DeleteCampaignMutationVariables = {
  condition?: ModelCampaignConditionInput | null,
  input: DeleteCampaignInput,
};

export type DeleteCampaignMutation = {
  deleteCampaign?:  {
    __typename: "Campaign",
    createdAt: string,
    id: string,
    isDefault?: boolean | null,
    offeringStack?:  {
      __typename: "OfferingStack",
      createdAt: string,
      id: string,
      offeringId: string,
      orderBumpId?: string | null,
      readableTitle: string,
      updatedAt: string,
    } | null,
    offeringStackId?: string | null,
    readableTitle: string,
    updatedAt: string,
  } | null,
};

export type DeleteCdnImageMutationVariables = {
  id: string,
};

export type DeleteCdnImageMutation = {
  deleteCdnImage?:  {
    __typename: "CdnAssetDeleteResponse",
    id: string,
  } | null,
};

export type DeleteChecklistMutationVariables = {
  condition?: ModelChecklistConditionInput | null,
  input: DeleteChecklistInput,
};

export type DeleteChecklistMutation = {
  deleteChecklist?:  {
    __typename: "Checklist",
    completed?: boolean | null,
    createdAt: string,
    date: string,
    items?:  Array< {
      __typename: "ItemCompletion",
      completed?: boolean | null,
      deleted?: boolean | null,
      itemId?: string | null,
      order?: number | null,
    } | null > | null,
    owner: string,
    started?: boolean | null,
    updatedAt: string,
  } | null,
};

export type DeleteChecklistItemMutationVariables = {
  condition?: ModelChecklistItemConditionInput | null,
  input: DeleteChecklistItemInput,
};

export type DeleteChecklistItemMutation = {
  deleteChecklistItem?:  {
    __typename: "ChecklistItem",
    createdAt: string,
    date: string,
    endDate?: string | null,
    frequency: ItemFrequency,
    id: string,
    order?: number | null,
    owner: string,
    title: string,
    updatedAt: string,
    weekday: DayOfWeek,
  } | null,
};

export type DeleteCommentMutationVariables = {
  condition?: ModelCommentConditionInput | null,
  input: DeleteCommentInput,
};

export type DeleteCommentMutation = {
  deleteComment?:  {
    __typename: "Comment",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    commentsCount?: number | null,
    content: string,
    createdAt?: string | null,
    id: string,
    images?:  Array< {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null > | null,
    isEdited?: boolean | null,
    likes?:  {
      __typename: "ModelCommentLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount?: number | null,
    owner?: string | null,
    parent?:  {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null,
    parentId: string,
    parentType?: CommentParentType | null,
    pinnedState?: CommentPinnedState | null,
    replies?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    threadId: string,
    type?: CommentType | null,
    updatedAt: string,
    version?: number | null,
    visibility: CommentVisibility,
  } | null,
};

export type DeleteCommentLikeMutationVariables = {
  condition?: ModelCommentLikeConditionInput | null,
  input: DeleteCommentLikeInput,
};

export type DeleteCommentLikeMutation = {
  deleteCommentLike?:  {
    __typename: "CommentLike",
    comment?:  {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null,
    commentId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    threadId: string,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type DeleteDailyLifescoreMutationVariables = {
  condition?: ModelDailyLifescoreConditionInput | null,
  input: DeleteDailyLifescoreInput,
};

export type DeleteDailyLifescoreMutation = {
  deleteDailyLifescore?:  {
    __typename: "DailyLifescore",
    averageScorePercentage: number,
    clarityScore: number,
    courageScore: number,
    createdAt?: string | null,
    energyScore: number,
    id: string,
    influenceScore: number,
    moodScore: number,
    movementScore: number,
    necessityScore: number,
    nutritionScore: number,
    owner?: string | null,
    parentId?: string | null,
    productivityScore: number,
    sleepScore: number,
    updatedAt: string,
  } | null,
};

export type DeleteDashboardCardMutationVariables = {
  condition?: ModelDashboardCardConditionInput | null,
  input: DeleteDashboardCardInput,
};

export type DeleteDashboardCardMutation = {
  deleteDashboardCard?:  {
    __typename: "DashboardCard",
    children?:  {
      __typename: "ModelDashboardCardItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    date: string,
    updatedAt: string,
  } | null,
};

export type DeleteDashboardCardItemMutationVariables = {
  condition?: ModelDashboardCardItemConditionInput | null,
  input: DeleteDashboardCardItemInput,
};

export type DeleteDashboardCardItemMutation = {
  deleteDashboardCardItem?:  {
    __typename: "DashboardCardItem",
    assessmentType?: DashboardCardItemAssessmentType | null,
    createdAt: string,
    customPrompt?: string | null,
    date: string,
    entityHasEntitlements?: boolean | null,
    entityId?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    nonEntitledEntityId?: string | null,
    order: number,
    parent?:  {
      __typename: "DashboardCard",
      createdAt: string,
      date: string,
      updatedAt: string,
    } | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    type?: DashboardCardItemType | null,
    updatedAt: string,
  } | null,
};

export type DeleteDashboardStreakMutationVariables = {
  condition?: ModelDashboardStreakConditionInput | null,
  input: DeleteDashboardStreakInput,
};

export type DeleteDashboardStreakMutation = {
  deleteDashboardStreak?:  {
    __typename: "DashboardStreak",
    count: number,
    createdAt: string,
    id: string,
    lastActiveDate: string,
    leaderboards?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    startDate: string,
    updatedAt: string,
  } | null,
};

export type DeleteEntityMutationVariables = {
  condition?: ModelEntityConditionInput | null,
  input: DeleteEntityInput,
};

export type DeleteEntityMutation = {
  deleteEntity?:  {
    __typename: "Entity",
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    description?: string | null,
    duration?: number | null,
    enforceEntitlementsAt?: number | null,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    liveState?: EntityLiveState | null,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    order?: number | null,
    parent?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    parentId?: string | null,
    publishAt?: string | null,
    redirectId?: string | null,
    requiredEntitlements?: Array< string | null > | null,
    rootEntityId?: string | null,
    shareContent?:  {
      __typename: "EntityShareContent",
      description?: string | null,
      title?: string | null,
    } | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    startTime?: string | null,
    tags?: Array< string | null > | null,
    title: string,
    updatedAt: string,
    validUntil?: string | null,
    visibility: EntityVisibility,
  } | null,
};

export type DeleteEntityLikeMutationVariables = {
  condition?: ModelEntityLikeConditionInput | null,
  input: DeleteEntityLikeInput,
};

export type DeleteEntityLikeMutation = {
  deleteEntityLike?:  {
    __typename: "EntityLike",
    createdAt: string,
    entityId: string,
    id: string,
    owner?: string | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type DeleteEntityRelationsMutationVariables = {
  condition?: ModelEntityRelationsConditionInput | null,
  input: DeleteEntityRelationsInput,
};

export type DeleteEntityRelationsMutation = {
  deleteEntityRelations?:  {
    __typename: "EntityRelations",
    childId: string,
    createdAt: string,
    entities?:  {
      __typename: "ModelEntityConnection",
      nextToken?: string | null,
    } | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    id: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventRsvpMutationVariables = {
  condition?: ModelEventRsvpConditionInput | null,
  input: DeleteEventRsvpInput,
};

export type DeleteEventRsvpMutation = {
  deleteEventRsvp?:  {
    __typename: "EventRsvp",
    createdAt?: string | null,
    eventStartTime: string,
    meetup?:  {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null,
    meetupId?: string | null,
    owner: string,
    parentId: string,
    parentType?: EventRsvpParentType | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    socialProofId?: string | null,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type DeleteGiftRecipientMutationVariables = {
  condition?: ModelGiftRecipientConditionInput | null,
  input: DeleteGiftRecipientInput,
};

export type DeleteGiftRecipientMutation = {
  deleteGiftRecipient?:  {
    __typename: "GiftRecipient",
    buyerId: string,
    createdAt?: string | null,
    email?: string | null,
    firstName?: string | null,
    id: string,
    lastName?: string | null,
    owner: string,
    stripePriceId?: string | null,
    subscriptionId?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteGrowthCoinStatsMutationVariables = {
  condition?: ModelGrowthCoinStatsConditionInput | null,
  input: DeleteGrowthCoinStatsInput,
};

export type DeleteGrowthCoinStatsMutation = {
  deleteGrowthCoinStats?:  {
    __typename: "GrowthCoinStats",
    createdAt: string,
    currentMonth: string,
    monthCoins: number,
    owner: string,
    source: string,
    sourceEvent: string,
    totalCoins: number,
    updatedAt: string,
    version?: number | null,
  } | null,
};

export type DeleteGrowthCoinTransactionMutationVariables = {
  condition?: ModelGrowthCoinTransactionConditionInput | null,
  input: DeleteGrowthCoinTransactionInput,
};

export type DeleteGrowthCoinTransactionMutation = {
  deleteGrowthCoinTransaction?:  {
    __typename: "GrowthCoinTransaction",
    coinsAdded: number,
    createdAt?: string | null,
    endBalance: number,
    id: string,
    owner?: string | null,
    source: GrowthCoinTransactionSource,
    sourceEvent: GrowthCoinTransactionSourceEvent,
    startBalance: number,
    updatedAt: string,
  } | null,
};

export type DeleteJournalMutationVariables = {
  condition?: ModelJournalConditionInput | null,
  input: DeleteJournalInput,
};

export type DeleteJournalMutation = {
  deleteJournal?:  {
    __typename: "Journal",
    createdAt: string,
    customPrompts?: Array< string | null > | null,
    datetime: string,
    id: string,
    images?:  Array< {
      __typename: "JournalImage",
      height?: number | null,
      s3Key: string,
      width?: number | null,
    } | null > | null,
    journalType: JournalType,
    owner?: string | null,
    parentId?: string | null,
    responses?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type DeleteLeaderboardMutationVariables = {
  condition?: ModelLeaderboardConditionInput | null,
  input: DeleteLeaderboardInput,
};

export type DeleteLeaderboardMutation = {
  deleteLeaderboard?:  {
    __typename: "Leaderboard",
    createdAt: string,
    dashboardStreaks?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    highestStreakCount: number,
    highestStreakCountAndTotalCoinsCount: string,
    month: string,
    owner: string,
    profile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    ranking?: number | null,
    totalCoinsCount: number,
    totalLeadsCount?: number | null,
    totalReferralsCount: number,
    totalReferralsCountAndTotalLeadsCount?: string | null,
    totalStreaksCount: number,
    updatedAt: string,
    userProfileId: string,
  } | null,
};

export type DeleteLeaderboardDashboardStreakMutationVariables = {
  condition?: ModelLeaderboardDashboardStreakConditionInput | null,
  input: DeleteLeaderboardDashboardStreakInput,
};

export type DeleteLeaderboardDashboardStreakMutation = {
  deleteLeaderboardDashboardStreak?:  {
    __typename: "LeaderboardDashboardStreak",
    createdAt: string,
    dashboardStreak?:  {
      __typename: "DashboardStreak",
      count: number,
      createdAt: string,
      id: string,
      lastActiveDate: string,
      owner: string,
      startDate: string,
      updatedAt: string,
    } | null,
    dashboardStreakId: string,
    id: string,
    leaderboard?:  {
      __typename: "Leaderboard",
      createdAt: string,
      highestStreakCount: number,
      highestStreakCountAndTotalCoinsCount: string,
      month: string,
      owner: string,
      ranking?: number | null,
      totalCoinsCount: number,
      totalLeadsCount?: number | null,
      totalReferralsCount: number,
      totalReferralsCountAndTotalLeadsCount?: string | null,
      totalStreaksCount: number,
      updatedAt: string,
      userProfileId: string,
    } | null,
    month: string,
    owner: string,
    updatedAt: string,
  } | null,
};

export type DeleteMeetupMutationVariables = {
  condition?: ModelMeetupConditionInput | null,
  input: DeleteMeetupInput,
};

export type DeleteMeetupMutation = {
  deleteMeetup?:  {
    __typename: "Meetup",
    agenda: string,
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    chatRoomId?: string | null,
    createdAt: string,
    duration: number,
    endTime: string,
    hostReferralId?: string | null,
    liveState: MeetupLiveState,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    recurrenceId?: string | null,
    recurrenceRule?: string | null,
    roomUrl?: string | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    slugId: string,
    startTime: string,
    thumbnail?:  {
      __typename: "MeetupThumbnail",
      height?: number | null,
      url: string,
      width?: number | null,
    } | null,
    title: string,
    updatedAt: string,
    version?: number | null,
    visibility: EntityVisibility,
  } | null,
};

export type DeleteMessageMutationVariables = {
  condition?: ModelMessageConditionInput | null,
  input: DeleteMessageInput,
};

export type DeleteMessageMutation = {
  deleteMessage?:  {
    __typename: "Message",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    content: string,
    createdAt?: string | null,
    id: string,
    isEdited?: boolean | null,
    mediaPosition: number,
    metadata?: string | null,
    owner?: string | null,
    pinnedState?: MessagePinnedState | null,
    room?:  {
      __typename: "ChatRoom",
      bannedUsers?: Array< string | null > | null,
      createdAt?: string | null,
      entityId: string,
      id: string,
      moderators?: Array< string | null > | null,
      updatedAt: string,
    } | null,
    roomId: string,
    type: MessageType,
    updatedAt: string,
  } | null,
};

export type DeleteMonthlyLifescoreMutationVariables = {
  condition?: ModelMonthlyLifescoreConditionInput | null,
  input: DeleteMonthlyLifescoreInput,
};

export type DeleteMonthlyLifescoreMutation = {
  deleteMonthlyLifescore?:  {
    __typename: "MonthlyLifescore",
    averageScorePercentage: number,
    createdAt?: string | null,
    experienceScore: number,
    familyScore: number,
    financeScore: number,
    friendScore: number,
    healthScore: number,
    id: string,
    learningScore: number,
    mentalAndEmotionalScore: number,
    missionScore: number,
    owner?: string | null,
    parentId?: string | null,
    partnerAndLoveScore: number,
    spiritScore: number,
    updatedAt: string,
  } | null,
};

export type DeleteNoteMutationVariables = {
  condition?: ModelNoteConditionInput | null,
  input: DeleteNoteInput,
};

export type DeleteNoteMutation = {
  deleteNote?:  {
    __typename: "Note",
    content: string,
    createdAt?: string | null,
    entityId: string,
    entityType?: EntityType | null,
    noteItems?:  {
      __typename: "ModelNoteItemConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    parentId: string,
    parentType?: NoteParentType | null,
    pinnedState?: NotePinnedState | null,
    updatedAt: string,
  } | null,
};

export type DeleteNoteItemMutationVariables = {
  condition?: ModelNoteItemConditionInput | null,
  input: DeleteNoteItemInput,
};

export type DeleteNoteItemMutation = {
  deleteNoteItem?:  {
    __typename: "NoteItem",
    content: string,
    createdAt: string,
    entityId: string,
    entityType?: EntityType | null,
    id: string,
    note?:  {
      __typename: "Note",
      content: string,
      createdAt?: string | null,
      entityId: string,
      entityType?: EntityType | null,
      owner: string,
      parentId: string,
      parentType?: NoteParentType | null,
      pinnedState?: NotePinnedState | null,
      updatedAt: string,
    } | null,
    noteOwner: string,
    owner?: string | null,
    parentId: string,
    parentType?: NoteItemParentType | null,
    timestamp: number,
    updatedAt: string,
  } | null,
};

export type DeleteNotificationLogMutationVariables = {
  condition?: ModelNotificationLogConditionInput | null,
  input: DeleteNotificationLogInput,
};

export type DeleteNotificationLogMutation = {
  deleteNotificationLog?:  {
    __typename: "NotificationLog",
    challengeDayProgressId?: string | null,
    createdAt: string,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    id: string,
    meetup?:  {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null,
    meetupSlugId?: string | null,
    name?: NotificationLogName | null,
    updatedAt: string,
  } | null,
};

export type DeleteOfferingMutationVariables = {
  condition?: ModelOfferingConditionInput | null,
  input: DeleteOfferingInput,
};

export type DeleteOfferingMutation = {
  deleteOffering?:  {
    __typename: "Offering",
    createdAt: string,
    cta?: string | null,
    description?: string | null,
    heading?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    media?:  {
      __typename: "Asset",
      assetType: AssetType,
      createdAt: string,
      description?: string | null,
      entityId?: string | null,
      id: string,
      locator: string,
      offeringId?: string | null,
      title?: string | null,
      updatedAt: string,
    } | null,
    offeringStackOfferings?:  {
      __typename: "ModelOfferingStackConnection",
      nextToken?: string | null,
    } | null,
    offeringStackOrderBumps?:  {
      __typename: "ModelOfferingStackConnection",
      nextToken?: string | null,
    } | null,
    offeringStackUpsellOfferings?:  {
      __typename: "ModelOfferingStackUpsellConnection",
      nextToken?: string | null,
    } | null,
    overrides?:  {
      __typename: "OfferingOverrides",
      skipCreditCard?: boolean | null,
      trialDuration?: number | null,
      trialFrequency?: OfferingOverridesTrialFrequency | null,
    } | null,
    productBundle?:  {
      __typename: "ModelOfferingProductBundleConnection",
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOfferingProductConnection",
      nextToken?: string | null,
    } | null,
    readableTitle: string,
    redirectUrl?: string | null,
    shortDescription?: string | null,
    showGuarantee?: boolean | null,
    skipEmailCollectionStep?: boolean | null,
    step1Title?: string | null,
    step2Title?: string | null,
    type?: OfferingType | null,
    updatedAt: string,
  } | null,
};

export type DeleteOfferingProductMutationVariables = {
  condition?: ModelOfferingProductConditionInput | null,
  input: DeleteOfferingProductInput,
};

export type DeleteOfferingProductMutation = {
  deleteOfferingProduct?:  {
    __typename: "OfferingProduct",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    updatedAt: string,
  } | null,
};

export type DeleteOfferingProductBundleMutationVariables = {
  condition?: ModelOfferingProductBundleConditionInput | null,
  input: DeleteOfferingProductBundleInput,
};

export type DeleteOfferingProductBundleMutation = {
  deleteOfferingProductBundle?:  {
    __typename: "OfferingProductBundle",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    overrides?:  {
      __typename: "OfferingOverrides",
      skipCreditCard?: boolean | null,
      trialDuration?: number | null,
      trialFrequency?: OfferingOverridesTrialFrequency | null,
    } | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    readableTitle: string,
    updatedAt: string,
  } | null,
};

export type DeleteOfferingStackMutationVariables = {
  condition?: ModelOfferingStackConditionInput | null,
  input: DeleteOfferingStackInput,
};

export type DeleteOfferingStackMutation = {
  deleteOfferingStack?:  {
    __typename: "OfferingStack",
    campaign?:  {
      __typename: "ModelCampaignConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    orderBump?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    orderBumpId?: string | null,
    readableTitle: string,
    updatedAt: string,
    upsell?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
  } | null,
};

export type DeleteOfferingStackUpsellMutationVariables = {
  condition?: ModelOfferingStackUpsellConditionInput | null,
  input: DeleteOfferingStackUpsellInput,
};

export type DeleteOfferingStackUpsellMutation = {
  deleteOfferingStackUpsell?:  {
    __typename: "OfferingStackUpsell",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    offeringStack?:  {
      __typename: "OfferingStack",
      createdAt: string,
      id: string,
      offeringId: string,
      orderBumpId?: string | null,
      readableTitle: string,
      updatedAt: string,
    } | null,
    offeringStackId?: string | null,
    updatedAt: string,
    upsellNo?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellNoId?: string | null,
    upsellNoParent?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellYes?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellYesId?: string | null,
    upsellYesParent?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
  } | null,
};

export type DeleteProductMutationVariables = {
  condition?: ModelProductConditionInput | null,
  input: DeleteProductInput,
};

export type DeleteProductMutation = {
  deleteProduct?:  {
    __typename: "Product",
    billingInterval?: ProductBillingInterval | null,
    businessUnit?: ProductBusinessUnit | null,
    createdAt: string,
    description?: string | null,
    entitlements?:  Array< {
      __typename: "EntitlementCustomType",
      identifier: string,
      revenueCatEntitlementId?: string | null,
    } | null > | null,
    id: string,
    name: string,
    offerings?:  {
      __typename: "ModelOfferingProductConnection",
      nextToken?: string | null,
    } | null,
    priceId?: string | null,
    productBundle?:  {
      __typename: "ModelOfferingProductBundleConnection",
      nextToken?: string | null,
    } | null,
    productCategory?: string | null,
    productId: string,
    productNamespace: string,
    store?: ProductStore | null,
    subscriptionGroup?: ProductSubscriptionGroup | null,
    updatedAt: string,
    userSubscriptions?:  {
      __typename: "ModelUserSubscriptionConnection",
      nextToken?: string | null,
    } | null,
    userTransactions?:  {
      __typename: "ModelUserTransactionConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteRecentlyPlayedMutationVariables = {
  condition?: ModelRecentlyPlayedConditionInput | null,
  input: DeleteRecentlyPlayedInput,
};

export type DeleteRecentlyPlayedMutation = {
  deleteRecentlyPlayed?:  {
    __typename: "RecentlyPlayed",
    children?:  Array< {
      __typename: "RecentlyPlayedChild",
      completeTime?: string | null,
      entityId?: string | null,
      lastPlayedAt: string,
      playbackPercentage: number,
    } | null > | null,
    completeTime?: string | null,
    createdAt: string,
    entityId: string,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    lastPlayedAt: string,
    owner?: string | null,
    playbackPercentage: number,
    updatedAt: string,
  } | null,
};

export type DeleteTeamMutationVariables = {
  condition?: ModelTeamConditionInput | null,
  input: DeleteTeamInput,
};

export type DeleteTeamMutation = {
  deleteTeam?:  {
    __typename: "Team",
    createdAt: string,
    id: string,
    invitationState?: TeamInvitationState | null,
    members?:  {
      __typename: "ModelTeamMemberConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    subscriptionId?: string | null,
    subscriptionItemId?: string | null,
    subscriptionState?: TeamSubscriptionState | null,
    totalSeats?: number | null,
    updatedAt: string,
    usedSeats?: number | null,
    version?: number | null,
  } | null,
};

export type DeleteTeamMemberMutationVariables = {
  condition?: ModelTeamMemberConditionInput | null,
  input: DeleteTeamMemberInput,
};

export type DeleteTeamMemberMutation = {
  deleteTeamMember?:  {
    __typename: "TeamMember",
    createdAt: string,
    email?: string | null,
    firstName?: string | null,
    id: string,
    lastName?: string | null,
    owner: string,
    subscriptionState?: TeamSubscriptionState | null,
    team?:  {
      __typename: "Team",
      createdAt: string,
      id: string,
      invitationState?: TeamInvitationState | null,
      owner: string,
      stripePriceId?: string | null,
      stripeProductId?: string | null,
      subscriptionId?: string | null,
      subscriptionItemId?: string | null,
      subscriptionState?: TeamSubscriptionState | null,
      totalSeats?: number | null,
      updatedAt: string,
      usedSeats?: number | null,
      version?: number | null,
    } | null,
    teamId: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "DeleteUserReturnType",
    status?: string | null,
  } | null,
};

export type DeleteUserExternalIdentifierMutationVariables = {
  condition?: ModelUserExternalIdentifierConditionInput | null,
  input: DeleteUserExternalIdentifierInput,
};

export type DeleteUserExternalIdentifierMutation = {
  deleteUserExternalIdentifier?:  {
    __typename: "UserExternalIdentifier",
    createdAt: string,
    externalIdentifier: string,
    owner: string,
    type?: UserExternalIdentifierType | null,
    updatedAt: string,
  } | null,
};

export type DeleteUserProfileMutationVariables = {
  condition?: ModelUserProfileConditionInput | null,
  input: DeleteUserProfileInput,
};

export type DeleteUserProfileMutation = {
  deleteUserProfile?:  {
    __typename: "UserProfile",
    activeViewSessions?:  {
      __typename: "ModelActiveViewSessionConnection",
      nextToken?: string | null,
    } | null,
    attributes?:  {
      __typename: "UserAttributes",
      intents?: Array< string | null > | null,
      surveyCustCategory?: UserAttributesSurveyCustCategory | null,
      surveyInterests?: Array< string | null > | null,
    } | null,
    badges?:  {
      __typename: "UserProfileBadges",
      chpc?: boolean | null,
      growthday?: boolean | null,
      ultra?: boolean | null,
    } | null,
    bio?: string | null,
    certificates?:  {
      __typename: "ModelCourseCertificateConnection",
      nextToken?: string | null,
    } | null,
    commentLikes?:  {
      __typename: "ModelCommentLikeConnection",
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    cover?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    createdAt?: string | null,
    displayName?: string | null,
    entityLikes?:  {
      __typename: "ModelEntityLikeConnection",
      nextToken?: string | null,
    } | null,
    experimentMetadata?:  {
      __typename: "UserProfileExperimentMetadata",
      mozartUser?: boolean | null,
    } | null,
    leaderboards?:  {
      __typename: "ModelLeaderboardConnection",
      nextToken?: string | null,
    } | null,
    meetups?:  {
      __typename: "ModelMeetupConnection",
      nextToken?: string | null,
    } | null,
    messages?:  {
      __typename: "ModelMessageConnection",
      nextToken?: string | null,
    } | null,
    notifications?:  {
      __typename: "ModelAppNotificationConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    profileImage?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    publicProfileId: string,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    socialMediaLinks?:  {
      __typename: "SocialMediaLinks",
      facebook?: string | null,
      instagram?: string | null,
      linkedin?: string | null,
      website?: string | null,
      x?: string | null,
    } | null,
    totalCoinsCount?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteUserSubscriptionMutationVariables = {
  condition?: ModelUserSubscriptionConditionInput | null,
  input: DeleteUserSubscriptionInput,
};

export type DeleteUserSubscriptionMutation = {
  deleteUserSubscription?:  {
    __typename: "UserSubscription",
    createdAt: string,
    expirationDate?: string | null,
    id: string,
    owner?: string | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    purchaseDate?: string | null,
    renewalDate?: string | null,
    status?: UserSubscriptionStatus | null,
    subscriptionId: string,
    updatedAt: string,
    userTransactions?:  {
      __typename: "ModelUserTransactionConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteUserTransactionMutationVariables = {
  condition?: ModelUserTransactionConditionInput | null,
  input: DeleteUserTransactionInput,
};

export type DeleteUserTransactionMutation = {
  deleteUserTransaction?:  {
    __typename: "UserTransaction",
    createdAt: string,
    currency?: string | null,
    id: string,
    owner?: string | null,
    price?: number | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    store: string,
    transactionDate: string,
    type?: UserTransactionType | null,
    updatedAt: string,
    userSubscription?:  {
      __typename: "UserSubscription",
      createdAt: string,
      expirationDate?: string | null,
      id: string,
      owner?: string | null,
      productId: string,
      purchaseDate?: string | null,
      renewalDate?: string | null,
      status?: UserSubscriptionStatus | null,
      subscriptionId: string,
      updatedAt: string,
    } | null,
    userSubscriptionId?: string | null,
  } | null,
};

export type EditMeetupsMutationVariables = {
  newAgenda?: string | null,
  newDuration?: number | null,
  newTitle?: string | null,
  recurrenceId?: string | null,
  selectSeries?: boolean | null,
  slugId: string,
};

export type EditMeetupsMutation = {
  editMeetups?:  {
    __typename: "UpdateMeetupBatchResponse",
    errors:  Array< {
      __typename: "UpdateMeetupBatchErrorResponse",
      reason?: string | null,
      slugId: string,
    } >,
    instances:  Array< {
      __typename: "UpdateMeetupBatchSuccessResponse",
      slugId: string,
    } >,
  } | null,
};

export type FreeOfferingSignupMutationVariables = {
  authenticate?: boolean | null,
  email: string,
  family_name?: string | null,
  given_name?: string | null,
  name?: string | null,
  offeringId?: string | null,
  password?: string | null,
  phone_number?: string | null,
  subscribeToSms?: boolean | null,
  userAttributes?: string | null,
};

export type FreeOfferingSignupMutation = {
  freeOfferingSignup?:  {
    __typename: "FreeOfferingSignupResult",
    accessToken?: string | null,
    entitlements?: Array< string | null > | null,
    idToken?: string | null,
    message?: string | null,
    refreshToken?: string | null,
    success: boolean,
    username?: string | null,
  } | null,
};

export type GenerateCourseCertificateMutationVariables = {
  entityId: string,
  fullName: string,
};

export type GenerateCourseCertificateMutation = {
  generateCourseCertificate?:  {
    __typename: "CourseCertificate",
    createdAt?: string | null,
    entityId: string,
    image:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    },
    owner: string,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type GrantGrowthCoinsMutationVariables = {
  coinsToAdd?: number | null,
  parentId?: string | null,
  source: string,
  sourceEvent: string,
};

export type GrantGrowthCoinsMutation = {
  grantGrowthCoins?:  {
    __typename: "GrowthCoinTransaction",
    coinsAdded: number,
    createdAt?: string | null,
    endBalance: number,
    id: string,
    owner?: string | null,
    source: GrowthCoinTransactionSource,
    sourceEvent: GrowthCoinTransactionSourceEvent,
    startBalance: number,
    updatedAt: string,
  } | null,
};

export type InviteTeamMembersMutationVariables = {
  emails?: Array< string | null > | null,
  firstNames?: Array< string | null > | null,
  lastNames?: Array< string | null > | null,
  teamId: string,
};

export type InviteTeamMembersMutation = {
  inviteTeamMembers?:  {
    __typename: "InviteTeamMembersReturnType",
    executionArn?: string | null,
  } | null,
};

export type JoinMeetupMutationVariables = {
  slugId: string,
};

export type JoinMeetupMutation = {
  joinMeetup?:  {
    __typename: "JoinMeetupResponse",
    token?: string | null,
  } | null,
};

export type JoinReferralProgramMutationVariables = {
  paypalEmail: string,
};

export type JoinReferralProgramMutation = {
  joinReferralProgram?:  {
    __typename: "ReferralProfile",
    activeCustomersCount: number,
    cancellationsCount: number,
    clicksCount: number,
    customersCount: number,
    earnings: number,
    leadsCount: number,
    nextPayDay: string,
    paidEarnings: number,
    paypalEmail?: string | null,
    referralCode: string,
    refundsCount: number,
    remainingBalance: number,
  } | null,
};

export type ProcessPurchaseV2MutationVariables = {
  campaignId?: string | null,
  captcha: string,
  country?: string | null,
  email: string,
  fullName?: string | null,
  marketingData?: string | null,
  offeringIds: Array< string | null >,
  offeringStackId?: string | null,
  password?: string | null,
  paymentMethodId: string,
  paymentMethodType?: ProcessPurchaseV2PaymentMethodType | null,
  postalCode?: string | null,
  priceIds: Array< string | null >,
  quantities: Array< number | null >,
  statsigStableId?: string | null,
  userAttributes?: string | null,
};

export type ProcessPurchaseV2Mutation = {
  processPurchaseV2?:  {
    __typename: "PurchaseV2Result",
    entitlements?: Array< string | null > | null,
    isAuthenticated?: boolean | null,
    isFirstTimeTrialOnlyUser?: boolean | null,
    message?: string | null,
    paymentIntents?:  Array< {
      __typename: "StripeIntentResponse",
      clientSecret?: string | null,
      id?: string | null,
      type?: string | null,
    } | null > | null,
    requiresAction?: boolean | null,
    success: boolean,
    username?: string | null,
    uuid?: string | null,
  } | null,
};

export type PurchaseTeamMutationVariables = {
  country?: string | null,
  paymentMethodId?: string | null,
  postalCode?: string | null,
  priceId: string,
  productId: string,
  stripeIntentId?: string | null,
  stripeIntentType?: string | null,
  subscriptionId?: string | null,
  subscriptionItemId?: string | null,
  teamId?: string | null,
  totalSeats: number,
};

export type PurchaseTeamMutation = {
  purchaseTeam?:  {
    __typename: "PurchaseTeamResponse",
    message: string,
    requiresAction: boolean,
    stripeIntentClientSecret?: string | null,
    stripeIntentId?: string | null,
    stripeIntentType?: string | null,
    subscriptionId?: string | null,
    subscriptionItemId?: string | null,
    success: boolean,
    teamId?: string | null,
  } | null,
};

export type PurchaseTeamSeatsMutationVariables = {
  teamId: string,
  totalSeats: number,
};

export type PurchaseTeamSeatsMutation = {
  purchaseTeamSeats?:  {
    __typename: "Team",
    createdAt: string,
    id: string,
    invitationState?: TeamInvitationState | null,
    members?:  {
      __typename: "ModelTeamMemberConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    subscriptionId?: string | null,
    subscriptionItemId?: string | null,
    subscriptionState?: TeamSubscriptionState | null,
    totalSeats?: number | null,
    updatedAt: string,
    usedSeats?: number | null,
    version?: number | null,
  } | null,
};

export type RsvpToMeetupsMutationVariables = {
  recurrenceId?: string | null,
  selectSeries?: boolean | null,
  slugId: string,
};

export type RsvpToMeetupsMutation = {
  rsvpToMeetups?:  {
    __typename: "UpdateMeetupBatchResponse",
    errors:  Array< {
      __typename: "UpdateMeetupBatchErrorResponse",
      reason?: string | null,
      slugId: string,
    } >,
    instances:  Array< {
      __typename: "UpdateMeetupBatchSuccessResponse",
      slugId: string,
    } >,
  } | null,
};

export type SendViewHeartbeatMutationVariables = {
  entityId: string,
  sessionId?: string | null,
};

export type SendViewHeartbeatMutation = {
  sendViewHeartbeat?:  {
    __typename: "SendViewHeartbeatReturnType",
    heartbeatCount?: number | null,
    sessionId?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type StartMeetupMutationVariables = {
  slugId: string,
};

export type StartMeetupMutation = {
  startMeetup?:  {
    __typename: "StartMeetupResponse",
    chatRoomId?: string | null,
    token?: string | null,
    url?: string | null,
  } | null,
};

export type TrackReferralSignupMutationVariables = {
  email: string,
  refId: string,
};

export type TrackReferralSignupMutation = {
  trackReferralSignup?: string | null,
};

export type UpdateActiveViewSessionMutationVariables = {
  condition?: ModelActiveViewSessionConditionInput | null,
  input: UpdateActiveViewSessionInput,
};

export type UpdateActiveViewSessionMutation = {
  updateActiveViewSession?:  {
    __typename: "ActiveViewSession",
    createdAt?: string | null,
    entityId: string,
    heartbeatCount: number,
    id: string,
    owner?: string | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    updatedAt?: string | null,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type UpdateAllAppNotificationsToReadMutationVariables = {
};

export type UpdateAllAppNotificationsToReadMutation = {
  updateAllAppNotificationsToRead?:  {
    __typename: "UpdateAppNotificationsBatchResponse",
    errors:  Array< {
      __typename: "AppNotificationsErrorResponse",
      id: string,
      reason?: string | null,
    } >,
    instances:  Array< {
      __typename: "AppNotificationsResponse",
      id: string,
      status?: AppNotificationStatus | null,
      updatedAt?: string | null,
    } >,
  } | null,
};

export type UpdateAppNotificationMutationVariables = {
  condition?: ModelAppNotificationConditionInput | null,
  input: UpdateAppNotificationInput,
};

export type UpdateAppNotificationMutation = {
  updateAppNotification?:  {
    __typename: "AppNotification",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    content?: string | null,
    createdAt?: string | null,
    deeplink?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    notificationType: AppNotificationType,
    owner: string,
    sourceId: string,
    sourceType?: AppNotificationSourceType | null,
    status: AppNotificationStatus,
    title: string,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAssetMutationVariables = {
  condition?: ModelAssetConditionInput | null,
  input: UpdateAssetInput,
};

export type UpdateAssetMutation = {
  updateAsset?:  {
    __typename: "Asset",
    assetType: AssetType,
    createdAt: string,
    description?: string | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    id: string,
    locator: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId?: string | null,
    title?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateBookmarkMutationVariables = {
  condition?: ModelBookmarkConditionInput | null,
  input: UpdateBookmarkInput,
};

export type UpdateBookmarkMutation = {
  updateBookmark?:  {
    __typename: "Bookmark",
    createdAt?: string | null,
    entityType?: string | null,
    owner: string,
    parentId: string,
    parentType: string,
    updatedAt: string,
  } | null,
};

export type UpdateCampaignMutationVariables = {
  condition?: ModelCampaignConditionInput | null,
  input: UpdateCampaignInput,
};

export type UpdateCampaignMutation = {
  updateCampaign?:  {
    __typename: "Campaign",
    createdAt: string,
    id: string,
    isDefault?: boolean | null,
    offeringStack?:  {
      __typename: "OfferingStack",
      createdAt: string,
      id: string,
      offeringId: string,
      orderBumpId?: string | null,
      readableTitle: string,
      updatedAt: string,
    } | null,
    offeringStackId?: string | null,
    readableTitle: string,
    updatedAt: string,
  } | null,
};

export type UpdateCdnImageMutationVariables = {
  checksum: string,
  filename: string,
  id: string,
  partitionId: string,
};

export type UpdateCdnImageMutation = {
  updateCdnImage?:  {
    __typename: "CdnAssetUploadResponse",
    cdnUrl: string,
    checksum?: string | null,
    id: string,
    uploadUrl?: string | null,
    uploadUrlExpiration?: number | null,
    uploadUrlRequestMethod?: CdnAssetUploadResponseUploadUrlRequestMethod | null,
  } | null,
};

export type UpdateChallengeProgressMutationVariables = {
  condition?: ModelChallengeProgressConditionInput | null,
  input: UpdateChallengeProgressInput,
};

export type UpdateChallengeProgressMutation = {
  updateChallengeProgress?:  {
    __typename: "ChallengeProgress",
    children?:  Array< {
      __typename: "ChallengeDayProgress",
      coinsEarned?: number | null,
      completeTime?: string | null,
      entityId: string,
      id: string,
      startTime: string,
    } | null > | null,
    coinsEarned?: number | null,
    completeTime?: string | null,
    createdAt: string,
    endTime: string,
    entityId: string,
    id: string,
    owner?: string | null,
    startTime: string,
    type?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateChatRoomMutationVariables = {
  condition?: ModelChatRoomConditionInput | null,
  input: UpdateChatRoomInput,
};

export type UpdateChatRoomMutation = {
  updateChatRoom?:  {
    __typename: "ChatRoom",
    bannedUsers?: Array< string | null > | null,
    createdAt?: string | null,
    entityId: string,
    id: string,
    messages?:  {
      __typename: "ModelMessageConnection",
      nextToken?: string | null,
    } | null,
    moderators?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type UpdateChecklistMutationVariables = {
  condition?: ModelChecklistConditionInput | null,
  input: UpdateChecklistInput,
};

export type UpdateChecklistMutation = {
  updateChecklist?:  {
    __typename: "Checklist",
    completed?: boolean | null,
    createdAt: string,
    date: string,
    items?:  Array< {
      __typename: "ItemCompletion",
      completed?: boolean | null,
      deleted?: boolean | null,
      itemId?: string | null,
      order?: number | null,
    } | null > | null,
    owner: string,
    started?: boolean | null,
    updatedAt: string,
  } | null,
};

export type UpdateChecklistItemMutationVariables = {
  condition?: ModelChecklistItemConditionInput | null,
  input: UpdateChecklistItemInput,
};

export type UpdateChecklistItemMutation = {
  updateChecklistItem?:  {
    __typename: "ChecklistItem",
    createdAt: string,
    date: string,
    endDate?: string | null,
    frequency: ItemFrequency,
    id: string,
    order?: number | null,
    owner: string,
    title: string,
    updatedAt: string,
    weekday: DayOfWeek,
  } | null,
};

export type UpdateCommentMutationVariables = {
  condition?: ModelCommentConditionInput | null,
  input: UpdateCommentInput,
};

export type UpdateCommentMutation = {
  updateComment?:  {
    __typename: "Comment",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    commentsCount?: number | null,
    content: string,
    createdAt?: string | null,
    id: string,
    images?:  Array< {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null > | null,
    isEdited?: boolean | null,
    likes?:  {
      __typename: "ModelCommentLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount?: number | null,
    owner?: string | null,
    parent?:  {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null,
    parentId: string,
    parentType?: CommentParentType | null,
    pinnedState?: CommentPinnedState | null,
    replies?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    threadId: string,
    type?: CommentType | null,
    updatedAt: string,
    version?: number | null,
    visibility: CommentVisibility,
  } | null,
};

export type UpdateCommentLikeMutationVariables = {
  condition?: ModelCommentLikeConditionInput | null,
  input: UpdateCommentLikeInput,
};

export type UpdateCommentLikeMutation = {
  updateCommentLike?:  {
    __typename: "CommentLike",
    comment?:  {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null,
    commentId: string,
    createdAt: string,
    id: string,
    owner?: string | null,
    threadId: string,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type UpdateCommentWithSpamFilterMutationVariables = {
  content: string,
  id: string,
  images?: string | null,
  pinnedState?: UpdateCommentWithSpamFilterPinnedState | null,
};

export type UpdateCommentWithSpamFilterMutation = {
  updateCommentWithSpamFilter?:  {
    __typename: "CommentMutationOutput",
    author?:  {
      __typename: "CommentMutationOutputAuthor",
      displayName?: string | null,
      publicProfileId?: string | null,
    } | null,
    content: string,
    createdAt?: string | null,
    id: string,
    images?:  Array< {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null > | null,
    owner: string,
    parentId?: string | null,
    parentType?: CommentParentType | null,
    pinnedState?: CommentPinnedState | null,
    threadId?: string | null,
    type?: CommentType | null,
    updatedAt?: string | null,
    version?: number | null,
    visibility?: CommentVisibility | null,
  } | null,
};

export type UpdateCourseCertificateMutationVariables = {
  condition?: ModelCourseCertificateConditionInput | null,
  input: UpdateCourseCertificateInput,
};

export type UpdateCourseCertificateMutation = {
  updateCourseCertificate?:  {
    __typename: "CourseCertificate",
    createdAt?: string | null,
    entityId: string,
    image:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    },
    owner: string,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type UpdateDashboardCardMutationVariables = {
  condition?: ModelDashboardCardConditionInput | null,
  input: UpdateDashboardCardInput,
};

export type UpdateDashboardCardMutation = {
  updateDashboardCard?:  {
    __typename: "DashboardCard",
    children?:  {
      __typename: "ModelDashboardCardItemConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    date: string,
    updatedAt: string,
  } | null,
};

export type UpdateDashboardCardItemMutationVariables = {
  condition?: ModelDashboardCardItemConditionInput | null,
  input: UpdateDashboardCardItemInput,
};

export type UpdateDashboardCardItemMutation = {
  updateDashboardCardItem?:  {
    __typename: "DashboardCardItem",
    assessmentType?: DashboardCardItemAssessmentType | null,
    createdAt: string,
    customPrompt?: string | null,
    date: string,
    entityHasEntitlements?: boolean | null,
    entityId?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    nonEntitledEntityId?: string | null,
    order: number,
    parent?:  {
      __typename: "DashboardCard",
      createdAt: string,
      date: string,
      updatedAt: string,
    } | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    type?: DashboardCardItemType | null,
    updatedAt: string,
  } | null,
};

export type UpdateDashboardProgressMutationVariables = {
  condition?: ModelDashboardProgressConditionInput | null,
  input: UpdateDashboardProgressInput,
};

export type UpdateDashboardProgressMutation = {
  updateDashboardProgress?:  {
    __typename: "DashboardProgress",
    children?:  Array< {
      __typename: "DashboardProgressItem",
      completeTime?: string | null,
      parentId: string,
      upsellRejected?: boolean | null,
    } > | null,
    completeTime?: string | null,
    createdAt: string,
    date: string,
    owner: string,
    updatedAt: string,
  } | null,
};

export type UpdateDashboardStreakMutationVariables = {
  condition?: ModelDashboardStreakConditionInput | null,
  input: UpdateDashboardStreakInput,
};

export type UpdateDashboardStreakMutation = {
  updateDashboardStreak?:  {
    __typename: "DashboardStreak",
    count: number,
    createdAt: string,
    id: string,
    lastActiveDate: string,
    leaderboards?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    startDate: string,
    updatedAt: string,
  } | null,
};

export type UpdateEntityMutationVariables = {
  condition?: ModelEntityConditionInput | null,
  input: UpdateEntityInput,
};

export type UpdateEntityMutation = {
  updateEntity?:  {
    __typename: "Entity",
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    description?: string | null,
    duration?: number | null,
    enforceEntitlementsAt?: number | null,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    liveState?: EntityLiveState | null,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    order?: number | null,
    parent?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    parentId?: string | null,
    publishAt?: string | null,
    redirectId?: string | null,
    requiredEntitlements?: Array< string | null > | null,
    rootEntityId?: string | null,
    shareContent?:  {
      __typename: "EntityShareContent",
      description?: string | null,
      title?: string | null,
    } | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    startTime?: string | null,
    tags?: Array< string | null > | null,
    title: string,
    updatedAt: string,
    validUntil?: string | null,
    visibility: EntityVisibility,
  } | null,
};

export type UpdateEntityLikeMutationVariables = {
  condition?: ModelEntityLikeConditionInput | null,
  input: UpdateEntityLikeInput,
};

export type UpdateEntityLikeMutation = {
  updateEntityLike?:  {
    __typename: "EntityLike",
    createdAt: string,
    entityId: string,
    id: string,
    owner?: string | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type UpdateEntityRelationsMutationVariables = {
  condition?: ModelEntityRelationsConditionInput | null,
  input: UpdateEntityRelationsInput,
};

export type UpdateEntityRelationsMutation = {
  updateEntityRelations?:  {
    __typename: "EntityRelations",
    childId: string,
    createdAt: string,
    entities?:  {
      __typename: "ModelEntityConnection",
      nextToken?: string | null,
    } | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    id: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventRsvpMutationVariables = {
  condition?: ModelEventRsvpConditionInput | null,
  input: UpdateEventRsvpInput,
};

export type UpdateEventRsvpMutation = {
  updateEventRsvp?:  {
    __typename: "EventRsvp",
    createdAt?: string | null,
    eventStartTime: string,
    meetup?:  {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null,
    meetupId?: string | null,
    owner: string,
    parentId: string,
    parentType?: EventRsvpParentType | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    socialProofId?: string | null,
    updatedAt: string,
    userProfile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    userProfileId: string,
  } | null,
};

export type UpdateGiftRecipientMutationVariables = {
  condition?: ModelGiftRecipientConditionInput | null,
  input: UpdateGiftRecipientInput,
};

export type UpdateGiftRecipientMutation = {
  updateGiftRecipient?:  {
    __typename: "GiftRecipient",
    buyerId: string,
    createdAt?: string | null,
    email?: string | null,
    firstName?: string | null,
    id: string,
    lastName?: string | null,
    owner: string,
    stripePriceId?: string | null,
    subscriptionId?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateGrowthCoinStatsMutationVariables = {
  condition?: ModelGrowthCoinStatsConditionInput | null,
  input: UpdateGrowthCoinStatsInput,
};

export type UpdateGrowthCoinStatsMutation = {
  updateGrowthCoinStats?:  {
    __typename: "GrowthCoinStats",
    createdAt: string,
    currentMonth: string,
    monthCoins: number,
    owner: string,
    source: string,
    sourceEvent: string,
    totalCoins: number,
    updatedAt: string,
    version?: number | null,
  } | null,
};

export type UpdateJournalMutationVariables = {
  condition?: ModelJournalConditionInput | null,
  input: UpdateJournalInput,
};

export type UpdateJournalMutation = {
  updateJournal?:  {
    __typename: "Journal",
    createdAt: string,
    customPrompts?: Array< string | null > | null,
    datetime: string,
    id: string,
    images?:  Array< {
      __typename: "JournalImage",
      height?: number | null,
      s3Key: string,
      width?: number | null,
    } | null > | null,
    journalType: JournalType,
    owner?: string | null,
    parentId?: string | null,
    responses?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type UpdateLeaderboardMutationVariables = {
  condition?: ModelLeaderboardConditionInput | null,
  input: UpdateLeaderboardInput,
};

export type UpdateLeaderboardMutation = {
  updateLeaderboard?:  {
    __typename: "Leaderboard",
    createdAt: string,
    dashboardStreaks?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    highestStreakCount: number,
    highestStreakCountAndTotalCoinsCount: string,
    month: string,
    owner: string,
    profile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    ranking?: number | null,
    totalCoinsCount: number,
    totalLeadsCount?: number | null,
    totalReferralsCount: number,
    totalReferralsCountAndTotalLeadsCount?: string | null,
    totalStreaksCount: number,
    updatedAt: string,
    userProfileId: string,
  } | null,
};

export type UpdateLeaderboardDashboardStreakMutationVariables = {
  condition?: ModelLeaderboardDashboardStreakConditionInput | null,
  input: UpdateLeaderboardDashboardStreakInput,
};

export type UpdateLeaderboardDashboardStreakMutation = {
  updateLeaderboardDashboardStreak?:  {
    __typename: "LeaderboardDashboardStreak",
    createdAt: string,
    dashboardStreak?:  {
      __typename: "DashboardStreak",
      count: number,
      createdAt: string,
      id: string,
      lastActiveDate: string,
      owner: string,
      startDate: string,
      updatedAt: string,
    } | null,
    dashboardStreakId: string,
    id: string,
    leaderboard?:  {
      __typename: "Leaderboard",
      createdAt: string,
      highestStreakCount: number,
      highestStreakCountAndTotalCoinsCount: string,
      month: string,
      owner: string,
      ranking?: number | null,
      totalCoinsCount: number,
      totalLeadsCount?: number | null,
      totalReferralsCount: number,
      totalReferralsCountAndTotalLeadsCount?: string | null,
      totalStreaksCount: number,
      updatedAt: string,
      userProfileId: string,
    } | null,
    month: string,
    owner: string,
    updatedAt: string,
  } | null,
};

export type UpdateMeetupMutationVariables = {
  condition?: ModelMeetupConditionInput | null,
  input: UpdateMeetupInput,
};

export type UpdateMeetupMutation = {
  updateMeetup?:  {
    __typename: "Meetup",
    agenda: string,
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    chatRoomId?: string | null,
    createdAt: string,
    duration: number,
    endTime: string,
    hostReferralId?: string | null,
    liveState: MeetupLiveState,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    recurrenceId?: string | null,
    recurrenceRule?: string | null,
    roomUrl?: string | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    slugId: string,
    startTime: string,
    thumbnail?:  {
      __typename: "MeetupThumbnail",
      height?: number | null,
      url: string,
      width?: number | null,
    } | null,
    title: string,
    updatedAt: string,
    version?: number | null,
    visibility: EntityVisibility,
  } | null,
};

export type UpdateMessageMutationVariables = {
  condition?: ModelMessageConditionInput | null,
  input: UpdateMessageInput,
};

export type UpdateMessageMutation = {
  updateMessage?:  {
    __typename: "Message",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    content: string,
    createdAt?: string | null,
    id: string,
    isEdited?: boolean | null,
    mediaPosition: number,
    metadata?: string | null,
    owner?: string | null,
    pinnedState?: MessagePinnedState | null,
    room?:  {
      __typename: "ChatRoom",
      bannedUsers?: Array< string | null > | null,
      createdAt?: string | null,
      entityId: string,
      id: string,
      moderators?: Array< string | null > | null,
      updatedAt: string,
    } | null,
    roomId: string,
    type: MessageType,
    updatedAt: string,
  } | null,
};

export type UpdateNoteMutationVariables = {
  condition?: ModelNoteConditionInput | null,
  input: UpdateNoteInput,
};

export type UpdateNoteMutation = {
  updateNote?:  {
    __typename: "Note",
    content: string,
    createdAt?: string | null,
    entityId: string,
    entityType?: EntityType | null,
    noteItems?:  {
      __typename: "ModelNoteItemConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    parentId: string,
    parentType?: NoteParentType | null,
    pinnedState?: NotePinnedState | null,
    updatedAt: string,
  } | null,
};

export type UpdateNoteItemMutationVariables = {
  condition?: ModelNoteItemConditionInput | null,
  input: UpdateNoteItemInput,
};

export type UpdateNoteItemMutation = {
  updateNoteItem?:  {
    __typename: "NoteItem",
    content: string,
    createdAt: string,
    entityId: string,
    entityType?: EntityType | null,
    id: string,
    note?:  {
      __typename: "Note",
      content: string,
      createdAt?: string | null,
      entityId: string,
      entityType?: EntityType | null,
      owner: string,
      parentId: string,
      parentType?: NoteParentType | null,
      pinnedState?: NotePinnedState | null,
      updatedAt: string,
    } | null,
    noteOwner: string,
    owner?: string | null,
    parentId: string,
    parentType?: NoteItemParentType | null,
    timestamp: number,
    updatedAt: string,
  } | null,
};

export type UpdateNotificationLogMutationVariables = {
  condition?: ModelNotificationLogConditionInput | null,
  input: UpdateNotificationLogInput,
};

export type UpdateNotificationLogMutation = {
  updateNotificationLog?:  {
    __typename: "NotificationLog",
    challengeDayProgressId?: string | null,
    createdAt: string,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    id: string,
    meetup?:  {
      __typename: "Meetup",
      agenda: string,
      chatRoomId?: string | null,
      createdAt: string,
      duration: number,
      endTime: string,
      hostReferralId?: string | null,
      liveState: MeetupLiveState,
      owner?: string | null,
      recurrenceId?: string | null,
      recurrenceRule?: string | null,
      roomUrl?: string | null,
      rsvpCount?: number | null,
      slugId: string,
      startTime: string,
      title: string,
      updatedAt: string,
      version?: number | null,
      visibility: EntityVisibility,
    } | null,
    meetupSlugId?: string | null,
    name?: NotificationLogName | null,
    updatedAt: string,
  } | null,
};

export type UpdateOfferingMutationVariables = {
  condition?: ModelOfferingConditionInput | null,
  input: UpdateOfferingInput,
};

export type UpdateOfferingMutation = {
  updateOffering?:  {
    __typename: "Offering",
    createdAt: string,
    cta?: string | null,
    description?: string | null,
    heading?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    media?:  {
      __typename: "Asset",
      assetType: AssetType,
      createdAt: string,
      description?: string | null,
      entityId?: string | null,
      id: string,
      locator: string,
      offeringId?: string | null,
      title?: string | null,
      updatedAt: string,
    } | null,
    offeringStackOfferings?:  {
      __typename: "ModelOfferingStackConnection",
      nextToken?: string | null,
    } | null,
    offeringStackOrderBumps?:  {
      __typename: "ModelOfferingStackConnection",
      nextToken?: string | null,
    } | null,
    offeringStackUpsellOfferings?:  {
      __typename: "ModelOfferingStackUpsellConnection",
      nextToken?: string | null,
    } | null,
    overrides?:  {
      __typename: "OfferingOverrides",
      skipCreditCard?: boolean | null,
      trialDuration?: number | null,
      trialFrequency?: OfferingOverridesTrialFrequency | null,
    } | null,
    productBundle?:  {
      __typename: "ModelOfferingProductBundleConnection",
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOfferingProductConnection",
      nextToken?: string | null,
    } | null,
    readableTitle: string,
    redirectUrl?: string | null,
    shortDescription?: string | null,
    showGuarantee?: boolean | null,
    skipEmailCollectionStep?: boolean | null,
    step1Title?: string | null,
    step2Title?: string | null,
    type?: OfferingType | null,
    updatedAt: string,
  } | null,
};

export type UpdateOfferingProductMutationVariables = {
  condition?: ModelOfferingProductConditionInput | null,
  input: UpdateOfferingProductInput,
};

export type UpdateOfferingProductMutation = {
  updateOfferingProduct?:  {
    __typename: "OfferingProduct",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    updatedAt: string,
  } | null,
};

export type UpdateOfferingProductBundleMutationVariables = {
  condition?: ModelOfferingProductBundleConditionInput | null,
  input: UpdateOfferingProductBundleInput,
};

export type UpdateOfferingProductBundleMutation = {
  updateOfferingProductBundle?:  {
    __typename: "OfferingProductBundle",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    overrides?:  {
      __typename: "OfferingOverrides",
      skipCreditCard?: boolean | null,
      trialDuration?: number | null,
      trialFrequency?: OfferingOverridesTrialFrequency | null,
    } | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    readableTitle: string,
    updatedAt: string,
  } | null,
};

export type UpdateOfferingStackMutationVariables = {
  condition?: ModelOfferingStackConditionInput | null,
  input: UpdateOfferingStackInput,
};

export type UpdateOfferingStackMutation = {
  updateOfferingStack?:  {
    __typename: "OfferingStack",
    campaign?:  {
      __typename: "ModelCampaignConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    orderBump?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    orderBumpId?: string | null,
    readableTitle: string,
    updatedAt: string,
    upsell?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
  } | null,
};

export type UpdateOfferingStackUpsellMutationVariables = {
  condition?: ModelOfferingStackUpsellConditionInput | null,
  input: UpdateOfferingStackUpsellInput,
};

export type UpdateOfferingStackUpsellMutation = {
  updateOfferingStackUpsell?:  {
    __typename: "OfferingStackUpsell",
    createdAt: string,
    id: string,
    offering?:  {
      __typename: "Offering",
      createdAt: string,
      cta?: string | null,
      description?: string | null,
      heading?: string | null,
      id: string,
      readableTitle: string,
      redirectUrl?: string | null,
      shortDescription?: string | null,
      showGuarantee?: boolean | null,
      skipEmailCollectionStep?: boolean | null,
      step1Title?: string | null,
      step2Title?: string | null,
      type?: OfferingType | null,
      updatedAt: string,
    } | null,
    offeringId: string,
    offeringStack?:  {
      __typename: "OfferingStack",
      createdAt: string,
      id: string,
      offeringId: string,
      orderBumpId?: string | null,
      readableTitle: string,
      updatedAt: string,
    } | null,
    offeringStackId?: string | null,
    updatedAt: string,
    upsellNo?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellNoId?: string | null,
    upsellNoParent?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellYes?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
    upsellYesId?: string | null,
    upsellYesParent?:  {
      __typename: "OfferingStackUpsell",
      createdAt: string,
      id: string,
      offeringId: string,
      offeringStackId?: string | null,
      updatedAt: string,
      upsellNoId?: string | null,
      upsellYesId?: string | null,
    } | null,
  } | null,
};

export type UpdatePaymentMethodMutationVariables = {
  country?: string | null,
  email: string,
  paymentMethodId: string,
  postalCode?: string | null,
};

export type UpdatePaymentMethodMutation = {
  updatePaymentMethod?:  {
    __typename: "PaymentMethod",
    address?:  {
      __typename: "Address",
      city?: string | null,
      country?: string | null,
      line1?: string | null,
      line2?: string | null,
      state?: string | null,
      zip?: string | null,
    } | null,
    brand: string,
    expMonth: number,
    expYear: number,
    id: string,
    last4: string,
    name?: string | null,
  } | null,
};

export type UpdateProductMutationVariables = {
  condition?: ModelProductConditionInput | null,
  input: UpdateProductInput,
};

export type UpdateProductMutation = {
  updateProduct?:  {
    __typename: "Product",
    billingInterval?: ProductBillingInterval | null,
    businessUnit?: ProductBusinessUnit | null,
    createdAt: string,
    description?: string | null,
    entitlements?:  Array< {
      __typename: "EntitlementCustomType",
      identifier: string,
      revenueCatEntitlementId?: string | null,
    } | null > | null,
    id: string,
    name: string,
    offerings?:  {
      __typename: "ModelOfferingProductConnection",
      nextToken?: string | null,
    } | null,
    priceId?: string | null,
    productBundle?:  {
      __typename: "ModelOfferingProductBundleConnection",
      nextToken?: string | null,
    } | null,
    productCategory?: string | null,
    productId: string,
    productNamespace: string,
    store?: ProductStore | null,
    subscriptionGroup?: ProductSubscriptionGroup | null,
    updatedAt: string,
    userSubscriptions?:  {
      __typename: "ModelUserSubscriptionConnection",
      nextToken?: string | null,
    } | null,
    userTransactions?:  {
      __typename: "ModelUserTransactionConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateRecentlyPlayedMutationVariables = {
  condition?: ModelRecentlyPlayedConditionInput | null,
  input: UpdateRecentlyPlayedInput,
};

export type UpdateRecentlyPlayedMutation = {
  updateRecentlyPlayed?:  {
    __typename: "RecentlyPlayed",
    children?:  Array< {
      __typename: "RecentlyPlayedChild",
      completeTime?: string | null,
      entityId?: string | null,
      lastPlayedAt: string,
      playbackPercentage: number,
    } | null > | null,
    completeTime?: string | null,
    createdAt: string,
    entityId: string,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    lastPlayedAt: string,
    owner?: string | null,
    playbackPercentage: number,
    updatedAt: string,
  } | null,
};

export type UpdateReferralProfileMutationVariables = {
  paypalEmail?: string | null,
  referralCode?: string | null,
};

export type UpdateReferralProfileMutation = {
  updateReferralProfile?:  {
    __typename: "ReferralProfile",
    activeCustomersCount: number,
    cancellationsCount: number,
    clicksCount: number,
    customersCount: number,
    earnings: number,
    leadsCount: number,
    nextPayDay: string,
    paidEarnings: number,
    paypalEmail?: string | null,
    referralCode: string,
    refundsCount: number,
    remainingBalance: number,
  } | null,
};

export type UpdateSocialProofMutationVariables = {
  condition?: ModelSocialProofConditionInput | null,
  input: UpdateSocialProofInput,
};

export type UpdateSocialProofMutation = {
  updateSocialProof?:  {
    __typename: "SocialProof",
    commentsCount?: number | null,
    createdAt: string,
    dashboardCardItem?:  {
      __typename: "DashboardCardItem",
      assessmentType?: DashboardCardItemAssessmentType | null,
      createdAt: string,
      customPrompt?: string | null,
      date: string,
      entityHasEntitlements?: boolean | null,
      entityId?: string | null,
      id: string,
      nonEntitledEntityId?: string | null,
      order: number,
      type?: DashboardCardItemType | null,
      updatedAt: string,
    } | null,
    dashboardCardItemId?: string | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    entityLikes?:  {
      __typename: "ModelEntityLikeConnection",
      nextToken?: string | null,
    } | null,
    joinCount?: number | null,
    likesCount?: number | null,
    parentId: string,
    parentType?: SocialProofParentType | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    sharesCount?: number | null,
    updatedAt: string,
    version?: number | null,
    viewSessions?:  {
      __typename: "ModelActiveViewSessionConnection",
      nextToken?: string | null,
    } | null,
    viewerCount?: number | null,
  } | null,
};

export type UpdateTeamMutationVariables = {
  condition?: ModelTeamConditionInput | null,
  input: UpdateTeamInput,
};

export type UpdateTeamMutation = {
  updateTeam?:  {
    __typename: "Team",
    createdAt: string,
    id: string,
    invitationState?: TeamInvitationState | null,
    members?:  {
      __typename: "ModelTeamMemberConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    subscriptionId?: string | null,
    subscriptionItemId?: string | null,
    subscriptionState?: TeamSubscriptionState | null,
    totalSeats?: number | null,
    updatedAt: string,
    usedSeats?: number | null,
    version?: number | null,
  } | null,
};

export type UpdateTeamMemberMutationVariables = {
  condition?: ModelTeamMemberConditionInput | null,
  input: UpdateTeamMemberInput,
};

export type UpdateTeamMemberMutation = {
  updateTeamMember?:  {
    __typename: "TeamMember",
    createdAt: string,
    email?: string | null,
    firstName?: string | null,
    id: string,
    lastName?: string | null,
    owner: string,
    subscriptionState?: TeamSubscriptionState | null,
    team?:  {
      __typename: "Team",
      createdAt: string,
      id: string,
      invitationState?: TeamInvitationState | null,
      owner: string,
      stripePriceId?: string | null,
      stripeProductId?: string | null,
      subscriptionId?: string | null,
      subscriptionItemId?: string | null,
      subscriptionState?: TeamSubscriptionState | null,
      totalSeats?: number | null,
      updatedAt: string,
      usedSeats?: number | null,
      version?: number | null,
    } | null,
    teamId: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserExternalIdentifierMutationVariables = {
  condition?: ModelUserExternalIdentifierConditionInput | null,
  input: UpdateUserExternalIdentifierInput,
};

export type UpdateUserExternalIdentifierMutation = {
  updateUserExternalIdentifier?:  {
    __typename: "UserExternalIdentifier",
    createdAt: string,
    externalIdentifier: string,
    owner: string,
    type?: UserExternalIdentifierType | null,
    updatedAt: string,
  } | null,
};

export type UpdateUserProfileMutationVariables = {
  condition?: ModelUserProfileConditionInput | null,
  input: UpdateUserProfileInput,
};

export type UpdateUserProfileMutation = {
  updateUserProfile?:  {
    __typename: "UserProfile",
    activeViewSessions?:  {
      __typename: "ModelActiveViewSessionConnection",
      nextToken?: string | null,
    } | null,
    attributes?:  {
      __typename: "UserAttributes",
      intents?: Array< string | null > | null,
      surveyCustCategory?: UserAttributesSurveyCustCategory | null,
      surveyInterests?: Array< string | null > | null,
    } | null,
    badges?:  {
      __typename: "UserProfileBadges",
      chpc?: boolean | null,
      growthday?: boolean | null,
      ultra?: boolean | null,
    } | null,
    bio?: string | null,
    certificates?:  {
      __typename: "ModelCourseCertificateConnection",
      nextToken?: string | null,
    } | null,
    commentLikes?:  {
      __typename: "ModelCommentLikeConnection",
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    cover?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    createdAt?: string | null,
    displayName?: string | null,
    entityLikes?:  {
      __typename: "ModelEntityLikeConnection",
      nextToken?: string | null,
    } | null,
    experimentMetadata?:  {
      __typename: "UserProfileExperimentMetadata",
      mozartUser?: boolean | null,
    } | null,
    leaderboards?:  {
      __typename: "ModelLeaderboardConnection",
      nextToken?: string | null,
    } | null,
    meetups?:  {
      __typename: "ModelMeetupConnection",
      nextToken?: string | null,
    } | null,
    messages?:  {
      __typename: "ModelMessageConnection",
      nextToken?: string | null,
    } | null,
    notifications?:  {
      __typename: "ModelAppNotificationConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    profileImage?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    publicProfileId: string,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    socialMediaLinks?:  {
      __typename: "SocialMediaLinks",
      facebook?: string | null,
      instagram?: string | null,
      linkedin?: string | null,
      website?: string | null,
      x?: string | null,
    } | null,
    totalCoinsCount?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateUserSubscriptionMutationVariables = {
  condition?: ModelUserSubscriptionConditionInput | null,
  input: UpdateUserSubscriptionInput,
};

export type UpdateUserSubscriptionMutation = {
  updateUserSubscription?:  {
    __typename: "UserSubscription",
    createdAt: string,
    expirationDate?: string | null,
    id: string,
    owner?: string | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    purchaseDate?: string | null,
    renewalDate?: string | null,
    status?: UserSubscriptionStatus | null,
    subscriptionId: string,
    updatedAt: string,
    userTransactions?:  {
      __typename: "ModelUserTransactionConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateUserTourMutationVariables = {
  condition?: ModelUserTourConditionInput | null,
  input: UpdateUserTourInput,
};

export type UpdateUserTourMutation = {
  updateUserTour?:  {
    __typename: "UserTour",
    completed?: boolean | null,
    completedAt?: string | null,
    createdAt: string,
    id: string,
    owner: string,
    type: UserTourType,
    updatedAt: string,
  } | null,
};

export type UpdateUserTransactionMutationVariables = {
  condition?: ModelUserTransactionConditionInput | null,
  input: UpdateUserTransactionInput,
};

export type UpdateUserTransactionMutation = {
  updateUserTransaction?:  {
    __typename: "UserTransaction",
    createdAt: string,
    currency?: string | null,
    id: string,
    owner?: string | null,
    price?: number | null,
    product?:  {
      __typename: "Product",
      billingInterval?: ProductBillingInterval | null,
      businessUnit?: ProductBusinessUnit | null,
      createdAt: string,
      description?: string | null,
      id: string,
      name: string,
      priceId?: string | null,
      productCategory?: string | null,
      productId: string,
      productNamespace: string,
      store?: ProductStore | null,
      subscriptionGroup?: ProductSubscriptionGroup | null,
      updatedAt: string,
    } | null,
    productId: string,
    store: string,
    transactionDate: string,
    type?: UserTransactionType | null,
    updatedAt: string,
    userSubscription?:  {
      __typename: "UserSubscription",
      createdAt: string,
      expirationDate?: string | null,
      id: string,
      owner?: string | null,
      productId: string,
      purchaseDate?: string | null,
      renewalDate?: string | null,
      status?: UserSubscriptionStatus | null,
      subscriptionId: string,
      updatedAt: string,
    } | null,
    userSubscriptionId?: string | null,
  } | null,
};

export type VerifyIntentMutationVariables = {
  ids: Array< string >,
  types: Array< string >,
};

export type VerifyIntentMutation = {
  verifyIntent?:  {
    __typename: "PurchaseV2Result",
    entitlements?: Array< string | null > | null,
    isAuthenticated?: boolean | null,
    isFirstTimeTrialOnlyUser?: boolean | null,
    message?: string | null,
    paymentIntents?:  Array< {
      __typename: "StripeIntentResponse",
      clientSecret?: string | null,
      id?: string | null,
      type?: string | null,
    } | null > | null,
    requiresAction?: boolean | null,
    success: boolean,
    username?: string | null,
    uuid?: string | null,
  } | null,
};

export type OnCreateAppNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionAppNotificationFilterInput | null,
  owner?: string | null,
};

export type OnCreateAppNotificationSubscription = {
  onCreateAppNotification?:  {
    __typename: "AppNotification",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    content?: string | null,
    createdAt?: string | null,
    deeplink?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    notificationType: AppNotificationType,
    owner: string,
    sourceId: string,
    sourceType?: AppNotificationSourceType | null,
    status: AppNotificationStatus,
    title: string,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateBookmarkSubscriptionVariables = {
  filter?: ModelSubscriptionBookmarkFilterInput | null,
  owner?: string | null,
};

export type OnCreateBookmarkSubscription = {
  onCreateBookmark?:  {
    __typename: "Bookmark",
    createdAt?: string | null,
    entityType?: string | null,
    owner: string,
    parentId: string,
    parentType: string,
    updatedAt: string,
  } | null,
};

export type OnCreateChatRoomSubscriptionVariables = {
  filter?: ModelSubscriptionChatRoomFilterInput | null,
};

export type OnCreateChatRoomSubscription = {
  onCreateChatRoom?:  {
    __typename: "ChatRoom",
    bannedUsers?: Array< string | null > | null,
    createdAt?: string | null,
    entityId: string,
    id: string,
    messages?:  {
      __typename: "ModelMessageConnection",
      nextToken?: string | null,
    } | null,
    moderators?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type OnCreateCommentSubscriptionVariables = {
  filter?: ModelSubscriptionCommentFilterInput | null,
  owner?: string | null,
};

export type OnCreateCommentSubscription = {
  onCreateComment?:  {
    __typename: "Comment",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    commentsCount?: number | null,
    content: string,
    createdAt?: string | null,
    id: string,
    images?:  Array< {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null > | null,
    isEdited?: boolean | null,
    likes?:  {
      __typename: "ModelCommentLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount?: number | null,
    owner?: string | null,
    parent?:  {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null,
    parentId: string,
    parentType?: CommentParentType | null,
    pinnedState?: CommentPinnedState | null,
    replies?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    threadId: string,
    type?: CommentType | null,
    updatedAt: string,
    version?: number | null,
    visibility: CommentVisibility,
  } | null,
};

export type OnCreateDashboardStreakSubscriptionVariables = {
  filter?: ModelSubscriptionDashboardStreakFilterInput | null,
  owner?: string | null,
};

export type OnCreateDashboardStreakSubscription = {
  onCreateDashboardStreak?:  {
    __typename: "DashboardStreak",
    count: number,
    createdAt: string,
    id: string,
    lastActiveDate: string,
    leaderboards?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    startDate: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEntitySubscriptionVariables = {
  filter?: ModelSubscriptionEntityFilterInput | null,
};

export type OnCreateEntitySubscription = {
  onCreateEntity?:  {
    __typename: "Entity",
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    description?: string | null,
    duration?: number | null,
    enforceEntitlementsAt?: number | null,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    liveState?: EntityLiveState | null,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    order?: number | null,
    parent?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    parentId?: string | null,
    publishAt?: string | null,
    redirectId?: string | null,
    requiredEntitlements?: Array< string | null > | null,
    rootEntityId?: string | null,
    shareContent?:  {
      __typename: "EntityShareContent",
      description?: string | null,
      title?: string | null,
    } | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    startTime?: string | null,
    tags?: Array< string | null > | null,
    title: string,
    updatedAt: string,
    validUntil?: string | null,
    visibility: EntityVisibility,
  } | null,
};

export type OnCreateGrowthCoinStatsSubscriptionVariables = {
  filter?: ModelSubscriptionGrowthCoinStatsFilterInput | null,
  owner?: string | null,
};

export type OnCreateGrowthCoinStatsSubscription = {
  onCreateGrowthCoinStats?:  {
    __typename: "GrowthCoinStats",
    createdAt: string,
    currentMonth: string,
    monthCoins: number,
    owner: string,
    source: string,
    sourceEvent: string,
    totalCoins: number,
    updatedAt: string,
    version?: number | null,
  } | null,
};

export type OnCreateLeaderboardSubscriptionVariables = {
  filter?: ModelSubscriptionLeaderboardFilterInput | null,
  owner?: string | null,
};

export type OnCreateLeaderboardSubscription = {
  onCreateLeaderboard?:  {
    __typename: "Leaderboard",
    createdAt: string,
    dashboardStreaks?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    highestStreakCount: number,
    highestStreakCountAndTotalCoinsCount: string,
    month: string,
    owner: string,
    profile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    ranking?: number | null,
    totalCoinsCount: number,
    totalLeadsCount?: number | null,
    totalReferralsCount: number,
    totalReferralsCountAndTotalLeadsCount?: string | null,
    totalStreaksCount: number,
    updatedAt: string,
    userProfileId: string,
  } | null,
};

export type OnCreateMeetupSubscriptionVariables = {
  filter?: ModelSubscriptionMeetupFilterInput | null,
  owner?: string | null,
};

export type OnCreateMeetupSubscription = {
  onCreateMeetup?:  {
    __typename: "Meetup",
    agenda: string,
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    chatRoomId?: string | null,
    createdAt: string,
    duration: number,
    endTime: string,
    hostReferralId?: string | null,
    liveState: MeetupLiveState,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    recurrenceId?: string | null,
    recurrenceRule?: string | null,
    roomUrl?: string | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    slugId: string,
    startTime: string,
    thumbnail?:  {
      __typename: "MeetupThumbnail",
      height?: number | null,
      url: string,
      width?: number | null,
    } | null,
    title: string,
    updatedAt: string,
    version?: number | null,
    visibility: EntityVisibility,
  } | null,
};

export type OnCreateMessageSubscriptionVariables = {
  filter?: ModelSubscriptionMessageFilterInput | null,
  owner?: string | null,
};

export type OnCreateMessageSubscription = {
  onCreateMessage?:  {
    __typename: "Message",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    content: string,
    createdAt?: string | null,
    id: string,
    isEdited?: boolean | null,
    mediaPosition: number,
    metadata?: string | null,
    owner?: string | null,
    pinnedState?: MessagePinnedState | null,
    room?:  {
      __typename: "ChatRoom",
      bannedUsers?: Array< string | null > | null,
      createdAt?: string | null,
      entityId: string,
      id: string,
      moderators?: Array< string | null > | null,
      updatedAt: string,
    } | null,
    roomId: string,
    type: MessageType,
    updatedAt: string,
  } | null,
};

export type OnCreateRecentlyPlayedSubscriptionVariables = {
  filter?: ModelSubscriptionRecentlyPlayedFilterInput | null,
  owner?: string | null,
};

export type OnCreateRecentlyPlayedSubscription = {
  onCreateRecentlyPlayed?:  {
    __typename: "RecentlyPlayed",
    children?:  Array< {
      __typename: "RecentlyPlayedChild",
      completeTime?: string | null,
      entityId?: string | null,
      lastPlayedAt: string,
      playbackPercentage: number,
    } | null > | null,
    completeTime?: string | null,
    createdAt: string,
    entityId: string,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    lastPlayedAt: string,
    owner?: string | null,
    playbackPercentage: number,
    updatedAt: string,
  } | null,
};

export type OnCreateSocialProofSubscriptionVariables = {
  filter?: ModelSubscriptionSocialProofFilterInput | null,
};

export type OnCreateSocialProofSubscription = {
  onCreateSocialProof?:  {
    __typename: "SocialProof",
    commentsCount?: number | null,
    createdAt: string,
    dashboardCardItem?:  {
      __typename: "DashboardCardItem",
      assessmentType?: DashboardCardItemAssessmentType | null,
      createdAt: string,
      customPrompt?: string | null,
      date: string,
      entityHasEntitlements?: boolean | null,
      entityId?: string | null,
      id: string,
      nonEntitledEntityId?: string | null,
      order: number,
      type?: DashboardCardItemType | null,
      updatedAt: string,
    } | null,
    dashboardCardItemId?: string | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    entityLikes?:  {
      __typename: "ModelEntityLikeConnection",
      nextToken?: string | null,
    } | null,
    joinCount?: number | null,
    likesCount?: number | null,
    parentId: string,
    parentType?: SocialProofParentType | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    sharesCount?: number | null,
    updatedAt: string,
    version?: number | null,
    viewSessions?:  {
      __typename: "ModelActiveViewSessionConnection",
      nextToken?: string | null,
    } | null,
    viewerCount?: number | null,
  } | null,
};

export type OnCreateTeamMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTeamMemberFilterInput | null,
  owner?: string | null,
};

export type OnCreateTeamMemberSubscription = {
  onCreateTeamMember?:  {
    __typename: "TeamMember",
    createdAt: string,
    email?: string | null,
    firstName?: string | null,
    id: string,
    lastName?: string | null,
    owner: string,
    subscriptionState?: TeamSubscriptionState | null,
    team?:  {
      __typename: "Team",
      createdAt: string,
      id: string,
      invitationState?: TeamInvitationState | null,
      owner: string,
      stripePriceId?: string | null,
      stripeProductId?: string | null,
      subscriptionId?: string | null,
      subscriptionItemId?: string | null,
      subscriptionState?: TeamSubscriptionState | null,
      totalSeats?: number | null,
      updatedAt: string,
      usedSeats?: number | null,
      version?: number | null,
    } | null,
    teamId: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBookmarkSubscriptionVariables = {
  filter?: ModelSubscriptionBookmarkFilterInput | null,
  owner?: string | null,
};

export type OnDeleteBookmarkSubscription = {
  onDeleteBookmark?:  {
    __typename: "Bookmark",
    createdAt?: string | null,
    entityType?: string | null,
    owner: string,
    parentId: string,
    parentType: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCommentSubscriptionVariables = {
  filter?: ModelSubscriptionCommentFilterInput | null,
  owner?: string | null,
};

export type OnDeleteCommentSubscription = {
  onDeleteComment?:  {
    __typename: "Comment",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    commentsCount?: number | null,
    content: string,
    createdAt?: string | null,
    id: string,
    images?:  Array< {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null > | null,
    isEdited?: boolean | null,
    likes?:  {
      __typename: "ModelCommentLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount?: number | null,
    owner?: string | null,
    parent?:  {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null,
    parentId: string,
    parentType?: CommentParentType | null,
    pinnedState?: CommentPinnedState | null,
    replies?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    threadId: string,
    type?: CommentType | null,
    updatedAt: string,
    version?: number | null,
    visibility: CommentVisibility,
  } | null,
};

export type OnDeleteDashboardStreakSubscriptionVariables = {
  filter?: ModelSubscriptionDashboardStreakFilterInput | null,
  owner?: string | null,
};

export type OnDeleteDashboardStreakSubscription = {
  onDeleteDashboardStreak?:  {
    __typename: "DashboardStreak",
    count: number,
    createdAt: string,
    id: string,
    lastActiveDate: string,
    leaderboards?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    startDate: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEntitySubscriptionVariables = {
  filter?: ModelSubscriptionEntityFilterInput | null,
};

export type OnDeleteEntitySubscription = {
  onDeleteEntity?:  {
    __typename: "Entity",
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    description?: string | null,
    duration?: number | null,
    enforceEntitlementsAt?: number | null,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    liveState?: EntityLiveState | null,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    order?: number | null,
    parent?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    parentId?: string | null,
    publishAt?: string | null,
    redirectId?: string | null,
    requiredEntitlements?: Array< string | null > | null,
    rootEntityId?: string | null,
    shareContent?:  {
      __typename: "EntityShareContent",
      description?: string | null,
      title?: string | null,
    } | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    startTime?: string | null,
    tags?: Array< string | null > | null,
    title: string,
    updatedAt: string,
    validUntil?: string | null,
    visibility: EntityVisibility,
  } | null,
};

export type OnDeleteGrowthCoinStatsSubscriptionVariables = {
  filter?: ModelSubscriptionGrowthCoinStatsFilterInput | null,
  owner?: string | null,
};

export type OnDeleteGrowthCoinStatsSubscription = {
  onDeleteGrowthCoinStats?:  {
    __typename: "GrowthCoinStats",
    createdAt: string,
    currentMonth: string,
    monthCoins: number,
    owner: string,
    source: string,
    sourceEvent: string,
    totalCoins: number,
    updatedAt: string,
    version?: number | null,
  } | null,
};

export type OnDeleteLeaderboardSubscriptionVariables = {
  filter?: ModelSubscriptionLeaderboardFilterInput | null,
  owner?: string | null,
};

export type OnDeleteLeaderboardSubscription = {
  onDeleteLeaderboard?:  {
    __typename: "Leaderboard",
    createdAt: string,
    dashboardStreaks?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    highestStreakCount: number,
    highestStreakCountAndTotalCoinsCount: string,
    month: string,
    owner: string,
    profile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    ranking?: number | null,
    totalCoinsCount: number,
    totalLeadsCount?: number | null,
    totalReferralsCount: number,
    totalReferralsCountAndTotalLeadsCount?: string | null,
    totalStreaksCount: number,
    updatedAt: string,
    userProfileId: string,
  } | null,
};

export type OnDeleteMeetupSubscriptionVariables = {
  filter?: ModelSubscriptionMeetupFilterInput | null,
  owner?: string | null,
};

export type OnDeleteMeetupSubscription = {
  onDeleteMeetup?:  {
    __typename: "Meetup",
    agenda: string,
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    chatRoomId?: string | null,
    createdAt: string,
    duration: number,
    endTime: string,
    hostReferralId?: string | null,
    liveState: MeetupLiveState,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    recurrenceId?: string | null,
    recurrenceRule?: string | null,
    roomUrl?: string | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    slugId: string,
    startTime: string,
    thumbnail?:  {
      __typename: "MeetupThumbnail",
      height?: number | null,
      url: string,
      width?: number | null,
    } | null,
    title: string,
    updatedAt: string,
    version?: number | null,
    visibility: EntityVisibility,
  } | null,
};

export type OnDeleteMessageSubscriptionVariables = {
  filter?: ModelSubscriptionMessageFilterInput | null,
  owner?: string | null,
};

export type OnDeleteMessageSubscription = {
  onDeleteMessage?:  {
    __typename: "Message",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    content: string,
    createdAt?: string | null,
    id: string,
    isEdited?: boolean | null,
    mediaPosition: number,
    metadata?: string | null,
    owner?: string | null,
    pinnedState?: MessagePinnedState | null,
    room?:  {
      __typename: "ChatRoom",
      bannedUsers?: Array< string | null > | null,
      createdAt?: string | null,
      entityId: string,
      id: string,
      moderators?: Array< string | null > | null,
      updatedAt: string,
    } | null,
    roomId: string,
    type: MessageType,
    updatedAt: string,
  } | null,
};

export type OnDeleteRecentlyPlayedSubscriptionVariables = {
  filter?: ModelSubscriptionRecentlyPlayedFilterInput | null,
  owner?: string | null,
};

export type OnDeleteRecentlyPlayedSubscription = {
  onDeleteRecentlyPlayed?:  {
    __typename: "RecentlyPlayed",
    children?:  Array< {
      __typename: "RecentlyPlayedChild",
      completeTime?: string | null,
      entityId?: string | null,
      lastPlayedAt: string,
      playbackPercentage: number,
    } | null > | null,
    completeTime?: string | null,
    createdAt: string,
    entityId: string,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    lastPlayedAt: string,
    owner?: string | null,
    playbackPercentage: number,
    updatedAt: string,
  } | null,
};

export type OnDeleteTeamMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTeamMemberFilterInput | null,
  owner?: string | null,
};

export type OnDeleteTeamMemberSubscription = {
  onDeleteTeamMember?:  {
    __typename: "TeamMember",
    createdAt: string,
    email?: string | null,
    firstName?: string | null,
    id: string,
    lastName?: string | null,
    owner: string,
    subscriptionState?: TeamSubscriptionState | null,
    team?:  {
      __typename: "Team",
      createdAt: string,
      id: string,
      invitationState?: TeamInvitationState | null,
      owner: string,
      stripePriceId?: string | null,
      stripeProductId?: string | null,
      subscriptionId?: string | null,
      subscriptionItemId?: string | null,
      subscriptionState?: TeamSubscriptionState | null,
      totalSeats?: number | null,
      updatedAt: string,
      usedSeats?: number | null,
      version?: number | null,
    } | null,
    teamId: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAppNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionAppNotificationFilterInput | null,
  owner?: string | null,
};

export type OnUpdateAppNotificationSubscription = {
  onUpdateAppNotification?:  {
    __typename: "AppNotification",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    content?: string | null,
    createdAt?: string | null,
    deeplink?: string | null,
    id: string,
    image?:  {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null,
    notificationType: AppNotificationType,
    owner: string,
    sourceId: string,
    sourceType?: AppNotificationSourceType | null,
    status: AppNotificationStatus,
    title: string,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateBookmarkSubscriptionVariables = {
  filter?: ModelSubscriptionBookmarkFilterInput | null,
  owner?: string | null,
};

export type OnUpdateBookmarkSubscription = {
  onUpdateBookmark?:  {
    __typename: "Bookmark",
    createdAt?: string | null,
    entityType?: string | null,
    owner: string,
    parentId: string,
    parentType: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateChatRoomSubscriptionVariables = {
  filter?: ModelSubscriptionChatRoomFilterInput | null,
};

export type OnUpdateChatRoomSubscription = {
  onUpdateChatRoom?:  {
    __typename: "ChatRoom",
    bannedUsers?: Array< string | null > | null,
    createdAt?: string | null,
    entityId: string,
    id: string,
    messages?:  {
      __typename: "ModelMessageConnection",
      nextToken?: string | null,
    } | null,
    moderators?: Array< string | null > | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateCommentSubscriptionVariables = {
  filter?: ModelSubscriptionCommentFilterInput | null,
  owner?: string | null,
};

export type OnUpdateCommentSubscription = {
  onUpdateComment?:  {
    __typename: "Comment",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    commentsCount?: number | null,
    content: string,
    createdAt?: string | null,
    id: string,
    images?:  Array< {
      __typename: "CdnImage",
      cdnId?: string | null,
      height?: number | null,
      url?: string | null,
      width?: number | null,
    } | null > | null,
    isEdited?: boolean | null,
    likes?:  {
      __typename: "ModelCommentLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount?: number | null,
    owner?: string | null,
    parent?:  {
      __typename: "Comment",
      commentsCount?: number | null,
      content: string,
      createdAt?: string | null,
      id: string,
      isEdited?: boolean | null,
      likesCount?: number | null,
      owner?: string | null,
      parentId: string,
      parentType?: CommentParentType | null,
      pinnedState?: CommentPinnedState | null,
      threadId: string,
      type?: CommentType | null,
      updatedAt: string,
      version?: number | null,
      visibility: CommentVisibility,
    } | null,
    parentId: string,
    parentType?: CommentParentType | null,
    pinnedState?: CommentPinnedState | null,
    replies?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    threadId: string,
    type?: CommentType | null,
    updatedAt: string,
    version?: number | null,
    visibility: CommentVisibility,
  } | null,
};

export type OnUpdateDashboardStreakSubscriptionVariables = {
  filter?: ModelSubscriptionDashboardStreakFilterInput | null,
  owner?: string | null,
};

export type OnUpdateDashboardStreakSubscription = {
  onUpdateDashboardStreak?:  {
    __typename: "DashboardStreak",
    count: number,
    createdAt: string,
    id: string,
    lastActiveDate: string,
    leaderboards?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    owner: string,
    startDate: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEntitySubscriptionVariables = {
  filter?: ModelSubscriptionEntityFilterInput | null,
};

export type OnUpdateEntitySubscription = {
  onUpdateEntity?:  {
    __typename: "Entity",
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    description?: string | null,
    duration?: number | null,
    enforceEntitlementsAt?: number | null,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    liveState?: EntityLiveState | null,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    order?: number | null,
    parent?:  {
      __typename: "EntityRelations",
      childId: string,
      createdAt: string,
      id: string,
      updatedAt: string,
    } | null,
    parentId?: string | null,
    publishAt?: string | null,
    redirectId?: string | null,
    requiredEntitlements?: Array< string | null > | null,
    rootEntityId?: string | null,
    shareContent?:  {
      __typename: "EntityShareContent",
      description?: string | null,
      title?: string | null,
    } | null,
    socialProof?:  {
      __typename: "SocialProof",
      commentsCount?: number | null,
      createdAt: string,
      dashboardCardItemId?: string | null,
      entityId?: string | null,
      joinCount?: number | null,
      likesCount?: number | null,
      parentId: string,
      parentType?: SocialProofParentType | null,
      rsvpCount?: number | null,
      sharesCount?: number | null,
      updatedAt: string,
      version?: number | null,
      viewerCount?: number | null,
    } | null,
    startTime?: string | null,
    tags?: Array< string | null > | null,
    title: string,
    updatedAt: string,
    validUntil?: string | null,
    visibility: EntityVisibility,
  } | null,
};

export type OnUpdateGrowthCoinStatsSubscriptionVariables = {
  filter?: ModelSubscriptionGrowthCoinStatsFilterInput | null,
  owner?: string | null,
};

export type OnUpdateGrowthCoinStatsSubscription = {
  onUpdateGrowthCoinStats?:  {
    __typename: "GrowthCoinStats",
    createdAt: string,
    currentMonth: string,
    monthCoins: number,
    owner: string,
    source: string,
    sourceEvent: string,
    totalCoins: number,
    updatedAt: string,
    version?: number | null,
  } | null,
};

export type OnUpdateLeaderboardSubscriptionVariables = {
  filter?: ModelSubscriptionLeaderboardFilterInput | null,
  owner?: string | null,
};

export type OnUpdateLeaderboardSubscription = {
  onUpdateLeaderboard?:  {
    __typename: "Leaderboard",
    createdAt: string,
    dashboardStreaks?:  {
      __typename: "ModelLeaderboardDashboardStreakConnection",
      nextToken?: string | null,
    } | null,
    highestStreakCount: number,
    highestStreakCountAndTotalCoinsCount: string,
    month: string,
    owner: string,
    profile?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    ranking?: number | null,
    totalCoinsCount: number,
    totalLeadsCount?: number | null,
    totalReferralsCount: number,
    totalReferralsCountAndTotalLeadsCount?: string | null,
    totalStreaksCount: number,
    updatedAt: string,
    userProfileId: string,
  } | null,
};

export type OnUpdateMeetupSubscriptionVariables = {
  filter?: ModelSubscriptionMeetupFilterInput | null,
  owner?: string | null,
};

export type OnUpdateMeetupSubscription = {
  onUpdateMeetup?:  {
    __typename: "Meetup",
    agenda: string,
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    chatRoomId?: string | null,
    createdAt: string,
    duration: number,
    endTime: string,
    hostReferralId?: string | null,
    liveState: MeetupLiveState,
    notificationLogs?:  {
      __typename: "ModelNotificationLogConnection",
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    recurrenceId?: string | null,
    recurrenceRule?: string | null,
    roomUrl?: string | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    slugId: string,
    startTime: string,
    thumbnail?:  {
      __typename: "MeetupThumbnail",
      height?: number | null,
      url: string,
      width?: number | null,
    } | null,
    title: string,
    updatedAt: string,
    version?: number | null,
    visibility: EntityVisibility,
  } | null,
};

export type OnUpdateMessageSubscriptionVariables = {
  filter?: ModelSubscriptionMessageFilterInput | null,
  owner?: string | null,
};

export type OnUpdateMessageSubscription = {
  onUpdateMessage?:  {
    __typename: "Message",
    author?:  {
      __typename: "UserProfile",
      bio?: string | null,
      createdAt?: string | null,
      displayName?: string | null,
      owner: string,
      publicProfileId: string,
      totalCoinsCount?: number | null,
      updatedAt: string,
    } | null,
    content: string,
    createdAt?: string | null,
    id: string,
    isEdited?: boolean | null,
    mediaPosition: number,
    metadata?: string | null,
    owner?: string | null,
    pinnedState?: MessagePinnedState | null,
    room?:  {
      __typename: "ChatRoom",
      bannedUsers?: Array< string | null > | null,
      createdAt?: string | null,
      entityId: string,
      id: string,
      moderators?: Array< string | null > | null,
      updatedAt: string,
    } | null,
    roomId: string,
    type: MessageType,
    updatedAt: string,
  } | null,
};

export type OnUpdateRecentlyPlayedSubscriptionVariables = {
  filter?: ModelSubscriptionRecentlyPlayedFilterInput | null,
  owner?: string | null,
};

export type OnUpdateRecentlyPlayedSubscription = {
  onUpdateRecentlyPlayed?:  {
    __typename: "RecentlyPlayed",
    children?:  Array< {
      __typename: "RecentlyPlayedChild",
      completeTime?: string | null,
      entityId?: string | null,
      lastPlayedAt: string,
      playbackPercentage: number,
    } | null > | null,
    completeTime?: string | null,
    createdAt: string,
    entityId: string,
    entityType: EntityType,
    id: string,
    images?:  Array< {
      __typename: "EntityImage",
      height?: number | null,
      imageType: EntityImageType,
      url: string,
      width?: number | null,
    } | null > | null,
    lastPlayedAt: string,
    owner?: string | null,
    playbackPercentage: number,
    updatedAt: string,
  } | null,
};

export type OnUpdateSocialProofSubscriptionVariables = {
  filter?: ModelSubscriptionSocialProofFilterInput | null,
};

export type OnUpdateSocialProofSubscription = {
  onUpdateSocialProof?:  {
    __typename: "SocialProof",
    commentsCount?: number | null,
    createdAt: string,
    dashboardCardItem?:  {
      __typename: "DashboardCardItem",
      assessmentType?: DashboardCardItemAssessmentType | null,
      createdAt: string,
      customPrompt?: string | null,
      date: string,
      entityHasEntitlements?: boolean | null,
      entityId?: string | null,
      id: string,
      nonEntitledEntityId?: string | null,
      order: number,
      type?: DashboardCardItemType | null,
      updatedAt: string,
    } | null,
    dashboardCardItemId?: string | null,
    entity?:  {
      __typename: "Entity",
      createdAt: string,
      description?: string | null,
      duration?: number | null,
      enforceEntitlementsAt?: number | null,
      entityType: EntityType,
      id: string,
      liveState?: EntityLiveState | null,
      order?: number | null,
      parentId?: string | null,
      publishAt?: string | null,
      redirectId?: string | null,
      requiredEntitlements?: Array< string | null > | null,
      rootEntityId?: string | null,
      startTime?: string | null,
      tags?: Array< string | null > | null,
      title: string,
      updatedAt: string,
      validUntil?: string | null,
      visibility: EntityVisibility,
    } | null,
    entityId?: string | null,
    entityLikes?:  {
      __typename: "ModelEntityLikeConnection",
      nextToken?: string | null,
    } | null,
    joinCount?: number | null,
    likesCount?: number | null,
    parentId: string,
    parentType?: SocialProofParentType | null,
    rsvpCount?: number | null,
    rsvps?:  {
      __typename: "ModelEventRsvpConnection",
      nextToken?: string | null,
    } | null,
    sharesCount?: number | null,
    updatedAt: string,
    version?: number | null,
    viewSessions?:  {
      __typename: "ModelActiveViewSessionConnection",
      nextToken?: string | null,
    } | null,
    viewerCount?: number | null,
  } | null,
};

export type OnUpdateTeamMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTeamMemberFilterInput | null,
  owner?: string | null,
};

export type OnUpdateTeamMemberSubscription = {
  onUpdateTeamMember?:  {
    __typename: "TeamMember",
    createdAt: string,
    email?: string | null,
    firstName?: string | null,
    id: string,
    lastName?: string | null,
    owner: string,
    subscriptionState?: TeamSubscriptionState | null,
    team?:  {
      __typename: "Team",
      createdAt: string,
      id: string,
      invitationState?: TeamInvitationState | null,
      owner: string,
      stripePriceId?: string | null,
      stripeProductId?: string | null,
      subscriptionId?: string | null,
      subscriptionItemId?: string | null,
      subscriptionState?: TeamSubscriptionState | null,
      totalSeats?: number | null,
      updatedAt: string,
      usedSeats?: number | null,
      version?: number | null,
    } | null,
    teamId: string,
    updatedAt: string,
  } | null,
};
